import { createCollectDiagnosticsBroadcastSender } from "./packlets/diagnostics/diagnostics-broadcast.mjs";
import { t as __decorate } from "./chunk-decorate.mjs";
import * as Effect from "effect/Effect";
import * as EffectStream from "effect/Stream";
import { AsyncTask, DeferredTask, Event, Mutex, PushStream, SubscriptionList, TimeoutError, Trigger, UpdateScheduler, asyncTimeout, runInContext, scheduleMicroTask, scheduleTask, scheduleTaskInterval, sleep, sleepWithContext, synchronized, trackLeaks } from "@dxos/async";
import { Context, ContextDisposedError, LifecycleState, Resource, cancelWithContext, rejectOnDispose } from "@dxos/context";
import { Stream } from "@dxos/codec-protobuf/stream";
import { FeedFactoryLayer, FeedIterator, FeedSetIterator, FeedStorageDirectoryService, FeedStoreLayer, FeedStoreService, writeMessages } from "@dxos/feed-store";
import { DXN, PublicKey, SpaceId, URI } from "@dxos/keys";
import { log, logInfo } from "@dxos/log";
import { Callback, CallbackCollection, ComplexMap, ComplexSet, arrayToBuffer, bufferToArray, createFilename, defaultMap, deferFunction, entry, forEachAsync, isNode, isNonNullable, isTauri, jsonKeyReplacer, numericalValues, rangeFromTo, tracer } from "@dxos/util";
import { getFirstStreamValue } from "@dxos/codec-protobuf";
import { CredentialGenerator, DeviceStateMachine, ProfileStateMachine, SpaceStateMachine, checkCredentialType, createAdmissionCredentials, createCancelDelegatedSpaceInvitationCredential, createCredential, createCredentialSignerWithChain, createCredentialSignerWithKey, createDelegatedSpaceInvitationCredential, createDidFromIdentityKey, credentialTypeFilter, generatePasscode, generateSeedPhrase, getCredentialAssertion, keyPairFromSeedPhrase, signPresentation, verifyCredential } from "@dxos/credentials";
import { InvariantViolation, assertArgument, assertState, failedInvariant, invariant } from "@dxos/invariant";
import { AlreadyJoinedError, ApiError, AuthorizationError, CancelledError, DataCorruptionError, EdgeAgentStatus, EdgeAuthChallengeError, EdgeCallFailedError, EdgeService, FEED_ARCHIVE_BLOCKS_PER_CHUNK, FeedProtocol, IdentityNotInitializedError, InvalidInvitationError, InvalidInvitationExtensionRoleError, InvalidStorageVersionError, ProtocolError, STORAGE_VERSION, SpaceArchiveFileStructure, SpaceArchiveVersion, SpaceNotFoundError, SystemError, encodeError, makeInProcessClient } from "@dxos/protocols";
import { CreateEpochRequest, Device, DeviceKind, EdgeStatus, GetDiagnosticsRequest, Invitation, Platform, QueryAgentStatusResponse, QueryInvitationsResponse, QueryLogsRequest, SpaceArchive, SpaceMember, SpaceState, SystemStatus } from "@dxos/protocols/proto/dxos/client/services";
import { schema } from "@dxos/protocols/proto";
import { AUTHENTICATION_CODE_LENGTH, AUTH_TIMEOUT, AuthenticatingInvitation, CancellableInvitation, INVITATION_TIMEOUT, LOAD_CONTROL_FEEDS_TIMEOUT, SpaceProperties, getExpirationTime, makeInProcessClientServicesRpc, makeServicesFromRpc } from "@dxos/client-protocol";
import { AdmittedFeed, DeviceType, MembershipPolicy, SpaceMember as SpaceMember$1 } from "@dxos/protocols/proto/dxos/halo/credentials";
import { trace } from "@dxos/tracing";
import { interpretAsDocumentId, parseAutomergeUrl } from "@automerge/automerge-repo";
import * as EffectContext from "effect/Context";
import * as Layer from "effect/Layer";
import * as Option from "effect/Option";
import { Type } from "@dxos/echo";
import { DatabaseRoot, EchoEdgeReplicatorLayer, EchoEdgeSubductionReplicatorLayer, EchoHostLayer, EchoHostService, EdgeAutomergeReplicatorService, MeshEchoReplicatorLayer, MeshEchoReplicatorService, findInlineObjectOfType, runSqliteHealthCheck } from "@dxos/echo-host";
import { SpaceDocVersion, createIdFromSpaceKey } from "@dxos/echo-protocol";
import { EdgeClient, EdgeConnectionClosedError, EdgeConnectionService, EdgeHttpClient, EdgeHttpClientService, EdgeIdentityChangedError, MessageSchema, createChainEdgeIdentity, createEphemeralEdgeIdentity, createStubEdgeIdentity } from "@dxos/edge-client";
import { KeyringApiService, SqliteKeyring, SqliteKeyringLayer } from "@dxos/keyring";
import { EdgeReplicationSetting } from "@dxos/protocols/proto/dxos/echo/metadata";
import { Gossip, Presence } from "@dxos/teleport-extension-gossip";
import { createKeyPair, randomBytes, sign, verify } from "@dxos/crypto";
import { MMSTTopology, SwarmNetworkManager, SwarmNetworkManagerService, createIceProvider, createRtcTransportFactory, createTeleportProtocolFactory } from "@dxos/network-manager";
import { AuthenticationResponse, InvitationOptions } from "@dxos/protocols/proto/dxos/halo/invitations";
import { RpcExtension, Teleport } from "@dxos/teleport";
import CRC32 from "crc-32";
import * as SqlClient from "@effect/sql/SqlClient";
import { EffectEx, RuntimeProvider } from "@dxos/effect";
import { Timeframe } from "@dxos/timeframe";
import { failUndefined, raise, timed, warnAfterTimeout } from "@dxos/debug";
import { createCodecEncoding } from "@dxos/hypercore";
import { BlobStoreApiService, BlobSync, SqliteBlobStore, SqliteBlobStoreLayer } from "@dxos/teleport-extension-object-sync";
import { ReplicatorExtension } from "@dxos/teleport-extension-replicator";
import { save } from "@automerge/automerge";
import { Encoder, decode, encode } from "cbor-x";
import { buf, createBuf } from "@dxos/protocols/buf";
import { MessageSchema as MessageSchema$1 } from "@dxos/protocols/buf/dxos/edge/messenger_pb";
import { ContactsService, DataService, DevicesService, EdgeAgentService, FeedService, IdentityService, InvitationsService, NetworkService, QueryService, SpacesService } from "@dxos/protocols/rpc";
import * as Exit from "effect/Exit";
import * as Scope from "effect/Scope";
import platform from "platform";
import { EdgeSignalManager, MemorySignalManager, MemorySignalManagerContext, SignalManagerService } from "@dxos/messaging";
import * as ManagedRuntime from "effect/ManagedRuntime";
import * as Runtime from "effect/Runtime";
import { resolveTelemetryTag } from "@dxos/config";
import * as SqlExport from "@dxos/sql-sqlite/SqlExport";
import * as Schema from "effect/Schema";
import { SyncClient } from "@dxos/feed";
import { Directory, StorageType, wrapFile } from "@dxos/random-access-storage";
//#region \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
		key = keys[i];
		if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: ((k) => from[k]).bind(null, key),
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
//#endregion
//#region src/packlets/devtools/feeds.ts
var __dxlog_file$48 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/devtools/feeds.ts";
var subscribeToFeeds = ({ feedStore, spaceManager }, { feedKeys }) => {
	return new Stream(({ next }) => {
		const subscriptions = new SubscriptionList();
		const feedMap = new ComplexMap(PublicKey.hash);
		const update = () => {
			const { feeds } = feedStore;
			feeds.filter((feed) => !feedKeys?.length || feedKeys.some((feedKey) => feedKey.equals(feed.key))).forEach((feed) => {
				if (!feedMap.has(feed.key)) {
					feedMap.set(feed.key, { feed });
					feed.on("close", update);
					subscriptions.add(() => feed.off("close", update));
				}
				if (!feedMap.get(feed.key)?.owner) feedMap.get(feed.key).owner = findFeedOwner(spaceManager, feed.key);
			});
			next({ feeds: Array.from(feedMap.values()).map(({ feed, owner }) => ({
				feedKey: feed.key,
				length: feed.properties.length,
				bytes: feed.core.byteLength,
				downloaded: feed.core.bitfield?.data.toBuffer() ?? /* @__PURE__ */ new Uint8Array(),
				owner
			})) });
		};
		subscriptions.add(feedStore.feedOpened.on(update));
		update();
		return () => {
			subscriptions.clear();
		};
	});
};
var findFeedOwner = (spaceManager, feedKey) => {
	const feedInfo = [...spaceManager.spaces.values()].flatMap((space) => [...space.spaceState.feeds.values()]).find((feed) => feed.key.equals(feedKey));
	log("feeds", {
		feedInfo,
		key: feedKey.truncate(),
		allSpaces: spaceManager.spaces.size
	}, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$48,
		L: 76,
		S: void 0
	});
	if (!feedInfo) return;
	return {
		identity: feedInfo.assertion.identityKey,
		device: feedInfo.assertion.deviceKey
	};
};
var subscribeToFeedBlocks = ({ feedStore }, { feedKey, maxBlocks = 10 }) => {
	return new Stream(({ next }) => {
		if (!feedKey) return;
		const subscriptions = new SubscriptionList();
		const timeout = setTimeout(async () => {
			const feed = feedStore.getFeed(feedKey);
			if (!feed) return;
			const update = async () => {
				if (!feed.properties.length) {
					next({ blocks: [] });
					return;
				}
				const iterator = new FeedIterator(feed);
				await iterator.open();
				const blocks = [];
				for await (const block of iterator) {
					blocks.push(block);
					if (blocks.length >= feed.properties.length) break;
				}
				next({ blocks: blocks.slice(-maxBlocks) });
				await iterator.close();
			};
			feed.on("append", update);
			subscriptions.add(() => feed.off("append", update));
			feed.on("truncate", update);
			subscriptions.add(() => feed.off("truncate", update));
			await update();
		});
		return () => {
			subscriptions.clear();
			clearTimeout(timeout);
		};
	});
};
//#endregion
//#region src/packlets/devtools/keys.ts
var subscribeToKeyringKeys = ({ keyring }) => new Stream(({ next, ctx }) => {
	const update = async () => {
		next({ keys: await keyring.list() });
	};
	keyring.keysUpdate.on(ctx, update);
	scheduleTask(ctx, update);
});
//#endregion
//#region src/packlets/devtools/metadata.ts
var subscribeToMetadata = ({ context }) => new Stream(({ next, ctx }) => {
	context.metadataStore.update.on(ctx, (data) => next({ metadata: data }));
	next({ metadata: context.metadataStore.metadata });
});
//#endregion
//#region src/packlets/devtools/network.ts
var __dxlog_file$47 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/devtools/network.ts";
var subscribeToNetworkStatus = ({ signalManager }) => new Stream(({ next, close }) => {
	const update = () => {
		try {
			const status = signalManager.getStatus?.();
			next({ servers: status });
		} catch (err) {
			close(err);
		}
	};
	signalManager.statusChanged?.on(() => update());
	update();
});
var subscribeToSignal = ({ signalManager, networkManager }) => new Stream(({ next }) => {
	const ctx = new Context(void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$47,
		L: 43
	});
	let unsubscribe;
	const peer = networkManager.getPeerInfo();
	if (peer) signalManager.subscribeMessages({
		peer,
		onMessage: (message) => {
			next({
				message: {
					author: PublicKey.from(message.author.peerKey).asUint8Array(),
					recipient: message.recipient ? PublicKey.from(message.recipient.peerKey).asUint8Array() : /* @__PURE__ */ new Uint8Array(),
					payload: message.payload
				},
				receivedAt: /* @__PURE__ */ new Date()
			});
		}
	}).then((unsub) => {
		if (ctx.disposed) unsub();
		else unsubscribe = unsub;
	}).catch((err) => log.catch(err, void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$47,
		L: 73,
		S: void 0
	}));
	signalManager.swarmEvent.on(ctx, (swarmEvent) => {
		next({
			swarmEvent: swarmEvent.peerAvailable ? { peerAvailable: {
				peer: PublicKey.from(swarmEvent.peerAvailable.peer.peerKey).asUint8Array(),
				since: swarmEvent.peerAvailable.since
			} } : { peerLeft: { peer: PublicKey.from(swarmEvent.peerLeft.peer.peerKey).asUint8Array() } },
			topic: swarmEvent.topic.asUint8Array(),
			receivedAt: /* @__PURE__ */ new Date()
		});
	});
	return () => {
		unsubscribe?.();
		return ctx.dispose();
	};
});
var subscribeToNetworkTopics = ({ networkManager }) => new Stream(({ next, close }) => {
	const update = () => {
		try {
			next({ topics: networkManager.topics.map((topic) => ({
				topic,
				label: networkManager.getSwarm(topic)?.label ?? topic.toHex()
			})) });
		} catch (err) {
			close(err);
		}
	};
	networkManager.topicsUpdated.on(update);
	update();
});
var subscribeToSwarmInfo = ({ networkManager }) => new Stream(({ next }) => {
	const update = () => {
		const info = networkManager.connectionLog?.swarms;
		if (info) next({ data: info });
	};
	networkManager.connectionLog?.update.on(update);
	update();
});
var getNetworkPeers = ({ networkManager }, request) => {
	if (!request.topic) throw new Error("Expected a network topic");
	return { peers: networkManager.getSwarmMap(PublicKey.from(request.topic))?.peers.map((peer) => ({
		...peer,
		connections: peer.connections.map((connection) => connection.asUint8Array())
	})) };
};
//#endregion
//#region src/packlets/devtools/spaces.ts
var subscribeToSpaces = (context, { spaceKeys = [] }) => {
	return new Stream(({ next }) => {
		let unsubscribe;
		const update = async () => {
			next({ spaces: [...context.spaceManager.spaces.values()].filter((space) => !spaceKeys?.length || spaceKeys.some((spaceKey) => spaceKey.equals(space.key))).map((space) => {
				const spaceMetadata = context.metadataStore.spaces.find((spaceMetadata) => spaceMetadata.key.equals(space.key));
				return {
					key: space.key,
					isOpen: space.isOpen,
					timeframe: spaceMetadata?.dataTimeframe,
					genesisFeed: space.genesisFeedKey,
					controlFeed: space.controlFeedKey,
					dataFeed: space.dataFeedKey
				};
			}) });
		};
		const timeout = setTimeout(async () => {
			await context.initialized.wait();
			unsubscribe = context.dataSpaceManager.updated.on(() => update());
			await update();
		});
		return () => {
			unsubscribe?.();
			clearTimeout(timeout);
		};
	});
};
//#endregion
//#region src/packlets/devtools/devtools.ts
var __dxlog_file$46 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/devtools/devtools.ts";
var DevtoolsHostEvents = class {
	ready = new Event();
};
/**
* @deprecated
*/
var DevtoolsServiceImpl = class {
	params;
	"constructor"(params) {
		this.params = params;
	}
	["DevtoolsHost.events"]() {
		return EffectStream.async((emit) => {
			const ctx = Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$46,
				L: 79
			});
			this.params.events.ready.on(ctx, () => {
				emit.single({ ready: {} });
			});
			return Effect.promise(() => ctx.dispose());
		});
	}
	["DevtoolsHost.getConfig"]() {
		return Effect.sync(() => ({ config: JSON.stringify(this.params.config.values) }));
	}
	["DevtoolsHost.getStorageInfo"]() {
		return Effect.tryPromise({
			try: async () => {
				const navigatorInfo = typeof navigator === "object" ? await navigator.storage.estimate() : void 0;
				return {
					type: "sqlite",
					storageUsage: navigatorInfo?.usage ?? 0,
					originUsage: navigatorInfo?.usage ?? 0,
					usageQuota: navigatorInfo?.quota ?? 0
				};
			},
			catch: (error) => error
		});
	}
	["DevtoolsHost.getBlobs"]() {
		return Effect.tryPromise({
			try: async () => ({ blobs: await this.params.context.blobStore.list() }),
			catch: (error) => error
		});
	}
	["DevtoolsHost.getSnapshots"]() {
		return Effect.sync(() => ({ snapshots: [] }));
	}
	["DevtoolsHost.resetStorage"](_request) {
		return Effect.fail(/* @__PURE__ */ new Error());
	}
	["DevtoolsHost.enableDebugLogging"](_request) {
		return Effect.fail(/* @__PURE__ */ new Error());
	}
	["DevtoolsHost.disableDebugLogging"](_request) {
		return Effect.fail(/* @__PURE__ */ new Error());
	}
	["DevtoolsHost.subscribeToKeyringKeys"](_request) {
		return toEffectStream(subscribeToKeyringKeys({ keyring: this.params.context.keyring }));
	}
	["DevtoolsHost.subscribeToCredentialMessages"](_request) {
		return EffectStream.fail(/* @__PURE__ */ new Error());
	}
	["DevtoolsHost.subscribeToSpaces"](request) {
		return toEffectStream(subscribeToSpaces(this.params.context, request));
	}
	["DevtoolsHost.subscribeToItems"](_request) {
		return EffectStream.fail(/* @__PURE__ */ new Error());
	}
	["DevtoolsHost.subscribeToFeeds"](request) {
		return toEffectStream(subscribeToFeeds(this.params.context, request));
	}
	["DevtoolsHost.subscribeToFeedBlocks"](request) {
		return toEffectStream(subscribeToFeedBlocks({ feedStore: this.params.context.feedStore }, request));
	}
	["DevtoolsHost.subscribeToMetadata"]() {
		return toEffectStream(subscribeToMetadata({ context: this.params.context }));
	}
	["DevtoolsHost.getSpaceSnapshot"](_request) {
		return Effect.fail(/* @__PURE__ */ new Error());
	}
	["DevtoolsHost.saveSpaceSnapshot"](_request) {
		return Effect.fail(/* @__PURE__ */ new Error());
	}
	["DevtoolsHost.clearSnapshots"](_request) {
		return Effect.fail(/* @__PURE__ */ new Error());
	}
	["DevtoolsHost.getNetworkPeers"](_request) {
		return Effect.fail(/* @__PURE__ */ new Error());
	}
	["DevtoolsHost.subscribeToNetworkTopics"]() {
		return EffectStream.fail(/* @__PURE__ */ new Error());
	}
	["DevtoolsHost.subscribeToSignalStatus"]() {
		return toEffectStream(subscribeToNetworkStatus({ signalManager: this.params.context.signalManager }));
	}
	["DevtoolsHost.subscribeToSignal"]() {
		return toEffectStream(subscribeToSignal({
			signalManager: this.params.context.signalManager,
			networkManager: this.params.context.networkManager
		}));
	}
	["DevtoolsHost.subscribeToSwarmInfo"](_request) {
		return toEffectStream(subscribeToSwarmInfo({ networkManager: this.params.context.networkManager }));
	}
	["DevtoolsHost.exportSqliteDatabase"]() {
		return Effect.tryPromise({
			try: async () => ({ data: await this.params.exportSqliteDatabase() }),
			catch: (error) => error
		});
	}
	["DevtoolsHost.runSqliteQuery"](request) {
		return Effect.promise(async () => {
			try {
				const parsedParams = request.params ? JSON.parse(request.params) : void 0;
				if (parsedParams !== void 0 && !Array.isArray(parsedParams)) throw new Error("Query params must be a JSON array.");
				const rows = await this.params.runSqliteQuery(request.query, parsedParams);
				return { rows: JSON.stringify(rows) };
			} catch (err) {
				return {
					rows: "[]",
					error: err instanceof Error ? err.message : String(err)
				};
			}
		});
	}
};
/**
* Bridges a codec-protobuf {@link Stream} into an Effect {@link EffectStream.Stream}.
* The underlying stream is closed (disposing its resources) when the Effect stream terminates.
*/
var toEffectStream = (stream) => EffectStream.async((emit) => {
	stream.subscribe((message) => void emit.single(message), (error) => error ? void emit.fail(error) : void emit.end());
	return Effect.promise(() => stream.close());
});
//#endregion
//#region src/version.ts
var DXOS_VERSION = "0.10.0";
//#endregion
//#region src/packlets/services/platform.ts
var getPlatform = () => {
	if (process.browser) if (typeof window !== "undefined") {
		const { userAgent } = window.navigator;
		return {
			type: Platform.PLATFORM_TYPE.BROWSER,
			userAgent,
			uptime: Math.floor((Date.now() - window.performance.timeOrigin) / 1e3)
		};
	} else return {
		type: Platform.PLATFORM_TYPE.DEDICATED_WORKER,
		uptime: Math.floor((Date.now() - performance.timeOrigin) / 1e3)
	};
	else {
		const { platform, version, arch } = process;
		return {
			type: Platform.PLATFORM_TYPE.NODE,
			platform,
			arch,
			runtime: version,
			uptime: Math.floor(process.uptime()),
			memory: process.memoryUsage()
		};
	}
};
//#endregion
//#region src/packlets/diagnostics/diagnostics.ts
var __dxlog_file$45 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/diagnostics/diagnostics.ts";
var DEFAULT_TIMEOUT = 1e3;
/**
* Create diagnostics to provide snapshot of current system state.
*/
var createDiagnostics = async (clientServices, serviceContext, config) => {
	const diagnostics = {
		created: (/* @__PURE__ */ new Date()).toISOString(),
		platform: getPlatform(),
		client: {
			version: DXOS_VERSION,
			storage: { version: STORAGE_VERSION }
		}
	};
	await Promise.all([
		(async () => {
			invariant(clientServices.LoggingService, "SystemService is not available.", {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$45,
				L: 98,
				S: void 0,
				A: ["clientServices.LoggingService", "'SystemService is not available.'"]
			});
			diagnostics.metrics = await getFirstStreamValue(clientServices.LoggingService.queryMetrics({}), { timeout: DEFAULT_TIMEOUT }).catch(() => void 0);
		})(),
		(async () => {
			diagnostics.storage = await asyncTimeout(getStorageDiagnostics(), DEFAULT_TIMEOUT).catch(() => void 0);
		})(),
		async () => {
			const identity = serviceContext.identityManager.identity;
			if (identity) {
				diagnostics.identity = {
					did: identity.did,
					identityKey: identity.identityKey,
					spaceKey: identity.space.key,
					profile: identity.profileDocument
				};
				const { devices } = await getFirstStreamValue(clientServices.DevicesService.queryDevices(), { timeout: DEFAULT_TIMEOUT }).catch(() => void 0) ?? {};
				diagnostics.devices = devices;
				if (serviceContext.dataSpaceManager) diagnostics.spaces = await Promise.all(Array.from(serviceContext.dataSpaceManager.spaces.values()).map((space) => getSpaceStats(space)) ?? []);
				const { feeds = [] } = await getFirstStreamValue(clientServices.DevtoolsHost.subscribeToFeeds({}), { timeout: DEFAULT_TIMEOUT }).catch(() => void 0) ?? {};
				diagnostics.feeds = feeds.map(({ feedKey, bytes, length }) => ({
					feedKey,
					bytes,
					length
				}));
				const status = await getFirstStreamValue(clientServices.NetworkService.queryStatus(), { timeout: DEFAULT_TIMEOUT }).catch(() => void 0);
				diagnostics.networkStatus = status;
				diagnostics.swarms = serviceContext.networkManager.connectionLog?.swarms;
			}
		}
	]);
	diagnostics.config = config.values;
	return diagnostics;
};
var getSpaceStats = async (space) => {
	const stats = {
		key: space.key,
		metrics: space.metrics,
		epochs: space.inner.spaceState.credentials.filter(credentialTypeFilter("dxos.halo.credentials.Epoch")).map((credential) => ({
			...credential.subject.assertion,
			id: credential.id
		})),
		members: await Promise.all(Array.from(space.inner.spaceState.members.values()).map(async (member) => ({
			role: member.role,
			identity: {
				did: await createDidFromIdentityKey(member.key),
				identityKey: member.key,
				profile: { displayName: member.assertion.profile?.displayName }
			},
			presence: space.presence.getPeersOnline().filter(({ identityKey }) => identityKey.equals(member.key)).length > 0 ? SpaceMember.PresenceState.ONLINE : SpaceMember.PresenceState.OFFLINE
		}))),
		pipeline: {
			currentEpoch: space.automergeSpaceState.lastEpoch,
			appliedEpoch: space.automergeSpaceState.lastEpoch,
			controlFeeds: space.inner.controlPipeline.state.feeds.map((feed) => feed.key),
			currentControlTimeframe: space.inner.controlPipeline.state.timeframe,
			targetControlTimeframe: space.inner.controlPipeline.state.targetTimeframe,
			totalControlTimeframe: space.inner.controlPipeline.state.endTimeframe
		}
	};
	if (stats.metrics) {
		const { open, ready } = stats.metrics;
		stats.metrics.startupTime = open && ready && ready.getTime() - open.getTime();
	}
	return stats;
};
var getStorageDiagnostics = async () => {
	if (typeof navigator === "undefined" || !navigator.storage) return;
	const map = /* @__PURE__ */ new Map();
	const dir = await navigator.storage.getDirectory();
	for await (const filename of dir?.keys()) {
		const idx = filename.indexOf("-", filename.indexOf("-") + 1);
		if (idx === -1) continue;
		map.set(filename.slice(0, idx), (map.get(filename.slice(0, idx)) ?? 0) + 1);
	}
	return Array.from(map.entries()).sort((a, b) => b[1] - a[1]).map(([file, count]) => ({
		file,
		count
	}));
};
//#endregion
//#region src/packlets/diagnostics/diagnostics-collector.ts
var GET_DIAGNOSTICS_RPC_TIMEOUT = 1e4;
var DiagnosticsCollector = class {
	static broadcastSender = createCollectDiagnosticsBroadcastSender();
	static async collect(config = [], services = null, options = {}) {
		const serviceDiagnostics = await services?.services?.SystemService?.getDiagnostics({ keys: options.humanize ? GetDiagnosticsRequest.KEY_OPTION.HUMANIZE : options.truncate ? GetDiagnosticsRequest.KEY_OPTION.TRUNCATE : void 0 }, { timeout: GET_DIAGNOSTICS_RPC_TIMEOUT });
		const clientDiagnostics = { config };
		const diagnostics = serviceDiagnostics != null ? {
			client: clientDiagnostics,
			services: serviceDiagnostics
		} : {
			client: clientDiagnostics,
			broadcast: await this.broadcastSender.broadcastDiagnosticsRequest()
		};
		return JSON.parse(JSON.stringify(diagnostics, jsonKeyReplacer(options)));
	}
};
//#endregion
//#region src/packlets/diagnostics/index.ts
var diagnostics_exports = /* @__PURE__ */ __exportAll({
	DiagnosticsCollector: () => DiagnosticsCollector,
	createDiagnostics: () => createDiagnostics
});
import * as import__diagnostics_broadcast from "#diagnostics-broadcast";
__reExport(diagnostics_exports, import__diagnostics_broadcast);
//#endregion
//#region src/packlets/identity/authenticator.ts
var __dxlog_file$44 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/identity/authenticator.ts";
var Credential = schema.getCodecForType("dxos.halo.credentials.Credential");
var createAuthProvider = (signer) => async (nonce) => {
	const credential = await signer.createCredential({
		assertion: { "@type": "dxos.halo.credentials.Auth" },
		subject: signer.getIssuer(),
		nonce
	});
	return Credential.encode(credential);
};
/**
* Verifies credentials of another member in the space based on a set of trusted key.
* Will wait up to `authTimeout` for the key to be added to the trusted set.
*/
var TrustedKeySetAuthVerifier = class {
	_params;
	_ctx = new Context(void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$44,
		L: 46
	});
	constructor(_params) {
		this._params = _params;
	}
	async close() {
		await this._ctx.dispose();
	}
	get verifier() {
		return async (nonce, auth) => {
			const credential = Credential.decode(auth);
			log("authenticating...", { credential }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$44,
				L: 57,
				S: this
			});
			const result = await verifyCredential(credential);
			if (result.kind === "fail") {
				log("Invalid credential", { result }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$44,
					L: 61,
					S: this
				});
				return false;
			}
			if (!credential.proof.nonce || !Buffer.from(nonce).equals(credential.proof.nonce)) {
				log("Invalid nonce", {
					nonce,
					credential
				}, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$44,
					L: 66,
					S: this
				});
				return false;
			}
			if (this._isTrustedKey(credential.issuer)) {
				log("key is trusted -- auth success", { key: credential.issuer }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$44,
					L: 71,
					S: this
				});
				return true;
			}
			const trigger = new Trigger();
			this._ctx.onDispose(() => {
				trigger.wake(false);
			});
			const clear = this._params.update.on(this._ctx, () => {
				if (this._isTrustedKey(credential.issuer)) {
					log("auth success", { key: credential.issuer }, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$44,
						L: 82,
						S: this
					});
					trigger.wake(true);
				} else log("key is not currently in trusted set, waiting...", {
					key: credential.issuer,
					trusted: [...this._params.trustedKeysProvider()]
				}, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$44,
					L: 85,
					S: this
				});
			});
			try {
				return await trigger.wait({ timeout: this._params.authTimeout });
			} catch {
				return false;
			} finally {
				clear();
			}
		};
	}
	_isTrustedKey(deviceKey) {
		return this._params.trustedKeysProvider().has(deviceKey);
	}
};
//#endregion
//#region src/packlets/invitations/device-invitation-protocol.ts
var __dxlog_file$43 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/invitations/device-invitation-protocol.ts";
var DeviceInvitationProtocol = class {
	_keyring;
	_getIdentity;
	_acceptIdentity;
	constructor(_keyring, _getIdentity, _acceptIdentity) {
		this._keyring = _keyring;
		this._getIdentity = _getIdentity;
		this._acceptIdentity = _acceptIdentity;
	}
	toJSON() {
		return { kind: "device" };
	}
	checkCanInviteNewMembers() {}
	getInvitationContext() {
		return { kind: Invitation.Kind.DEVICE };
	}
	async delegate() {
		throw new Error("delegation not supported");
	}
	async cancelDelegation() {
		throw new Error("delegation not supported");
	}
	async admit(_, request) {
		invariant(request.device, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$43,
			L: 54,
			S: this,
			A: ["request.device", ""]
		});
		const identity = this._getIdentity();
		const credential = await identity.admitDevice(request.device);
		invariant(getCredentialAssertion(credential)["@type"] === "dxos.halo.credentials.AuthorizedDevice", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$43,
			L: 57,
			S: this,
			A: ["getCredentialAssertion(credential)['@type'] === 'dxos.halo.credentials.AuthorizedDevice'", ""]
		});
		return { device: {
			identityKey: identity.identityKey,
			haloSpaceKey: identity.haloSpaceKey,
			genesisFeedKey: identity.haloGenesisFeedKey,
			controlTimeframe: identity.controlPipeline.state.timeframe,
			credential
		} };
	}
	checkInvitation(invitation) {
		try {
			if (this._getIdentity()) return new AlreadyJoinedError({ message: "Currently only one identity per client is supported." });
		} catch {}
	}
	createIntroduction() {
		return {};
	}
	async createAdmissionRequest(deviceProfile) {
		return { device: {
			deviceKey: await this._keyring.createKey(),
			controlFeedKey: await this._keyring.createKey(),
			dataFeedKey: await this._keyring.createKey(),
			profile: deviceProfile
		} };
	}
	async accept(_ctx, response, request) {
		invariant(response.device, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$43,
			L: 101,
			S: this,
			A: ["response.device", ""]
		});
		const { identityKey, haloSpaceKey, genesisFeedKey, controlTimeframe } = response.device;
		invariant(request.device, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$43,
			L: 104,
			S: this,
			A: ["request.device", ""]
		});
		const { deviceKey, controlFeedKey, dataFeedKey, profile } = request.device;
		await this._acceptIdentity({
			identityKey,
			deviceKey,
			haloSpaceKey,
			haloGenesisFeedKey: genesisFeedKey,
			controlFeedKey,
			dataFeedKey,
			controlTimeframe,
			deviceProfile: profile,
			authorizedDeviceCredential: response.device.credential
		});
		return { identityKey };
	}
};
//#endregion
//#region src/packlets/invitations/utils.ts
var stateToString = (state) => {
	return Object.entries(Invitation.State).find(([key, val]) => val === state)?.[0] ?? "unknown";
};
var computeExpirationTime = (invitation) => {
	if (!invitation.lifetime) return;
	return new Date((invitation.created?.getTime() ?? Date.now()) + invitation.lifetime * 1e3);
};
var tryAcquireBeforeContextDisposed = async (ctx, mutex) => {
	let guard;
	return cancelWithContext(ctx, (async () => {
		guard = await mutex.acquire();
		if (ctx.disposed) {
			guard.release();
			guard = void 0;
			throw new ContextDisposedError();
		}
		return guard;
	})());
};
//#endregion
//#region src/packlets/invitations/edge-invitation-handler.ts
var __dxlog_file$42 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/invitations/edge-invitation-handler.ts";
var EdgeInvitationHandler = class {
	_client;
	_callbacks;
	_flowLock;
	_retryInterval;
	_retryJitter;
	constructor(config, _client, _callbacks) {
		this._client = _client;
		this._callbacks = _callbacks;
		this._retryInterval = config?.retryInterval ?? 3e3;
		this._retryJitter = config?.retryJitter ?? 500;
	}
	handle(ctx, guardedState, protocol, deviceProfile) {
		if (!this._client) {
			log("edge disabled", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$42,
				L: 67,
				S: this
			});
			return;
		}
		const invitation = guardedState.current;
		const spaceId = invitation.spaceId;
		if (!(invitation.authMethod !== Invitation.AuthMethod.SHARED_SECRET && invitation.type === Invitation.Type.DELEGATED && invitation.kind === Invitation.Kind.SPACE && spaceId != null && SpaceId.isValid(spaceId))) {
			log("invitation could not be handled by edge", { invitation }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$42,
				L: 81,
				S: this
			});
			return;
		}
		ctx.onDispose(() => {
			this._flowLock?.release();
			this._flowLock = void 0;
		});
		let requestCount = 0;
		const tryHandleInvitation = async () => {
			requestCount++;
			const admissionRequest = await protocol.createAdmissionRequest(deviceProfile);
			if (admissionRequest.space) try {
				await this._handleSpaceInvitationFlow(ctx, guardedState, admissionRequest.space, spaceId);
			} catch (error) {
				if (error instanceof EdgeCallFailedError) {
					log.info("join space with edge unsuccessful", {
						reason: error.message,
						retryable: error.isRetryable,
						after: error.retryAfterMs ?? this._calculateNextRetryMs()
					}, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$42,
						L: 99,
						S: this
					});
					if (error.isRetryable && requestCount < 5) scheduleTask(ctx, tryHandleInvitation, error.retryAfterMs ?? this._calculateNextRetryMs());
				} else if (requestCount < 5) {
					log.info("failed to handle invitation with edge", { error }, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$42,
						L: 108,
						S: this
					});
					scheduleTask(ctx, tryHandleInvitation, this._calculateNextRetryMs());
				}
			}
		};
		scheduleMicroTask(ctx, tryHandleInvitation);
	}
	async _handleSpaceInvitationFlow(ctx, guardedState, admissionRequest, spaceId) {
		try {
			log("edge invitation flow", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$42,
				L: 125,
				S: this
			});
			this._flowLock = await tryAcquireBeforeContextDisposed(ctx, guardedState.mutex);
			log.verbose("edge invitation flow acquired the lock", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$42,
				L: 127,
				S: this
			});
			guardedState.set(this, Invitation.State.CONNECTING);
			const response = await this._joinSpaceByInvitation(ctx, guardedState, spaceId, {
				identityKey: admissionRequest.identityKey.toHex(),
				invitationId: guardedState.current.invitationId
			});
			const admissionResponse = await this._mapToAdmissionResponse(response);
			await this._callbacks.onInvitationSuccess(ctx, admissionResponse, { space: admissionRequest });
		} catch (error) {
			guardedState.set(this, Invitation.State.ERROR);
			throw error;
		} finally {
			this._flowLock?.release();
			this._flowLock = void 0;
		}
	}
	async _mapToAdmissionResponse(edgeResponse) {
		const credentialBytes = Buffer.from(edgeResponse.spaceMemberCredential, "base64");
		return { space: { credential: schema.getCodecForType("dxos.halo.credentials.Credential").decode(credentialBytes) } };
	}
	async _joinSpaceByInvitation(ctx, guardedState, spaceId, request) {
		invariant(this._client, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$42,
			L: 163,
			S: this,
			A: ["this._client", ""]
		});
		try {
			return await this._client.joinSpaceByInvitation(ctx, spaceId, request);
		} catch (error) {
			if (error instanceof EdgeAuthChallengeError) {
				const publicKey = guardedState.current.guestKeypair?.publicKey;
				const privateKey = guardedState.current.guestKeypair?.privateKey;
				if (!privateKey || !publicKey) throw error;
				const signature = sign(Buffer.from(error.challenge, "base64"), privateKey);
				return this._client.joinSpaceByInvitation(ctx, spaceId, {
					...request,
					signature: Buffer.from(signature).toString("base64")
				});
			} else throw error;
		}
	}
	hasFlowLock() {
		return this._flowLock != null;
	}
	_calculateNextRetryMs() {
		return this._retryInterval + Math.random() * this._retryJitter;
	}
};
__decorate([trace.span({ op: "invitation.edge" })], EdgeInvitationHandler.prototype, "_handleSpaceInvitationFlow", null);
//#endregion
//#region src/packlets/invitations/invitation-guest-extenstion.ts
var __dxlog_file$41 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/invitations/invitation-guest-extenstion.ts";
var OPTIONS_TIMEOUT$1 = 1e4;
/**
* Guest's side for a connection to a concrete peer in p2p network during invitation.
*/
var InvitationGuestExtension = class extends RpcExtension {
	_invitationFlowMutex;
	_callbacks;
	_ctx = new Context(void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$41,
		L: 38
	});
	_remoteOptions;
	_remoteOptionsTrigger = new Trigger();
	/**
	* Held to allow only one invitation flow at a time to be active.
	*/
	_invitationFlowLock = null;
	constructor(_invitationFlowMutex, _callbacks) {
		super({
			requested: { InvitationHostService: schema.getService("dxos.halo.invitations.InvitationHostService") },
			exposed: { InvitationHostService: schema.getService("dxos.halo.invitations.InvitationHostService") }
		});
		this._invitationFlowMutex = _invitationFlowMutex;
		this._callbacks = _callbacks;
	}
	hasFlowLock() {
		return this._invitationFlowLock != null;
	}
	async getHandlers() {
		return { InvitationHostService: {
			options: async (options) => {
				invariant(!this._remoteOptions, "Remote options already set.", {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$41,
					L: 68,
					S: this,
					A: ["!this._remoteOptions", "'Remote options already set.'"]
				});
				this._remoteOptions = options;
				this._remoteOptionsTrigger.wake();
			},
			introduce: () => {
				throw new Error("Method not allowed.");
			},
			authenticate: () => {
				throw new Error("Method not allowed.");
			},
			admit: () => {
				throw new Error("Method not allowed.");
			}
		} };
	}
	async onOpen(context) {
		await super.onOpen(context);
		try {
			log.verbose("guest acquire lock", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$41,
				L: 89,
				S: this
			});
			this._invitationFlowLock = await tryAcquireBeforeContextDisposed(this._ctx, this._invitationFlowMutex);
			log.verbose("guest lock acquired", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$41,
				L: 91,
				S: this
			});
			await cancelWithContext(this._ctx, this.rpc.InvitationHostService.options({ role: InvitationOptions.Role.GUEST }));
			log.verbose("options sent", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$41,
				L: 96,
				S: this
			});
			await cancelWithContext(this._ctx, this._remoteOptionsTrigger.wait({ timeout: OPTIONS_TIMEOUT$1 }));
			log.verbose("options received", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$41,
				L: 98,
				S: this
			});
			if (this._remoteOptions?.role !== InvitationOptions.Role.HOST) throw new InvalidInvitationExtensionRoleError({ context: {
				expected: InvitationOptions.Role.HOST,
				remoteOptions: this._remoteOptions,
				remotePeerId: context.remotePeerId
			} });
			this._callbacks.onOpen(this._ctx, context);
		} catch (err) {
			if (this._invitationFlowLock != null) this._callbacks.onError(err);
			if (!this._ctx.disposed) context.close(err);
		}
	}
	async onClose() {
		await this._destroy();
	}
	async onAbort() {
		await this._destroy();
	}
	async _destroy() {
		await this._ctx.dispose();
		if (this._invitationFlowLock != null) {
			this._invitationFlowLock.release();
			this._invitationFlowLock = null;
			log.verbose("invitation flow lock released", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$41,
				L: 133,
				S: this
			});
		}
	}
};
//#endregion
//#region src/packlets/invitations/invitation-host-extension.ts
var __dxlog_file$40 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/invitations/invitation-host-extension.ts";
var OPTIONS_TIMEOUT = 1e4;
/**
* Host's side for a connection to a concrete peer in p2p network during invitation.
*/
var InvitationHostExtension = class extends RpcExtension {
	_invitationFlowMutex;
	_callbacks;
	/**
	* @internal
	*/
	_ctx = new Context(void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$40,
		L: 57
	});
	_remoteOptions;
	_remoteOptionsTrigger = new Trigger();
	_challenge = void 0;
	guestProfile = void 0;
	authenticationPassed = false;
	/**
	* Retry counter for SHARED_SECRET authentication method.
	*/
	authenticationRetry = 0;
	/**
	* Resolved when admission is completed.
	*/
	completedTrigger = new Trigger();
	/**
	* Held to allow only one invitation flow at a time to be active.
	*/
	_invitationFlowLock = null;
	constructor(_invitationFlowMutex, _callbacks) {
		super({
			requested: { InvitationHostService: schema.getService("dxos.halo.invitations.InvitationHostService") },
			exposed: { InvitationHostService: schema.getService("dxos.halo.invitations.InvitationHostService") }
		});
		this._invitationFlowMutex = _invitationFlowMutex;
		this._callbacks = _callbacks;
	}
	hasFlowLock() {
		return this._invitationFlowLock != null;
	}
	async getHandlers() {
		return { InvitationHostService: {
			options: async (options) => {
				invariant(!this._remoteOptions, "Remote options already set.", {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$40,
					L: 106,
					S: this,
					A: ["!this._remoteOptions", "'Remote options already set.'"]
				});
				this._remoteOptions = options;
				this._remoteOptionsTrigger.wake();
			},
			introduce: async (request) => {
				const { profile, invitationId } = request;
				log("introducing host invitation", void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$40,
					L: 113,
					S: this
				});
				const invitation = this._requireActiveInvitation();
				this._assertInvitationState(Invitation.State.CONNECTED);
				if (invitationId !== invitation?.invitationId) {
					log.warn("incorrect invitationId", {
						expected: invitation.invitationId,
						actual: invitationId
					}, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$40,
						L: 118,
						S: this
					});
					this._callbacks.onError(/* @__PURE__ */ new Error("Incorrect invitationId."));
					scheduleTask(this._ctx, () => this.close());
					return { authMethod: Invitation.AuthMethod.NONE };
				}
				log.verbose("guest introduced themselves", { guestProfile: profile }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$40,
					L: 127,
					S: this
				});
				this.guestProfile = profile;
				this._callbacks.onStateUpdate(Invitation.State.READY_FOR_AUTHENTICATION);
				this._challenge = invitation.authMethod === Invitation.AuthMethod.KNOWN_PUBLIC_KEY ? randomBytes(32) : void 0;
				log("introduced host invitation", void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$40,
					L: 133,
					S: this
				});
				return {
					authMethod: invitation.authMethod,
					challenge: this._challenge
				};
			},
			authenticate: async ({ authCode: code, signedChallenge }) => {
				log("authenticating host invitation", void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$40,
					L: 141,
					S: this
				});
				const invitation = this._requireActiveInvitation();
				log.verbose("received authentication request", { authCode: code }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$40,
					L: 144,
					S: this
				});
				let status = AuthenticationResponse.Status.OK;
				this._assertInvitationState([Invitation.State.AUTHENTICATING, Invitation.State.READY_FOR_AUTHENTICATION]);
				this._callbacks.onStateUpdate(Invitation.State.AUTHENTICATING);
				switch (invitation.authMethod) {
					case Invitation.AuthMethod.NONE:
						log("authentication not required", void 0, {
							"~LogMeta": "~LogMeta",
							F: __dxlog_file$40,
							L: 152,
							S: this
						});
						return { status: AuthenticationResponse.Status.OK };
					case Invitation.AuthMethod.SHARED_SECRET:
						if (invitation.authCode) if (this.authenticationRetry++ > 3) status = AuthenticationResponse.Status.INVALID_OPT_ATTEMPTS;
						else if (code !== invitation.authCode) status = AuthenticationResponse.Status.INVALID_OTP;
						else this.authenticationPassed = true;
						break;
					case Invitation.AuthMethod.KNOWN_PUBLIC_KEY:
						if (!invitation.guestKeypair) {
							status = AuthenticationResponse.Status.INTERNAL_ERROR;
							break;
						}
						if (this._challenge && verify(this._challenge, Buffer.from(signedChallenge ?? []), invitation.guestKeypair.publicKey.asBuffer())) this.authenticationPassed = true;
						else status = AuthenticationResponse.Status.INVALID_SIGNATURE;
						break;
					default:
						log.error("invalid authentication method", { authMethod: invitation.authMethod }, {
							"~LogMeta": "~LogMeta",
							F: __dxlog_file$40,
							L: 190,
							S: this
						});
						status = AuthenticationResponse.Status.INTERNAL_ERROR;
						break;
				}
				if (![AuthenticationResponse.Status.OK, AuthenticationResponse.Status.INVALID_OTP].includes(status)) {
					this._callbacks.onError(/* @__PURE__ */ new Error(`Authentication failed, with status=${status}`));
					scheduleTask(this._ctx, () => this.close());
					return { status };
				}
				log("authenticated host invitation", { status }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$40,
					L: 202,
					S: this
				});
				return { status };
			},
			admit: async (request) => {
				log("admitting guest", void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$40,
					L: 207,
					S: this
				});
				const invitation = this._requireActiveInvitation();
				try {
					if (isAuthenticationRequired(invitation)) {
						this._assertInvitationState(Invitation.State.AUTHENTICATING);
						if (!this.authenticationPassed) throw new Error("Not authenticated");
					}
					const response = await this._callbacks.admit(request);
					log("admitted guest", void 0, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$40,
						L: 221,
						S: this
					});
					return response;
				} catch (err) {
					this._callbacks.onError(err);
					throw err;
				}
			}
		} };
	}
	async onOpen(context) {
		await super.onOpen(context);
		try {
			log.verbose("host acquire lock", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$40,
				L: 236,
				S: this
			});
			this._invitationFlowLock = await tryAcquireBeforeContextDisposed(this._ctx, this._invitationFlowMutex);
			log.verbose("host lock acquired", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$40,
				L: 238,
				S: this
			});
			this._callbacks.onStateUpdate(Invitation.State.CONNECTING);
			await this.rpc.InvitationHostService.options({ role: InvitationOptions.Role.HOST });
			log.verbose("options sent", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$40,
				L: 241,
				S: this
			});
			await cancelWithContext(this._ctx, this._remoteOptionsTrigger.wait({ timeout: OPTIONS_TIMEOUT }));
			log.verbose("options received", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$40,
				L: 243,
				S: this
			});
			if (this._remoteOptions?.role !== InvitationOptions.Role.GUEST) throw new InvalidInvitationExtensionRoleError({ context: {
				expected: InvitationOptions.Role.GUEST,
				remoteOptions: this._remoteOptions,
				remotePeerId: context.remotePeerId
			} });
			this._callbacks.onStateUpdate(Invitation.State.CONNECTED);
			this._callbacks.onOpen(this._ctx, context);
		} catch (err) {
			if (this._invitationFlowLock != null) this._callbacks.onError(err);
			if (!this._ctx.disposed) context.close(err);
		}
	}
	_requireActiveInvitation() {
		const invitation = this._callbacks.activeInvitation;
		if (invitation == null) {
			scheduleTask(this._ctx, () => this.close());
			throw new Error("Active invitation not found");
		}
		return invitation;
	}
	_assertInvitationState(stateOrMany) {
		const invitation = this._requireActiveInvitation();
		const validStates = Array.isArray(stateOrMany) ? stateOrMany : [stateOrMany];
		if (!validStates.includes(invitation.state)) {
			scheduleTask(this._ctx, () => this.close());
			throw new InvariantViolation(`Expected ${stateToString(invitation.state)} to be one of [${validStates.map(stateToString).join(", ")}]`);
		}
	}
	async onClose() {
		await this._destroy();
	}
	async onAbort() {
		await this._destroy();
	}
	async _destroy() {
		await this._ctx.dispose();
		if (this._invitationFlowLock != null) {
			this._invitationFlowLock?.release();
			this._invitationFlowLock = null;
			log.verbose("invitation flow lock released", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$40,
				L: 298,
				S: this
			});
		}
	}
};
var isAuthenticationRequired = (invitation) => invitation.authMethod !== Invitation.AuthMethod.NONE;
//#endregion
//#region src/packlets/invitations/invitation-state.ts
/**
* A utility object for serializing invitation state changes by multiple concurrent
* invitation flow connections.
*/
var __dxlog_file$39 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/invitations/invitation-state.ts";
var createGuardedInvitationState = (ctx, invitation, stream) => {
	const mutex = new Mutex();
	let lastActiveLockHolder = null;
	let currentInvitation = { ...invitation };
	const isStateChangeAllowed = (lockHolder) => {
		if (ctx.disposed || lockHolder !== null && mutex.isLocked() && !lockHolder.hasFlowLock()) return false;
		return lockHolder == null || lastActiveLockHolder !== lockHolder || isNonTerminalState(currentInvitation.state);
	};
	return {
		mutex,
		get current() {
			return currentInvitation;
		},
		complete: (newState) => {
			logStateUpdate(currentInvitation, void 0, invitation.state);
			currentInvitation = {
				...currentInvitation,
				...newState
			};
			stream.next(currentInvitation);
			return ctx.dispose();
		},
		set: (lockHolder, newState) => {
			if (isStateChangeAllowed(lockHolder)) {
				logStateUpdate(currentInvitation, lockHolder, newState);
				currentInvitation = {
					...currentInvitation,
					state: newState
				};
				stream.next(currentInvitation);
				lastActiveLockHolder = lockHolder;
				return true;
			}
			return false;
		},
		error: (lockHolder, error) => {
			if (isStateChangeAllowed(lockHolder)) {
				logStateUpdate(currentInvitation, lockHolder, Invitation.State.ERROR, error);
				currentInvitation = {
					...currentInvitation,
					state: Invitation.State.ERROR
				};
				stream.next(currentInvitation);
				stream.error(error);
				lastActiveLockHolder = lockHolder;
				return true;
			}
			return false;
		}
	};
};
var logStateUpdate = (invitation, actor, newState, error) => {
	const logContext = {
		invitationId: invitation.invitationId,
		actor: actor?.constructor.name,
		newState: stateToString(newState),
		oldState: stateToString(invitation.state),
		error: error?.message,
		errorStack: error?.stack
	};
	log.verbose("dxos.sdk.invitations-handler.state.update", logContext, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$39,
		L: 87,
		S: void 0
	});
};
var isNonTerminalState = (currentState) => {
	return ![
		Invitation.State.SUCCESS,
		Invitation.State.ERROR,
		Invitation.State.CANCELLED,
		Invitation.State.TIMEOUT,
		Invitation.State.EXPIRED
	].includes(currentState);
};
//#endregion
//#region src/packlets/invitations/invitation-topology.ts
var __dxlog_file$38 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/invitations/invitation-topology.ts";
/**
* Hosts are listening on an invitation topic.
* They initiate a connection with any new peer if they are not currently in the invitation flow
* with another peer (connected.length > 0).
* When the invitation flow ends guest leaves the swarm and topology is updated once again,
* so we can connect to the next peer we haven't tried yet.
* If the peer turns out to be a host or a malicious guest their ID is remembered so that we don't try
* to establish a connection with them again.
*
* Guests don't initiate connections. They accept all connections because if we reject,
* the host won't retry their offer.
* Even if we started an invitation flow with one host we might want to try other hosts in case
* the first one failed due to a network error, so multiple connections are accepted.
*/
var InvitationTopology = class {
	_role;
	_controller;
	/**
	* Peers we tried to establish a connection with.
	* In invitation flow peers are assigned random ids when they join the swarm, so we'll retry
	* a peer if they reload an invitation.
	*
	* Consider keeping a separate set for peers we know are hosts and have some retry timeout
	* for guests we failed an invitation flow with (potentially due to a network error).
	*/
	_seenPeers = new ComplexSet(PublicKey.hash);
	constructor(_role) {
		this._role = _role;
	}
	init(controller) {
		invariant(!this._controller, "Already initialized.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$38,
			L: 42,
			S: this,
			A: ["!this._controller", "'Already initialized.'"]
		});
		this._controller = controller;
	}
	update() {
		invariant(this._controller, "Not initialized.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$38,
			L: 47,
			S: this,
			A: ["this._controller", "'Not initialized.'"]
		});
		const { ownPeerId, candidates, connected, allPeers } = this._controller.getState();
		if (this._role === InvitationOptions.Role.GUEST) return;
		if (connected.length > 0) {
			connected.forEach((c) => this._seenPeers.add(c));
			return;
		}
		const firstUnknownPeer = candidates.find((peerId) => !this._seenPeers.has(peerId));
		this._seenPeers = new ComplexSet(PublicKey.hash, allPeers.filter((peerId) => this._seenPeers.has(peerId)));
		if (firstUnknownPeer != null) {
			log("invitation connect", {
				ownPeerId,
				remotePeerId: firstUnknownPeer
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$38,
				L: 69,
				S: this
			});
			this._controller.connect(firstUnknownPeer);
			this._seenPeers.add(firstUnknownPeer);
		}
	}
	async onOffer(peer) {
		invariant(this._controller, "Not initialized.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$38,
			L: 76,
			S: this,
			A: ["this._controller", "'Not initialized.'"]
		});
		return !this._seenPeers.has(peer);
	}
	async destroy() {
		this._seenPeers.clear();
	}
	toString() {
		return `InvitationTopology(${this._role === InvitationOptions.Role.GUEST ? "guest" : "host"})`;
	}
};
//#endregion
//#region src/packlets/invitations/invitations-handler.ts
var __dxlog_file$37 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/invitations/invitations-handler.ts";
var metrics = trace.metrics;
var MAX_DELEGATED_INVITATION_HOST_TRIES = 3;
/**
* Generic handler for Halo and Space invitations.
* Handles the life-cycle of invitations between peers.
*
* Host
* - Creates an invitation containing a swarm topic (which can be shared via a URL, QR code, or direct message).
* - Joins the swarm with the topic and waits for guest's introduction.
* - Wait for guest to authenticate with challenge specified in the invitation.
* - Waits for guest to present credentials (containing local device and feed keys).
* - Writes credentials to control feed then exits or waits for more guests (multi use invitations).
*
* Guest
* - Joins the swarm with the topic.
* - Sends an introduction.
* - Submits the challenge.
* - If Space handler then creates a local cloned space (with genesis block).
* - Sends admission credentials.
*  ```
*  [Guest]                                          [Host]
*   |------------------------------------Introduce-->|
*   |-------------------------------[Authenticate]-->|
*   |----------------------------------------Admit-->|
*  ```
*
*  TODO: consider refactoring using xstate making the logic separation more explicit:
*  TODO: the flow logic should either be contained in invitations-handler or in extensions, not be split across
*  TODO: potentially re-evaluate host-side API to allow multiple concurrent connection, so that mutex can be removed
*/
/**
* Effect service tag for {@link InvitationsHandler}.
*/
var InvitationsHandlerService = class extends EffectContext.Tag("@dxos/client-services/InvitationsHandler")() {};
var InvitationsHandler = class {
	_networkManager;
	_edgeClient;
	_connectionProps;
	/**
	* @internal
	*/
	constructor(_networkManager, _edgeClient, _connectionProps) {
		this._networkManager = _networkManager;
		this._edgeClient = _edgeClient;
		this._connectionProps = _connectionProps;
	}
	handleInvitationFlow(ctx, stream, protocol, invitation) {
		log.verbose("dxos.sdk.invitations-handler.handleInvitationFlow", {
			state: invitation.state,
			invitationId: invitation.invitationId,
			kind: invitation.kind,
			type: invitation.type
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$37,
			L: 101,
			S: this
		});
		metrics.increment("dxos.invitation.host");
		const hostSpanId = `invitation-host-${invitation.invitationId}`;
		const invitationCtx = ctx;
		ctx = trace.spanStart({
			id: hostSpanId,
			instance: this,
			methodName: "handleInvitationFlow",
			parentCtx: ctx,
			op: "invitation.host",
			attributes: {
				"ctx.dxos.invitation.id": invitation.invitationId,
				"ctx.dxos.invitation.kind": Invitation.Kind[invitation.kind]
			}
		}) ?? ctx;
		if (ctx !== invitationCtx) ctx.onDispose(() => {
			invitationCtx.dispose();
		});
		ctx.onDispose(() => trace.spanEnd(hostSpanId));
		const guardedState = createGuardedInvitationState(ctx, invitation, stream);
		const createExtension = () => {
			const extension = new InvitationHostExtension(guardedState.mutex, {
				get activeInvitation() {
					return ctx.disposed ? null : guardedState.current;
				},
				onStateUpdate: (newState) => {
					if (newState !== Invitation.State.ERROR && newState !== Invitation.State.TIMEOUT) guardedState.set(extension, newState);
					return guardedState.current;
				},
				admit: async (admissionRequest) => {
					try {
						log.verbose("dxos.sdk.invitations-handler.host.admit", {
							invitationId: invitation.invitationId,
							...protocol.toJSON()
						}, {
							"~LogMeta": "~LogMeta",
							F: __dxlog_file$37,
							L: 152,
							S: this
						});
						const deviceKey = admissionRequest.device?.deviceKey ?? admissionRequest.space?.deviceKey;
						invariant(deviceKey, void 0, {
							"~LogMeta": "~LogMeta",
							F: __dxlog_file$37,
							L: 157,
							S: this,
							A: ["deviceKey", ""]
						});
						const admissionResponse = await protocol.admit(invitation, admissionRequest, extension.guestProfile);
						extension.completedTrigger.wake(deviceKey);
						return admissionResponse;
					} catch (err) {
						guardedState.error(extension, err);
						throw err;
					}
				},
				onOpen: (connectionCtx, extensionsCtx) => {
					let admitted = false;
					connectionCtx.onDispose(() => {
						if (!admitted) guardedState.set(extension, Invitation.State.CONNECTING);
					});
					scheduleTask(connectionCtx, async () => {
						try {
							log("opening host invitation handler", void 0, {
								"~LogMeta": "~LogMeta",
								F: __dxlog_file$37,
								L: 181,
								S: this
							});
							log.verbose("connected", { ...protocol.toJSON() }, {
								"~LogMeta": "~LogMeta",
								F: __dxlog_file$37,
								L: 182,
								S: this
							});
							const deviceKey = await extension.completedTrigger.wait({ timeout: invitation.timeout });
							log.verbose("admitted guest", {
								guest: deviceKey,
								...protocol.toJSON()
							}, {
								"~LogMeta": "~LogMeta",
								F: __dxlog_file$37,
								L: 184,
								S: this
							});
							guardedState.set(extension, Invitation.State.SUCCESS);
							metrics.increment("dxos.invitation.success");
							log("host invitation handler opened", void 0, {
								"~LogMeta": "~LogMeta",
								F: __dxlog_file$37,
								L: 187,
								S: this
							});
							admitted = true;
							if (!invitation.multiUse) await ctx.dispose();
						} catch (err) {
							const stateChanged = guardedState.set(extension, Invitation.State.CONNECTING);
							if (err instanceof TimeoutError) {
								if (stateChanged) {
									metrics.increment("dxos.invitation.timeout");
									log.verbose("timeout", { ...protocol.toJSON() }, {
										"~LogMeta": "~LogMeta",
										F: __dxlog_file$37,
										L: 198,
										S: this
									});
								}
							} else if (stateChanged) {
								metrics.increment("dxos.invitation.failed");
								log.error("failed", err, {
									"~LogMeta": "~LogMeta",
									F: __dxlog_file$37,
									L: 203,
									S: this
								});
							}
							extensionsCtx.close(err);
						}
					});
				},
				onError: (err) => {
					const stateChanged = guardedState.set(extension, Invitation.State.CONNECTING);
					if (err instanceof InvalidInvitationExtensionRoleError) {
						log("invalid role", { ...err.context }, {
							"~LogMeta": "~LogMeta",
							F: __dxlog_file$37,
							L: 214,
							S: this
						});
						return;
					}
					if (err instanceof TimeoutError) {
						if (stateChanged) {
							metrics.increment("dxos.invitation.timeout");
							log.verbose("timeout", { err }, {
								"~LogMeta": "~LogMeta",
								F: __dxlog_file$37,
								L: 220,
								S: this
							});
						}
					} else if (stateChanged) {
						metrics.increment("dxos.invitation.failed");
						log.error("failed", err, {
							"~LogMeta": "~LogMeta",
							F: __dxlog_file$37,
							L: 225,
							S: this
						});
					}
				}
			});
			return extension;
		};
		const expiresOn = getExpirationTime(invitation);
		if (expiresOn) {
			if (expiresOn.getTime() < Date.now()) {
				log.warn("invitation has already expired", void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$37,
					L: 237,
					S: this
				});
				guardedState.set(null, Invitation.State.EXPIRED);
				ctx.dispose().catch((err) => log.catch(err, void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$37,
					L: 239,
					S: this
				}));
				return;
			}
			scheduleTask(ctx, async () => {
				await swarmConnection.close(ctx);
				guardedState.set(null, Invitation.State.EXPIRED);
				metrics.increment("dxos.invitation.expired");
				await ctx.dispose();
			}, expiresOn.getTime() - Date.now());
		}
		let swarmConnection;
		scheduleTask(ctx, async () => {
			swarmConnection = await this._joinSwarm(ctx, invitation, InvitationOptions.Role.HOST, createExtension);
			guardedState.set(null, Invitation.State.CONNECTING);
		});
	}
	acceptInvitation(ctx, stream, protocol, invitation, otpEnteredTrigger, deviceProfile) {
		log.verbose("dxos.sdk.invitations-handler.acceptInvitation", {
			state: invitation.state,
			invitationId: invitation.invitationId,
			kind: invitation.kind,
			type: invitation.type
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$37,
			L: 270,
			S: this
		});
		const { timeout = INVITATION_TIMEOUT } = invitation;
		const guestSpanId = `invitation-guest-${invitation.invitationId}`;
		const invitationCtx = ctx;
		ctx = trace.spanStart({
			id: guestSpanId,
			instance: this,
			methodName: "acceptInvitation",
			parentCtx: ctx,
			op: "invitation.guest",
			attributes: {
				"ctx.dxos.invitation.id": invitation.invitationId,
				"ctx.dxos.invitation.kind": Invitation.Kind[invitation.kind]
			}
		}) ?? ctx;
		if (ctx !== invitationCtx) ctx.onDispose(() => {
			invitationCtx.dispose();
		});
		ctx.onDispose(() => trace.spanEnd(guestSpanId));
		if (deviceProfile) invariant(invitation.kind === Invitation.Kind.DEVICE, "deviceProfile provided for non-device invitation", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$37,
			L: 307,
			S: this,
			A: ["invitation.kind === Invitation.Kind.DEVICE", "'deviceProfile provided for non-device invitation'"]
		});
		const triedPeersIds = new ComplexSet(PublicKey.hash);
		const guardedState = createGuardedInvitationState(ctx, invitation, stream);
		const shouldCancelInvitationFlow = (extension) => {
			const isLockedByAnotherConnection = guardedState.mutex.isLocked() && !extension.hasFlowLock();
			log("should cancel invitation flow", {
				isLockedByAnotherConnection,
				invitationType: Invitation.Type.DELEGATED,
				triedPeers: triedPeersIds.size
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$37,
				L: 315,
				S: this
			});
			if (isLockedByAnotherConnection) return false;
			return invitation.type !== Invitation.Type.DELEGATED || triedPeersIds.size >= MAX_DELEGATED_INVITATION_HOST_TRIES;
		};
		let admitted = false;
		const createExtension = () => {
			const extension = new InvitationGuestExtension(guardedState.mutex, {
				onStateUpdate: (newState) => {
					guardedState.set(extension, newState);
				},
				onOpen: (connectionCtx, extensionCtx) => {
					triedPeersIds.add(extensionCtx.remotePeerId);
					if (admitted) {
						extensionCtx.close();
						return;
					}
					connectionCtx.onDispose(async () => {
						log.verbose("extension disposed", {
							admitted,
							currentState: guardedState.current.state
						}, {
							"~LogMeta": "~LogMeta",
							F: __dxlog_file$37,
							L: 343,
							S: this
						});
						if (!admitted) {
							guardedState.error(extension, new ContextDisposedError());
							if (shouldCancelInvitationFlow(extension)) await ctx.dispose();
						}
					});
					scheduleTask(connectionCtx, async () => {
						try {
							log("opening guest invitation handler", void 0, {
								"~LogMeta": "~LogMeta",
								F: __dxlog_file$37,
								L: 354,
								S: this
							});
							scheduleTask(connectionCtx, () => {
								guardedState.set(extension, Invitation.State.TIMEOUT);
								extensionCtx.close();
							}, timeout);
							log.verbose("dxos.sdk.invitations-handler.guest.connected", { ...protocol.toJSON() }, {
								"~LogMeta": "~LogMeta",
								F: __dxlog_file$37,
								L: 365,
								S: this
							});
							guardedState.set(extension, Invitation.State.CONNECTED);
							log.verbose("dxos.sdk.invitations-handler.guest.introduce", {
								invitationId: invitation.invitationId,
								...protocol.toJSON()
							}, {
								"~LogMeta": "~LogMeta",
								F: __dxlog_file$37,
								L: 369,
								S: this
							});
							const introductionResponse = await extension.rpc.InvitationHostService.introduce({
								invitationId: invitation.invitationId,
								...protocol.createIntroduction()
							});
							log.verbose("dxos.sdk.invitations-handler.guest.introduce-response", {
								invitationId: invitation.invitationId,
								...protocol.toJSON(),
								authMethod: introductionResponse.authMethod
							}, {
								"~LogMeta": "~LogMeta",
								F: __dxlog_file$37,
								L: 377,
								S: this
							});
							invitation.authMethod = introductionResponse.authMethod;
							if (isAuthenticationRequired(invitation)) switch (invitation.authMethod) {
								case Invitation.AuthMethod.SHARED_SECRET:
									await this._handleGuestOtpAuth(extension, (state) => guardedState.set(extension, state), otpEnteredTrigger, { timeout });
									break;
								case Invitation.AuthMethod.KNOWN_PUBLIC_KEY:
									await this._handleGuestKpkAuth(extension, (state) => guardedState.set(extension, state), invitation, introductionResponse);
									break;
							}
							log.verbose("dxos.sdk.invitations-handler.guest.request-admission", {
								invitationId: invitation.invitationId,
								...protocol.toJSON()
							}, {
								"~LogMeta": "~LogMeta",
								F: __dxlog_file$37,
								L: 407,
								S: this
							});
							const admissionRequest = await protocol.createAdmissionRequest(deviceProfile);
							const admissionResponse = await extension.rpc.InvitationHostService.admit(admissionRequest);
							admitted = true;
							const result = await protocol.accept(ctx, admissionResponse, admissionRequest);
							log.verbose("dxos.sdk.invitations-handler.guest.admitted-by-host", {
								invitationId: invitation.invitationId,
								...protocol.toJSON()
							}, {
								"~LogMeta": "~LogMeta",
								F: __dxlog_file$37,
								L: 421,
								S: this
							});
							guardedState.complete({
								...guardedState.current,
								...result,
								state: Invitation.State.SUCCESS
							});
							log("guest invitation handler opened", void 0, {
								"~LogMeta": "~LogMeta",
								F: __dxlog_file$37,
								L: 430,
								S: this
							});
						} catch (err) {
							if (err instanceof TimeoutError) {
								log.verbose("timeout", { ...protocol.toJSON() }, {
									"~LogMeta": "~LogMeta",
									F: __dxlog_file$37,
									L: 433,
									S: this
								});
								guardedState.set(extension, Invitation.State.TIMEOUT);
							} else {
								log.verbose("auth failed", err, {
									"~LogMeta": "~LogMeta",
									F: __dxlog_file$37,
									L: 436,
									S: this
								});
								guardedState.error(extension, err);
							}
							extensionCtx.close(err);
						}
					});
				},
				onError: (err) => {
					if (err instanceof InvalidInvitationExtensionRoleError) return;
					if (err instanceof TimeoutError) {
						log.verbose("timeout", { ...protocol.toJSON() }, {
							"~LogMeta": "~LogMeta",
							F: __dxlog_file$37,
							L: 448,
							S: this
						});
						guardedState.set(extension, Invitation.State.TIMEOUT);
					} else {
						log.verbose("auth failed", err, {
							"~LogMeta": "~LogMeta",
							F: __dxlog_file$37,
							L: 451,
							S: this
						});
						guardedState.error(extension, err);
					}
				}
			});
			return extension;
		};
		new EdgeInvitationHandler(this._connectionProps?.edgeInvitations, this._edgeClient, { onInvitationSuccess: async (edgeCtx, admissionResponse, admissionRequest) => {
			const result = await protocol.accept(edgeCtx, admissionResponse, admissionRequest);
			log.info("admitted by edge", { ...protocol.toJSON() }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$37,
				L: 463,
				S: this
			});
			guardedState.complete({
				...guardedState.current,
				...result,
				state: Invitation.State.SUCCESS
			});
		} }).handle(ctx, guardedState, protocol, deviceProfile);
		scheduleTask(ctx, async () => {
			const error = checkInvitation(protocol, invitation);
			if (error) {
				stream.error(error);
				await ctx.dispose();
			} else {
				invariant(invitation.swarmKey, void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$37,
					L: 475,
					S: this,
					A: ["invitation.swarmKey", ""]
				});
				const timeoutInactive = () => {
					if (guardedState.mutex.isLocked()) scheduleTask(ctx, timeoutInactive, timeout);
					else guardedState.set(null, Invitation.State.TIMEOUT);
				};
				scheduleTask(ctx, timeoutInactive, timeout);
				await this._joinSwarm(ctx, invitation, InvitationOptions.Role.GUEST, createExtension);
				guardedState.set(null, Invitation.State.CONNECTING);
			}
		});
	}
	async _joinSwarm(ctx, invitation, role, extensionFactory) {
		let label;
		if (role === InvitationOptions.Role.GUEST) label = "invitation guest";
		else if (invitation.kind === Invitation.Kind.DEVICE) label = "invitation host for device";
		else label = `invitation host for space ${invitation.spaceKey?.truncate()}`;
		const swarmConnection = await this._networkManager.joinSwarm(ctx, {
			topic: invitation.swarmKey,
			protocolProvider: createTeleportProtocolFactory(async (teleport) => {
				teleport.addExtension("dxos.halo.invitations", extensionFactory());
			}, this._connectionProps?.teleport),
			topology: new InvitationTopology(role),
			label
		});
		ctx.onDispose(() => swarmConnection.close(ctx));
		return swarmConnection;
	}
	async _handleGuestOtpAuth(extension, setState, authenticated, options) {
		for (let attempt = 1; attempt <= 3; attempt++) {
			log("guest waiting for authentication code...", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$37,
				L: 527,
				S: this
			});
			setState(Invitation.State.READY_FOR_AUTHENTICATION);
			const authCode = await authenticated.wait(options);
			log("sending authentication request", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$37,
				L: 531,
				S: this
			});
			setState(Invitation.State.AUTHENTICATING);
			const response = await extension.rpc.InvitationHostService.authenticate({ authCode });
			if (response.status === void 0 || response.status === AuthenticationResponse.Status.OK) break;
			if (response.status === AuthenticationResponse.Status.INVALID_OTP) if (attempt === 3) throw new Error(`Maximum retry attempts: 3`);
			else {
				log("retrying invalid code", { attempt }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$37,
					L: 542,
					S: this
				});
				authenticated.reset();
			}
		}
	}
	async _handleGuestKpkAuth(extension, setState, invitation, introductionResponse) {
		if (invitation.guestKeypair?.privateKey == null) throw new Error("keypair missing in the invitation");
		if (introductionResponse.challenge == null) throw new Error("challenge missing in the introduction");
		log("sending authentication request", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$37,
			L: 561,
			S: this
		});
		const signature = sign(Buffer.from(introductionResponse.challenge), invitation.guestKeypair.privateKey);
		const response = await extension.rpc.InvitationHostService.authenticate({ signedChallenge: signature });
		if (response.status !== AuthenticationResponse.Status.OK) throw new Error(`Authentication failed with code: ${response.status}`);
	}
};
var checkInvitation = (protocol, invitation) => {
	const expiresOn = getExpirationTime(invitation);
	if (expiresOn && expiresOn.getTime() < Date.now()) return new InvalidInvitationError({ message: "Invitation already expired." });
	return protocol.checkInvitation(invitation);
};
var createAdmissionKeypair = () => {
	const keypair = createKeyPair();
	return {
		publicKey: PublicKey.from(keypair.publicKey),
		privateKey: keypair.secretKey
	};
};
/**
* Effect Layer constructing an {@link InvitationsHandler}.
*/
var InvitationsHandlerLayer = (options = {}) => Layer.effect(InvitationsHandlerService, Effect.gen(function* () {
	const networkManager = yield* SwarmNetworkManagerService;
	const edgeClient = yield* Effect.serviceOption(EdgeHttpClientService);
	return new InvitationsHandler(networkManager, Option.getOrUndefined(edgeClient), options.connectionProps);
}));
//#endregion
//#region src/packlets/invitations/invitations-service.ts
var __dxlog_file$36 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/invitations/invitations-service.ts";
/**
* Adapts invitation service observable to client/service stream.
*/
var InvitationsServiceImpl = class {
	_invitationsManager;
	"constructor"(_invitationsManager) {
		this._invitationsManager = _invitationsManager;
	}
	"getLoggingContext"() {
		return {};
	}
	["InvitationsService.createInvitation"](request) {
		return EffectStream.async((emit) => {
			const ctx = Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$36,
				L: 36
			});
			this._invitationsManager.createInvitation(ctx, request).then((invitation) => {
				trace.metrics.increment("dxos.invitation.created");
				invitation.subscribe((value) => void emit.single(value), (err) => void emit.fail(err), () => void emit.end());
			}).catch((err) => void emit.fail(err));
			return Effect.promise(() => ctx.dispose());
		});
	}
	["InvitationsService.acceptInvitation"](request) {
		return EffectStream.async((emit) => {
			const ctx = Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$36,
				L: 54
			});
			this._invitationsManager.acceptInvitation(ctx, request).subscribe((value) => void emit.single(value), (err) => void emit.fail(err), () => void emit.end());
			return Effect.promise(() => ctx.dispose());
		});
	}
	["InvitationsService.authenticate"](request) {
		return Effect.tryPromise({
			try: () => this._invitationsManager.authenticate(request),
			catch: (error) => error
		});
	}
	["InvitationsService.cancelInvitation"](request) {
		return Effect.tryPromise({
			try: () => this._invitationsManager.cancelInvitation(request),
			catch: (error) => error
		});
	}
	["InvitationsService.queryInvitations"]() {
		return EffectStream.async((emit) => {
			const ctx = Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$36,
				L: 81
			});
			this._invitationsManager.invitationCreated.on(ctx, (invitation) => {
				emit.single({
					action: QueryInvitationsResponse.Action.ADDED,
					type: QueryInvitationsResponse.Type.CREATED,
					invitations: [invitation]
				});
			});
			this._invitationsManager.invitationAccepted.on(ctx, (invitation) => {
				emit.single({
					action: QueryInvitationsResponse.Action.ADDED,
					type: QueryInvitationsResponse.Type.ACCEPTED,
					invitations: [invitation]
				});
			});
			this._invitationsManager.removedCreated.on(ctx, (invitation) => {
				emit.single({
					action: QueryInvitationsResponse.Action.REMOVED,
					type: QueryInvitationsResponse.Type.CREATED,
					invitations: [invitation]
				});
			});
			this._invitationsManager.removedAccepted.on(ctx, (invitation) => {
				emit.single({
					action: QueryInvitationsResponse.Action.REMOVED,
					type: QueryInvitationsResponse.Type.ACCEPTED,
					invitations: [invitation]
				});
			});
			this._invitationsManager.saved.on(ctx, (invitation) => {
				emit.single({
					action: QueryInvitationsResponse.Action.SAVED,
					type: QueryInvitationsResponse.Type.CREATED,
					invitations: [invitation]
				});
			});
			emit.single({
				action: QueryInvitationsResponse.Action.ADDED,
				type: QueryInvitationsResponse.Type.CREATED,
				invitations: this._invitationsManager.getCreatedInvitations(),
				existing: true
			});
			emit.single({
				action: QueryInvitationsResponse.Action.ADDED,
				type: QueryInvitationsResponse.Type.ACCEPTED,
				invitations: this._invitationsManager.getAcceptedInvitations(),
				existing: true
			});
			this._invitationsManager.onPersistentInvitationsLoaded(ctx, () => {
				emit.single({
					action: QueryInvitationsResponse.Action.LOAD_COMPLETE,
					type: QueryInvitationsResponse.Type.CREATED
				});
			});
			return Effect.promise(() => ctx.dispose());
		});
	}
};
//#endregion
//#region src/packlets/invitations/space-invitation-protocol.ts
var __dxlog_file$35 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/invitations/space-invitation-protocol.ts";
var SpaceInvitationProtocol = class {
	_spaceManager;
	_signingContext;
	_keyring;
	_spaceKey;
	constructor(_spaceManager, _signingContext, _keyring, _spaceKey) {
		this._spaceManager = _spaceManager;
		this._signingContext = _signingContext;
		this._keyring = _keyring;
		this._spaceKey = _spaceKey;
	}
	toJSON() {
		return {
			kind: "space",
			deviceKey: this._signingContext.deviceKey,
			spaceKey: this._spaceKey
		};
	}
	checkCanInviteNewMembers() {
		if (this._spaceKey == null) return new InvalidInvitationError({ message: "No spaceKey was provided for a space invitation." });
		const space = this._spaceManager.spaces.get(this._spaceKey);
		if (space == null) return new SpaceNotFoundError(this._spaceKey);
		if (!space?.inner.spaceState.hasMembershipManagementPermission(this._signingContext.identityKey)) return new AuthorizationError({ message: "No member management permission." });
	}
	getInvitationContext() {
		invariant(this._spaceKey, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 60,
			S: this,
			A: ["this._spaceKey", ""]
		});
		const space = this._spaceManager.spaces.get(this._spaceKey);
		invariant(space, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 62,
			S: this,
			A: ["space", ""]
		});
		return {
			kind: Invitation.Kind.SPACE,
			spaceKey: this._spaceKey,
			spaceId: space.id
		};
	}
	async admit(invitation, request, guestProfile) {
		invariant(this._spaceKey && request.space, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 75,
			S: this,
			A: ["this._spaceKey && request.space", ""]
		});
		log("writing guest credentials", {
			host: this._signingContext.deviceKey,
			guest: request.space.deviceKey
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 76,
			S: this
		});
		return { space: {
			credential: await this._spaceManager.admitMember({
				spaceKey: this._spaceKey,
				identityKey: request.space.identityKey,
				role: invitation.role ?? SpaceMember$1.Role.ADMIN,
				profile: guestProfile,
				delegationCredentialId: invitation.delegationCredentialId
			}),
			controlTimeframe: this._spaceManager.spaces.get(this._spaceKey)?.inner.controlPipeline.state.timeframe
		} };
	}
	async delegate(invitation) {
		invariant(this._spaceKey, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 96,
			S: this,
			A: ["this._spaceKey", ""]
		});
		const space = this._spaceManager.spaces.get(this._spaceKey);
		invariant(space, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 98,
			S: this,
			A: ["space", ""]
		});
		if (invitation.authMethod === Invitation.AuthMethod.KNOWN_PUBLIC_KEY) invariant(invitation.guestKeypair?.publicKey, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 100,
			S: this,
			A: ["invitation.guestKeypair?.publicKey", ""]
		});
		log("writing delegate space invitation", {
			host: this._signingContext.deviceKey,
			id: invitation.invitationId
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 103,
			S: this
		});
		const credential = await createDelegatedSpaceInvitationCredential(this._signingContext.credentialSigner, space.key, {
			invitationId: invitation.invitationId,
			authMethod: invitation.authMethod,
			swarmKey: invitation.swarmKey,
			role: invitation.role ?? SpaceMember$1.Role.ADMIN,
			expiresOn: computeExpirationTime(invitation),
			multiUse: invitation.multiUse ?? false,
			guestKey: invitation.authMethod === Invitation.AuthMethod.KNOWN_PUBLIC_KEY ? invitation.guestKeypair.publicKey : void 0
		});
		invariant(credential.credential, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 121,
			S: this,
			A: ["credential.credential", ""]
		});
		await writeMessages(space.inner.controlPipeline.writer, [credential]);
		return credential.credential.credential.id;
	}
	async cancelDelegation(invitation) {
		invariant(this._spaceKey, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 127,
			S: this,
			A: ["this._spaceKey", ""]
		});
		invariant(invitation.type === Invitation.Type.DELEGATED && invitation.delegationCredentialId, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 128,
			S: this,
			A: ["invitation.type === Invitation.Type.DELEGATED && invitation.delegationCredentialId", ""]
		});
		const space = this._spaceManager.spaces.get(this._spaceKey);
		invariant(space, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 130,
			S: this,
			A: ["space", ""]
		});
		log("cancelling delegated space invitation", {
			host: this._signingContext.deviceKey,
			id: invitation.invitationId
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 132,
			S: this
		});
		const credential = await createCancelDelegatedSpaceInvitationCredential(this._signingContext.credentialSigner, space.key, invitation.delegationCredentialId);
		invariant(credential.credential, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 139,
			S: this,
			A: ["credential.credential", ""]
		});
		await writeMessages(space.inner.controlPipeline.writer, [credential]);
	}
	checkInvitation(invitation) {
		if (invitation.spaceKey == null) return new InvalidInvitationError({ message: "No spaceKey was provided for a space invitation." });
		if (this._spaceManager.spaces.has(invitation.spaceKey)) return new AlreadyJoinedError({ message: "Already joined space." });
	}
	createIntroduction() {
		return { profile: this._signingContext.getProfile() };
	}
	async createAdmissionRequest() {
		const controlFeedKey = await this._keyring.createKey();
		const dataFeedKey = await this._keyring.createKey();
		return { space: {
			identityKey: this._signingContext.identityKey,
			deviceKey: this._signingContext.deviceKey,
			controlFeedKey,
			dataFeedKey
		} };
	}
	async accept(ctx, response) {
		invariant(response.space, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 174,
			S: this,
			A: ["response.space", ""]
		});
		const { credential, controlTimeframe, dataTimeframe } = response.space;
		const assertion = getCredentialAssertion(credential);
		invariant(assertion["@type"] === "dxos.halo.credentials.SpaceMember", "Invalid credential", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 177,
			S: this,
			A: ["assertion['@type'] === 'dxos.halo.credentials.SpaceMember'", "'Invalid credential'"]
		});
		invariant(credential.subject.id.equals(this._signingContext.identityKey), void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$35,
			L: 178,
			S: this,
			A: ["credential.subject.id.equals(this._signingContext.identityKey)", ""]
		});
		if (this._spaceManager.spaces.has(assertion.spaceKey)) throw new AlreadyJoinedError({ message: "Already joined space." });
		await this._spaceManager.acceptSpace(ctx, {
			spaceKey: assertion.spaceKey,
			genesisFeedKey: assertion.genesisFeedKey,
			controlTimeframe,
			dataTimeframe,
			tags: assertion.tags
		});
		await this._signingContext.recordCredential(credential);
		return { spaceKey: assertion.spaceKey };
	}
};
//#endregion
//#region src/packlets/metadata/metadata-store.ts
var __dxlog_file$34 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/metadata/metadata-store.ts";
var EXPIRED_INVITATION_CLEANUP_INTERVAL$1 = 3600 * 1e3;
/**
* Effect service tag for {@link IMetadataStore}.
*/
var IMetadataStoreService = class extends EffectContext.Tag("@dxos/client-services/IMetadataStore")() {};
var emptyEchoMetadata$1 = () => ({
	version: STORAGE_VERSION,
	spaces: [],
	created: /* @__PURE__ */ new Date(),
	updated: /* @__PURE__ */ new Date()
});
var emptyLargeSpaceMetadata$1 = () => ({});
var EchoMetadata = schema.getCodecForType("dxos.echo.metadata.EchoMetadata");
var LargeSpaceMetadata = schema.getCodecForType("dxos.echo.metadata.LargeSpaceMetadata");
var MetadataStore = class {
	_metadata = emptyEchoMetadata$1();
	_spaceLargeMetadata = new ComplexMap(PublicKey.hash);
	_metadataFile = void 0;
	update = new Event();
	_invitationCleanupCtx = new Context(void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$34,
		L: 103
	});
	/**
	* @internal
	*/
	_directory;
	constructor(directory) {
		this._directory = directory;
	}
	get metadata() {
		return this._metadata;
	}
	get version() {
		return this._metadata.version ?? 0;
	}
	/**
	* Returns a list of currently saved spaces. The list and objects in it can be modified addSpace and
	* addSpaceFeed functions.
	*/
	get spaces() {
		return this._metadata.spaces ?? [];
	}
	/**
	* Returns the keys of spaces that have been tombstoned (soft-deleted).
	*/
	get deletedSpaces() {
		return this._metadata.deletedSpaces ?? [];
	}
	async _readFile(file, codec) {
		try {
			const { size: fileLength } = await file.stat();
			if (fileLength < 8) return;
			const dataSize = fromBytesInt32(await file.read(0, 4));
			const checksum = fromBytesInt32(await file.read(4, 4));
			log("loaded", {
				size: dataSize,
				checksum,
				name: file.filename
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$34,
				L: 146,
				S: this
			});
			if (fileLength < dataSize + 8) throw new DataCorruptionError({
				message: "Metadata size is smaller than expected.",
				context: {
					fileLength,
					dataSize
				}
			});
			const data = await file.read(8, dataSize);
			if (CRC32.buf(data) !== checksum) throw new DataCorruptionError({ message: "Metadata checksum is invalid." });
			return codec.decode(data);
		} finally {
			await file.close();
		}
	}
	/**
	* @internal
	*/
	async _writeFile(file, codec, data) {
		const encoded = arrayToBuffer(codec.encode(data));
		const checksum = CRC32.buf(encoded);
		const result = Buffer.alloc(8 + encoded.length);
		result.writeInt32LE(encoded.length, 0);
		result.writeInt32LE(checksum, 4);
		encoded.copy(result, 8);
		await file.write(0, result);
		log("saved", {
			size: encoded.length,
			checksum
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$34,
			L: 184,
			S: this
		});
	}
	async close() {
		await this._invitationCleanupCtx.dispose();
		await this.flush();
		await this._metadataFile?.close();
		this._metadataFile = void 0;
		this._metadata = emptyEchoMetadata$1();
		this._spaceLargeMetadata.clear();
	}
	/**
	* Loads metadata from persistent storage.
	*/
	async load() {
		if (!this._metadataFile || this._metadataFile.closed) this._metadataFile = this._directory.getOrCreateFile("EchoMetadata");
		try {
			const metadata = await this._readFile(this._metadataFile, EchoMetadata);
			if (metadata) this._metadata = metadata;
			this._metadata.spaces?.forEach((space) => {
				space.state ??= SpaceState.SPACE_ACTIVE;
			});
		} catch (err) {
			log.error("failed to load metadata", { err }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$34,
				L: 216,
				S: this
			});
			this._metadata = emptyEchoMetadata$1();
		}
		await forEachAsync([this._metadata.identity?.haloSpace.key, ...this._metadata.spaces?.map((space) => space.key) ?? []].filter(isNonNullable), async (key) => {
			try {
				await this._loadSpaceLargeMetadata(key);
			} catch (err) {
				log.error("failed to load space large metadata", { err }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$34,
					L: 228,
					S: this
				});
			}
		});
		scheduleTaskInterval(this._invitationCleanupCtx, async () => {
			for (const invitation of this._metadata.invitations ?? []) if (hasInvitationExpired(invitation) || isLegacyInvitationFormat$1(invitation)) await this.removeInvitation(invitation.invitationId);
		}, EXPIRED_INVITATION_CLEANUP_INTERVAL$1);
	}
	async _save() {
		const data = {
			...this._metadata,
			version: STORAGE_VERSION,
			created: this._metadata.created ?? /* @__PURE__ */ new Date(),
			updated: /* @__PURE__ */ new Date()
		};
		this.update.emit(data);
		const file = this._directory.getOrCreateFile("EchoMetadata");
		await this._writeFile(file, EchoMetadata, data);
	}
	async _loadSpaceLargeMetadata(key) {
		const file = this._directory.getOrCreateFile(`space_${key.toHex()}_large`);
		try {
			const metadata = await this._readFile(file, LargeSpaceMetadata);
			if (metadata) this._spaceLargeMetadata.set(key, metadata);
		} catch (err) {
			log.error("failed to load space large metadata", { err }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$34,
				L: 270,
				S: this
			});
		}
	}
	async _saveSpaceLargeMetadata(key) {
		const data = this._getLargeSpaceMetadata(key);
		const file = this._directory.getOrCreateFile(`space_${key.toHex()}_large`);
		await this._writeFile(file, LargeSpaceMetadata, data);
	}
	async flush() {
		await this._directory.flush();
	}
	_getSpace(spaceKey) {
		if (this._metadata.identity?.haloSpace.key.equals(spaceKey)) return this._metadata.identity.haloSpace;
		const space = this.spaces.find((space) => space.key.equals(spaceKey));
		invariant(space, "Space not found", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$34,
			L: 292,
			S: this,
			A: ["space", "'Space not found'"]
		});
		return space;
	}
	hasSpace(spaceKey) {
		if (this._metadata.identity?.haloSpace.key.equals(spaceKey)) return true;
		return !!this.spaces.find((space) => space.key.equals(spaceKey));
	}
	_getLargeSpaceMetadata(key) {
		let entry = this._spaceLargeMetadata.get(key);
		if (entry) return entry;
		entry = emptyLargeSpaceMetadata$1();
		this._spaceLargeMetadata.set(key, entry);
		return entry;
	}
	/**
	* Clears storage - doesn't work for now.
	*/
	async clear() {
		log("clearing all metadata", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$34,
			L: 320,
			S: this
		});
		await this._directory.delete();
		this._metadata = emptyEchoMetadata$1();
	}
	getIdentityRecord() {
		return this._metadata.identity;
	}
	async setIdentityRecord(record) {
		invariant(!this._metadata.identity, "Cannot overwrite existing identity in metadata", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$34,
			L: 330,
			S: this,
			A: ["!this._metadata.identity", "'Cannot overwrite existing identity in metadata'"]
		});
		this._metadata.identity = record;
		await this._save();
		await this.flush();
	}
	getInvitations() {
		return this._metadata.invitations ?? [];
	}
	async addInvitation(invitation) {
		if (this._metadata.invitations?.find((i) => i.invitationId === invitation.invitationId)) return;
		(this._metadata.invitations ??= []).push(invitation);
		await this._save();
		await this.flush();
	}
	async removeInvitation(invitationId) {
		this._metadata.invitations = (this._metadata.invitations ?? []).filter((i) => i.invitationId !== invitationId);
		await this._save();
		await this.flush();
	}
	/**
	* Records a space as tombstoned (soft-deleted) so it is never re-accepted or auto-opened.
	*/
	async addDeletedSpace(spaceKey) {
		if ((this._metadata.deletedSpaces ?? []).some((key) => key.equals(spaceKey))) return;
		(this._metadata.deletedSpaces ??= []).push(spaceKey);
		await this._save();
		await this.flush();
	}
	async addSpace(record) {
		invariant(!(this._metadata.spaces ?? []).find((space) => space.key.equals(record.key)), "Cannot overwrite existing space in metadata", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$34,
			L: 371,
			S: this,
			A: ["!(this._metadata.spaces ?? []).find((space) => space.key.equals(record.key))", "'Cannot overwrite existing space in metadata'"]
		});
		(this._metadata.spaces ??= []).push(record);
		await this._save();
		await this.flush();
	}
	async setSpaceDataLatestTimeframe(spaceKey, timeframe) {
		this._getSpace(spaceKey).dataTimeframe = timeframe;
		await this._save();
	}
	async setSpaceControlLatestTimeframe(spaceKey, timeframe) {
		this._getSpace(spaceKey).controlTimeframe = timeframe;
		await this._save();
		await this.flush();
	}
	async setCache(spaceKey, cache) {
		this._getSpace(spaceKey).cache = cache;
		await this._save();
	}
	async setWritableFeedKeys(spaceKey, controlFeedKey, dataFeedKey) {
		const space = this._getSpace(spaceKey);
		space.controlFeedKey = controlFeedKey;
		space.dataFeedKey = dataFeedKey;
		await this._save();
		await this.flush();
	}
	async setSpaceState(spaceKey, state) {
		this._getSpace(spaceKey).state = state;
		await this._save();
		await this.flush();
	}
	getSpaceControlPipelineSnapshot(spaceKey) {
		return this._getLargeSpaceMetadata(spaceKey).controlPipelineSnapshot;
	}
	async setSpaceControlPipelineSnapshot(spaceKey, snapshot) {
		this._getLargeSpaceMetadata(spaceKey).controlPipelineSnapshot = snapshot;
		await this._saveSpaceLargeMetadata(spaceKey);
		await this.flush();
	}
	getSpaceEdgeReplicationSetting(spaceKey) {
		return this.hasSpace(spaceKey) ? this._getSpace(spaceKey).edgeReplication : void 0;
	}
	async setSpaceEdgeReplicationSetting(spaceKey, setting) {
		this._getSpace(spaceKey).edgeReplication = setting;
		await this._save();
		await this.flush();
	}
};
__decorate([synchronized], MetadataStore.prototype, "load", null);
__decorate([synchronized], MetadataStore.prototype, "_save", null);
__decorate([synchronized], MetadataStore.prototype, "_saveSpaceLargeMetadata", null);
var fromBytesInt32 = (buf) => buf.readInt32LE(0);
var hasInvitationExpired = (invitation) => {
	return Boolean(invitation.created && invitation.lifetime && invitation.lifetime !== 0 && invitation.created.getTime() + invitation.lifetime * 1e3 < Date.now());
};
var isLegacyInvitationFormat$1 = (invitation) => {
	return invitation.type === Invitation.Type.MULTIUSE;
};
//#endregion
//#region src/packlets/metadata/sqlite-metadata-store.ts
var __dxlog_file$33 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/metadata/sqlite-metadata-store.ts";
var EXPIRED_INVITATION_CLEANUP_INTERVAL = 3600 * 1e3;
var emptyEchoMetadata = () => ({
	version: STORAGE_VERSION,
	spaces: [],
	created: /* @__PURE__ */ new Date(),
	updated: /* @__PURE__ */ new Date()
});
var emptyLargeSpaceMetadata = () => ({});
var EchoMetadataCodec = schema.getCodecForType("dxos.echo.metadata.EchoMetadata");
var LargeSpaceMetadataCodec = schema.getCodecForType("dxos.echo.metadata.LargeSpaceMetadata");
var MAIN_KEY = "main";
var largeKey = (spaceKey) => `large:${spaceKey.toHex()}`;
var isLegacyInvitationFormat = (invitation) => invitation.type === Invitation.Type.MULTIUSE;
/**
* SQLite-backed replacement for MetadataStore.
* Stores EchoMetadata as a single protobuf blob and LargeSpaceMetadata as per-space blobs.
*/
var SqliteMetadataStore = class {
	#runtime;
	#metadata = emptyEchoMetadata();
	#spaceLargeMetadata = new ComplexMap(PublicKey.hash);
	update = new Event();
	#invitationCleanupCtx = new Context(void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$33,
		L: 73
	});
	constructor({ runtime }) {
		this.#runtime = runtime;
	}
	/**
	* Creates the space_metadata and space_large tables if they do not exist.
	*/
	migrate = Effect.fn("SqliteMetadataStore.migrate")(() => Effect.gen(function* () {
		const sql = yield* SqlClient.SqlClient;
		yield* sql`CREATE TABLE IF NOT EXISTS space_metadata (
          key TEXT PRIMARY KEY,
          value BLOB NOT NULL
        )`;
		yield* sql`CREATE TABLE IF NOT EXISTS space_large (
          space_key TEXT PRIMARY KEY,
          value BLOB NOT NULL
        )`;
		log("space_metadata and space_large tables ready", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$33,
			L: 95,
			S: this
		});
	}).pipe(Effect.withSpan("SqliteMetadataStore.migrate")))();
	get metadata() {
		return this.#metadata;
	}
	get version() {
		return this.#metadata.version ?? 0;
	}
	get spaces() {
		return this.#metadata.spaces ?? [];
	}
	async close() {
		await this.#invitationCleanupCtx.dispose();
		await this._save();
		this.#metadata = emptyEchoMetadata();
		this.#spaceLargeMetadata.clear();
	}
	/**
	* Loads metadata from SQLite.
	*/
	async load() {
		const rows = await RuntimeProvider.runPromise(this.#runtime)(Effect.gen(function* () {
			return yield* (yield* SqlClient.SqlClient)`SELECT value FROM space_metadata WHERE key = ${MAIN_KEY}`;
		}));
		if (rows.length > 0) try {
			this.#metadata = this.#decodeWithCrc(rows[0].value, EchoMetadataCodec) ?? emptyEchoMetadata();
			this.#metadata.spaces?.forEach((space) => {
				space.state ??= SpaceState.SPACE_ACTIVE;
			});
		} catch (err) {
			log.error("failed to load metadata from SQLite", { err }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$33,
				L: 137,
				S: this
			});
			this.#metadata = emptyEchoMetadata();
		}
		await forEachAsync([this.#metadata.identity?.haloSpace.key, ...this.#metadata.spaces?.map((s) => s.key) ?? []].filter(isNonNullable), async (key) => {
			try {
				await this.#loadSpaceLargeMetadata(key);
			} catch (err) {
				log.error("failed to load large space metadata", { err }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$33,
					L: 152,
					S: this
				});
			}
		});
		scheduleTaskInterval(this.#invitationCleanupCtx, async () => {
			for (const invitation of this.#metadata.invitations ?? []) if (hasInvitationExpired(invitation) || isLegacyInvitationFormat(invitation)) await this.removeInvitation(invitation.invitationId);
		}, EXPIRED_INVITATION_CLEANUP_INTERVAL);
	}
	async flush() {}
	hasSpace(spaceKey) {
		if (this.#metadata.identity?.haloSpace.key.equals(spaceKey)) return true;
		return !!this.spaces.find((space) => space.key.equals(spaceKey));
	}
	getIdentityRecord() {
		return this.#metadata.identity;
	}
	async setIdentityRecord(record) {
		invariant(!this.#metadata.identity, "Cannot overwrite existing identity in metadata", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$33,
			L: 185,
			S: this,
			A: ["!this.#metadata.identity", "'Cannot overwrite existing identity in metadata'"]
		});
		this.#metadata.identity = record;
		await this._save();
	}
	getInvitations() {
		return this.#metadata.invitations ?? [];
	}
	async addInvitation(invitation) {
		if (this.#metadata.invitations?.find((i) => i.invitationId === invitation.invitationId)) return;
		(this.#metadata.invitations ??= []).push(invitation);
		await this._save();
	}
	async removeInvitation(invitationId) {
		this.#metadata.invitations = (this.#metadata.invitations ?? []).filter((i) => i.invitationId !== invitationId);
		await this._save();
	}
	async addSpace(record) {
		invariant(!(this.#metadata.spaces ?? []).find((space) => space.key.equals(record.key)), "Cannot overwrite existing space in metadata", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$33,
			L: 208,
			S: this,
			A: ["!(this.#metadata.spaces ?? []).find((space) => space.key.equals(record.key))", "'Cannot overwrite existing space in metadata'"]
		});
		(this.#metadata.spaces ??= []).push(record);
		await this._save();
	}
	async setSpaceDataLatestTimeframe(spaceKey, timeframe) {
		this.#getSpace(spaceKey).dataTimeframe = timeframe;
		await this._save();
	}
	async setSpaceControlLatestTimeframe(spaceKey, timeframe) {
		this.#getSpace(spaceKey).controlTimeframe = timeframe;
		await this._save();
	}
	async setCache(spaceKey, cache) {
		this.#getSpace(spaceKey).cache = cache;
		await this._save();
	}
	async setWritableFeedKeys(spaceKey, controlFeedKey, dataFeedKey) {
		const space = this.#getSpace(spaceKey);
		space.controlFeedKey = controlFeedKey;
		space.dataFeedKey = dataFeedKey;
		await this._save();
	}
	async setSpaceState(spaceKey, state) {
		this.#getSpace(spaceKey).state = state;
		await this._save();
	}
	getSpaceControlPipelineSnapshot(spaceKey) {
		return this.#getLargeSpaceMetadata(spaceKey).controlPipelineSnapshot;
	}
	async setSpaceControlPipelineSnapshot(spaceKey, snapshot) {
		this.#getLargeSpaceMetadata(spaceKey).controlPipelineSnapshot = snapshot;
		await this._saveSpaceLargeMetadata(spaceKey);
	}
	getSpaceEdgeReplicationSetting(spaceKey) {
		return this.hasSpace(spaceKey) ? this.#getSpace(spaceKey).edgeReplication : void 0;
	}
	async setSpaceEdgeReplicationSetting(spaceKey, setting) {
		this.#getSpace(spaceKey).edgeReplication = setting;
		await this._save();
	}
	get deletedSpaces() {
		return this.#metadata.deletedSpaces ?? [];
	}
	async addDeletedSpace(spaceKey) {
		if ((this.#metadata.deletedSpaces ?? []).some((key) => key.equals(spaceKey))) return;
		(this.#metadata.deletedSpaces ??= []).push(spaceKey);
		await this._save();
	}
	async clear() {
		log("clearing all metadata", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$33,
			L: 274,
			S: this
		});
		await RuntimeProvider.runPromise(this.#runtime)(Effect.gen(function* () {
			const sql = yield* SqlClient.SqlClient;
			yield* sql`DELETE FROM space_metadata`;
			yield* sql`DELETE FROM space_large`;
		}));
		this.#metadata = emptyEchoMetadata();
		this.#spaceLargeMetadata.clear();
	}
	#getSpace(spaceKey) {
		if (this.#metadata.identity?.haloSpace.key.equals(spaceKey)) return this.#metadata.identity.haloSpace;
		const space = this.spaces.find((space) => space.key.equals(spaceKey));
		invariant(space, "Space not found", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$33,
			L: 291,
			S: this,
			A: ["space", "'Space not found'"]
		});
		return space;
	}
	#getLargeSpaceMetadata(key) {
		let entry = this.#spaceLargeMetadata.get(key);
		if (!entry) {
			entry = emptyLargeSpaceMetadata();
			this.#spaceLargeMetadata.set(key, entry);
		}
		return entry;
	}
	async _save() {
		const data = {
			...this.#metadata,
			version: STORAGE_VERSION,
			created: this.#metadata.created ?? /* @__PURE__ */ new Date(),
			updated: /* @__PURE__ */ new Date()
		};
		this.update.emit(data);
		const encoded = this.#encodeWithCrc(EchoMetadataCodec, data);
		await RuntimeProvider.runPromise(this.#runtime)(Effect.gen(function* () {
			yield* (yield* SqlClient.SqlClient)`INSERT OR REPLACE INTO space_metadata (key, value) VALUES (${MAIN_KEY}, ${encoded})`;
		}));
	}
	async #loadSpaceLargeMetadata(key) {
		const keyStr = largeKey(key);
		const rows = await RuntimeProvider.runPromise(this.#runtime)(Effect.gen(function* () {
			return yield* (yield* SqlClient.SqlClient)`SELECT value FROM space_large WHERE space_key = ${keyStr}`;
		}));
		if (rows.length > 0) try {
			const meta = this.#decodeWithCrc(rows[0].value, LargeSpaceMetadataCodec);
			if (meta) this.#spaceLargeMetadata.set(key, meta);
		} catch (err) {
			log.error("failed to decode large space metadata", { err }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$33,
				L: 337,
				S: this
			});
		}
	}
	async _saveSpaceLargeMetadata(key) {
		const data = this.#getLargeSpaceMetadata(key);
		const keyStr = largeKey(key);
		const encoded = this.#encodeWithCrc(LargeSpaceMetadataCodec, data);
		await RuntimeProvider.runPromise(this.#runtime)(Effect.gen(function* () {
			yield* (yield* SqlClient.SqlClient)`INSERT OR REPLACE INTO space_large (space_key, value) VALUES (${keyStr}, ${encoded})`;
		}));
	}
	/** Serialize with CRC32 checksum prefix for integrity checking (matches MetadataStore format). */
	#encodeWithCrc(codec, data) {
		const encoded = arrayToBuffer(codec.encode(data));
		const checksum = CRC32.buf(encoded);
		const result = Buffer.alloc(8 + encoded.length);
		result.writeInt32LE(encoded.length, 0);
		result.writeInt32LE(checksum, 4);
		encoded.copy(result, 8);
		return result;
	}
	/** Deserialize with CRC32 integrity check (matches MetadataStore format). */
	#decodeWithCrc(data, codec) {
		const buf = Buffer.from(data);
		if (buf.length < 8) return;
		const dataSize = buf.readInt32LE(0);
		const checksum = buf.readInt32LE(4);
		if (dataSize < 0 || dataSize > buf.length - 8) throw new DataCorruptionError({
			message: "Metadata size header is invalid.",
			context: {
				fileLength: buf.length,
				dataSize
			}
		});
		if (buf.length !== dataSize + 8) throw new DataCorruptionError({
			message: "Metadata payload length does not match framing header.",
			context: {
				fileLength: buf.length,
				dataSize
			}
		});
		const payload = buf.subarray(8, dataSize + 8);
		if (CRC32.buf(payload) !== checksum) throw new DataCorruptionError({ message: "Metadata checksum is invalid." });
		return codec.decode(payload);
	}
};
__decorate([synchronized], SqliteMetadataStore.prototype, "load", null);
__decorate([synchronized], SqliteMetadataStore.prototype, "_save", null);
__decorate([synchronized], SqliteMetadataStore.prototype, "_saveSpaceLargeMetadata", null);
/**
* Effect Layer constructing a {@link SqliteMetadataStore} from the ambient SQL runtime.
*/
var SqliteMetadataStoreLayer = () => Layer.effect(IMetadataStoreService, Effect.gen(function* () {
	return new SqliteMetadataStore({ runtime: yield* RuntimeProvider.currentRuntime() });
}));
//#endregion
//#region src/packlets/invitations/invitations-manager.ts
var __dxlog_file$32 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/invitations/invitations-manager.ts";
/**
* Effect service tag for {@link InvitationsManager}.
*/
var InvitationsManagerService = class extends EffectContext.Tag("@dxos/client-services/InvitationsManager")() {};
/**
* Entry point for creating and accepting invitations, keeps track of existing invitation set and
* emits events when the set changes.
*/
var InvitationsManager = class {
	_invitationsHandler;
	_metadataStore;
	_createInvitations = /* @__PURE__ */ new Map();
	_acceptInvitations = /* @__PURE__ */ new Map();
	invitationCreated = new Event();
	invitationAccepted = new Event();
	removedCreated = new Event();
	removedAccepted = new Event();
	saved = new Event();
	_persistentInvitationsLoadedEvent = new Event();
	_persistentInvitationsLoaded = false;
	_invitationHandlerFactory;
	constructor(_invitationsHandler, _metadataStore) {
		this._invitationsHandler = _invitationsHandler;
		this._metadataStore = _metadataStore;
	}
	/**
	* Wires the invitation handler factory after the composing stack is fully constructed.
	*/
	setInvitationHandlerFactory(getHandler) {
		this._invitationHandlerFactory = getHandler;
	}
	_getHandler(invitation) {
		invariant(this._invitationHandlerFactory, "Invitation handler factory not set.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$32,
			L: 77,
			S: this,
			A: ["this._invitationHandlerFactory", "'Invitation handler factory not set.'"]
		});
		return this._invitationHandlerFactory(invitation);
	}
	async createInvitation(ctx, options) {
		if (options.invitationId) {
			const existingInvitation = this._createInvitations.get(options.invitationId);
			if (existingInvitation) return existingInvitation;
		}
		const handler = this._getHandler(options);
		const invitationError = handler.checkCanInviteNewMembers();
		if (invitationError != null) throw invitationError;
		const invitation = this._createInvitation(handler, options);
		const { ctx: invitationCtx, stream, observableInvitation } = this._createObservableInvitation(ctx, handler, invitation);
		this._createInvitations.set(invitation.invitationId, observableInvitation);
		this.invitationCreated.emit(invitation);
		this._onInvitationComplete(observableInvitation, async () => {
			this._createInvitations.delete(observableInvitation.get().invitationId);
			this.removedCreated.emit(observableInvitation.get());
			if (observableInvitation.get().persistent) await this._safeDeleteInvitation(observableInvitation.get());
		});
		try {
			await this._persistIfRequired(handler, stream, invitation);
		} catch (err) {
			log.catch(err, void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$32,
				L: 120,
				S: this
			});
			await observableInvitation.cancel();
			return observableInvitation;
		}
		this._invitationsHandler.handleInvitationFlow(invitationCtx, stream, handler, observableInvitation.get());
		return observableInvitation;
	}
	async loadPersistentInvitations(ctx) {
		if (this._persistentInvitationsLoaded) return { invitations: this.getCreatedInvitations().filter((i) => i.persistent) };
		try {
			const loadTasks = this._metadataStore.getInvitations().filter((invitation) => !hasInvitationExpired(invitation)).map((persistentInvitation) => {
				invariant(!this._createInvitations.get(persistentInvitation.invitationId), "invitation already exists", {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$32,
					L: 141,
					S: this,
					A: ["!this._createInvitations.get(persistentInvitation.invitationId)", "'invitation already exists'"]
				});
				return this.createInvitation(ctx, {
					...persistentInvitation,
					persistent: false
				});
			});
			return { invitations: (await Promise.all(loadTasks)).map((invitation) => invitation.get()) };
		} catch (err) {
			log.catch(err, void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$32,
				L: 148,
				S: this
			});
			return { invitations: [] };
		} finally {
			this._persistentInvitationsLoadedEvent.emit();
			this._persistentInvitationsLoaded = true;
		}
	}
	acceptInvitation(ctx, request) {
		const options = request.invitation;
		const existingInvitation = this._acceptInvitations.get(options.invitationId);
		if (existingInvitation) return existingInvitation;
		const handler = this._getHandler(options);
		const { ctx: invitationCtx, invitation, stream, otpEnteredTrigger } = this._createObservableAcceptingInvitation(ctx, handler, options);
		this._invitationsHandler.acceptInvitation(invitationCtx, stream, handler, options, otpEnteredTrigger, request.deviceProfile);
		this._acceptInvitations.set(invitation.get().invitationId, invitation);
		this.invitationAccepted.emit(invitation.get());
		this._onInvitationComplete(invitation, () => {
			this._acceptInvitations.delete(invitation.get().invitationId);
			this.removedAccepted.emit(invitation.get());
		});
		return invitation;
	}
	async authenticate({ invitationId, authCode }) {
		log("authenticating...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$32,
			L: 190,
			S: this
		});
		invariant(invitationId, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$32,
			L: 191,
			S: this,
			A: ["invitationId", ""]
		});
		const observable = this._acceptInvitations.get(invitationId);
		if (!observable) log.warn("invalid invitation", { invitationId }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$32,
			L: 194,
			S: this
		});
		else await observable.authenticate(authCode);
	}
	async cancelInvitation({ invitationId }) {
		log("cancelInvitation...", { invitationId }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$32,
			L: 201,
			S: this
		});
		invariant(invitationId, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$32,
			L: 202,
			S: this,
			A: ["invitationId", ""]
		});
		const created = this._createInvitations.get(invitationId);
		if (created) {
			if (created.get().persistent) await this._metadataStore.removeInvitation(invitationId);
			if (created.get().type === Invitation.Type.DELEGATED) await this._getHandler(created.get()).cancelDelegation(created.get());
			await created.cancel();
			this._createInvitations.delete(invitationId);
			this.removedCreated.emit(created.get());
			return;
		}
		const accepted = this._acceptInvitations.get(invitationId);
		if (accepted) {
			await accepted.cancel();
			this._acceptInvitations.delete(invitationId);
			this.removedAccepted.emit(accepted.get());
		}
	}
	getCreatedInvitations() {
		return [...this._createInvitations.values()].map((i) => i.get());
	}
	getAcceptedInvitations() {
		return [...this._acceptInvitations.values()].map((i) => i.get());
	}
	onPersistentInvitationsLoaded(ctx, callback) {
		if (this._persistentInvitationsLoaded) callback();
		else this._persistentInvitationsLoadedEvent.once(ctx, () => callback());
	}
	_createInvitation(protocol, _options) {
		const { invitationId = PublicKey.random().toHex(), type = Invitation.Type.INTERACTIVE, authMethod = Invitation.AuthMethod.SHARED_SECRET, state = Invitation.State.INIT, timeout = INVITATION_TIMEOUT, swarmKey = PublicKey.random(), persistent = _options?.authMethod !== Invitation.AuthMethod.KNOWN_PUBLIC_KEY, created = /* @__PURE__ */ new Date(), guestKeypair = void 0, role = SpaceMember$1.Role.ADMIN, lifetime = 86400 * 7, multiUse = false, ...options } = _options ?? {};
		return {
			invitationId,
			type,
			authMethod,
			state,
			swarmKey,
			authCode: options?.authCode ?? (authMethod === Invitation.AuthMethod.SHARED_SECRET ? generatePasscode(AUTHENTICATION_CODE_LENGTH) : void 0),
			timeout,
			persistent: persistent && type !== Invitation.Type.DELEGATED,
			guestKeypair: guestKeypair ?? (authMethod === Invitation.AuthMethod.KNOWN_PUBLIC_KEY ? createAdmissionKeypair() : void 0),
			created,
			lifetime,
			role,
			multiUse,
			delegationCredentialId: options?.delegationCredentialId,
			...options,
			...protocol.getInvitationContext()
		};
	}
	_createObservableInvitation(ctx, handler, invitation) {
		const stream = new PushStream();
		const invitationCtx = ctx.derive({ onError: (err) => {
			stream.error(err);
			invitationCtx.dispose();
		} });
		invitationCtx.onDispose(() => {
			log("complete", { ...handler.toJSON() }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$32,
				L: 297,
				S: this
			});
			stream.complete();
		});
		return {
			ctx: invitationCtx,
			stream,
			observableInvitation: new CancellableInvitation({
				initialInvitation: invitation,
				subscriber: stream.observable,
				onCancel: async () => {
					stream.next({
						...invitation,
						state: Invitation.State.CANCELLED
					});
					await invitationCtx.dispose();
				}
			})
		};
	}
	_createObservableAcceptingInvitation(parentCtx, handler, initialState) {
		const otpEnteredTrigger = new Trigger();
		const stream = new PushStream();
		const ctx = parentCtx.derive({ onError: (err) => {
			if (err instanceof TimeoutError) {
				log("timeout", { ...handler.toJSON() }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$32,
					L: 327,
					S: this
				});
				stream.next({
					...initialState,
					state: Invitation.State.TIMEOUT
				});
			} else {
				log.warn("auth failed", err, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$32,
					L: 330,
					S: this
				});
				stream.next({
					...initialState,
					state: Invitation.State.ERROR
				});
			}
			ctx.dispose();
		} });
		ctx.onDispose(() => {
			log("complete", { ...handler.toJSON() }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$32,
				L: 337,
				S: this
			});
			stream.complete();
		});
		return {
			ctx,
			invitation: new AuthenticatingInvitation({
				initialInvitation: initialState,
				subscriber: stream.observable,
				onCancel: async () => {
					stream.next({
						...initialState,
						state: Invitation.State.CANCELLED
					});
					await ctx.dispose();
				},
				onAuthenticate: async (code) => {
					otpEnteredTrigger.wake(code);
				}
			}),
			stream,
			otpEnteredTrigger
		};
	}
	async _persistIfRequired(handler, changeStream, invitation) {
		if (invitation.type === Invitation.Type.DELEGATED && invitation.delegationCredentialId == null) {
			const delegationCredentialId = await handler.delegate(invitation);
			changeStream.next({
				...invitation,
				delegationCredentialId
			});
		} else if (invitation.persistent) {
			await this._metadataStore.addInvitation(invitation);
			this.saved.emit(invitation);
		}
	}
	async _safeDeleteInvitation(invitation) {
		try {
			await this._metadataStore.removeInvitation(invitation.invitationId);
		} catch (err) {
			log.catch(err, void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$32,
				L: 373,
				S: this
			});
		}
	}
	_onInvitationComplete(invitation, callback) {
		invitation.subscribe(() => {}, () => {}, callback);
	}
};
__decorate([trace.span({
	showInBrowserTimeline: true,
	op: "lifecycle"
})], InvitationsManager.prototype, "createInvitation", null);
/**
* Effect Layer constructing an {@link InvitationsManager}.
*
* The invitation handler factory points "up the stack" and is wired via
* {@link InvitationsManager.setInvitationHandlerFactory} after composition.
*/
var InvitationsManagerLayer = () => Layer.effect(InvitationsManagerService, Effect.gen(function* () {
	return new InvitationsManager(yield* InvitationsHandlerService, yield* IMetadataStoreService);
}));
//#endregion
//#region src/packlets/space/auth.ts
var __dxlog_file$31 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/space/auth.ts";
var AuthExtension = class extends RpcExtension {
	_authProps;
	_ctx = new Context({ onError: (err) => {
		log.catch(err, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$31,
			L: 28,
			S: this
		});
	} }, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$31,
		L: 26
	});
	constructor(_authProps) {
		super({
			requested: { AuthService: schema.getService("dxos.mesh.teleport.auth.AuthService") },
			exposed: { AuthService: schema.getService("dxos.mesh.teleport.auth.AuthService") },
			timeout: 60 * 1e3
		});
		this._authProps = _authProps;
	}
	async getHandlers() {
		return { AuthService: { authenticate: async ({ challenge }) => {
			try {
				const credential = await this._authProps.provider(challenge);
				if (!credential) throw new Error("auth rejected");
				return { credential };
			} catch (err) {
				log.error("failed to generate auth credentials", err, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$31,
					L: 55,
					S: this
				});
				throw new Error("auth rejected");
			}
		} } };
	}
	async onOpen(context) {
		await super.onOpen(context);
		scheduleTask(this._ctx, async () => {
			try {
				const challenge = randomBytes(32);
				const { credential } = await this.rpc.AuthService.authenticate({ challenge });
				invariant(credential?.length > 0, "invalid credential", {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$31,
					L: 69,
					S: this,
					A: ["credential?.length > 0", "'invalid credential'"]
				});
				invariant(await this._authProps.verifier(challenge, credential), "credential not verified", {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$31,
					L: 71,
					S: this,
					A: ["success", "'credential not verified'"]
				});
				runInContext(this._ctx, () => this._authProps.onAuthSuccess());
			} catch (err) {
				log("auth failed", err, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$31,
					L: 74,
					S: this
				});
				this.close();
				this._authProps.onAuthFailure();
			}
		});
	}
	async onClose() {
		await this._ctx.dispose();
		await super.onClose();
	}
	async onAbort() {
		await this._ctx.dispose();
		await super.onAbort();
	}
};
//#endregion
//#region src/packlets/pipeline/feeds.ts
var __dxlog_file$30 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/pipeline/feeds.ts";
/**
* Maps the written arguments onto a different message type.
*/
var createMappedFeedWriter = (mapper, writer) => {
	invariant(mapper, void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$30,
		L: 16,
		S: void 0,
		A: ["mapper", ""]
	});
	invariant(writer, void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$30,
		L: 17,
		S: void 0,
		A: ["writer", ""]
	});
	return { write: async (data, options) => await writer.write(await mapper(data), options) };
};
//#endregion
//#region src/packlets/pipeline/message-selector.ts
var __dxlog_file$29 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/pipeline/message-selector.ts";
/**
* The MessageSelector makes sure that we read in a trusted order.
* The first message we wish to process is the SpaceGenesis, which will admit a Feed.
* As we encounter and process FeedAdmit messages those are added to the Space's trust,
* and we begin processing messages from them as well.
*/
var createMessageSelector = (timeframeClock) => {
	return (messages) => {
		for (let i = 0; i < messages.length; i++) {
			const { data: { timeframe } } = messages[i];
			invariant(timeframe, void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$29,
				L: 25,
				S: void 0,
				A: ["timeframe", ""]
			});
			if (!timeframeClock.hasGaps(timeframe)) return i;
		}
		log("Skipping...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$29,
			L: 33,
			S: void 0
		});
	};
};
//#endregion
//#region src/packlets/pipeline/timeframe-clock.ts
var __dxlog_file$28 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/pipeline/timeframe-clock.ts";
var mapFeedIndexesToTimeframe = (indexes) => new Timeframe(indexes.map(({ feedKey, index }) => [feedKey, index]));
var startAfter = (timeframe) => timeframe.frames().map(([feedKey, index]) => ({
	feedKey,
	index: index + 1
}));
/**
* Keeps state of the last timeframe that was processed by ECHO.
*/
var TimeframeClock = class {
	_timeframe;
	update = new Event();
	_pendingTimeframe;
	constructor(_timeframe = new Timeframe()) {
		this._timeframe = _timeframe;
		this._pendingTimeframe = _timeframe;
	}
	/**
	* Timeframe that was processed by ECHO.
	*/
	get timeframe() {
		return this._timeframe;
	}
	/**
	* Timeframe that is currently being processed by ECHO.
	* Will be equal to `timeframe` after the processing is complete.
	*/
	get pendingTimeframe() {
		return this._pendingTimeframe;
	}
	setTimeframe(timeframe) {
		this._timeframe = timeframe;
		this._pendingTimeframe = timeframe;
		this.update.emit(this._timeframe);
	}
	updatePendingTimeframe(key, seq) {
		this._pendingTimeframe = Timeframe.merge(this._pendingTimeframe, new Timeframe([[key, seq]]));
	}
	updateTimeframe() {
		this._timeframe = this._pendingTimeframe;
		this.update.emit(this._timeframe);
	}
	hasGaps(timeframe) {
		return !Timeframe.dependencies(timeframe, this._timeframe).isEmpty();
	}
	async waitUntilReached(target) {
		log("waitUntilReached", {
			target,
			current: this._timeframe
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$28,
			L: 70,
			S: this
		});
		await this.update.waitForCondition(() => {
			log("check if reached", {
				target,
				current: this._timeframe,
				deps: Timeframe.dependencies(target, this._timeframe)
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$28,
				L: 72,
				S: this
			});
			return Timeframe.dependencies(target, this._timeframe).isEmpty();
		});
	}
};
__decorate([timed(5e3)], TimeframeClock.prototype, "waitUntilReached", null);
//#endregion
//#region src/packlets/pipeline/pipeline.ts
var __dxlog_file$27 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/pipeline/pipeline.ts";
/**
* External state accessor.
*/
var PipelineState = class {
	_feeds;
	_timeframeClock;
	/**
	* @internal
	*/
	_ctx = new Context(void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$27,
		L: 41
	});
	get timeframeUpdate() {
		return this._timeframeClock.update;
	}
	stalled = new Event();
	/**
	* @internal
	*/
	_startTimeframe = new Timeframe();
	/**
	* Target timeframe we are waiting to reach.
	*/
	_targetTimeframe;
	/**
	* @internal
	*/
	_reachedTargetPromise;
	/**
	* @internal
	*/
	_reachedTarget = false;
	constructor(_feeds, _timeframeClock) {
		this._feeds = _feeds;
		this._timeframeClock = _timeframeClock;
	}
	/**
	* Latest theoretical timeframe based on the last mutation in each feed.
	* NOTE: This might never be reached if the mutation dependencies
	*/
	get endTimeframe() {
		return mapFeedIndexesToTimeframe(Array.from(this._feeds.values()).filter((feed) => feed.length > 0).map((feed) => ({
			feedKey: feed.key,
			index: feed.length - 1
		})));
	}
	get startTimeframe() {
		return this._startTimeframe;
	}
	get timeframe() {
		return this._timeframeClock.timeframe;
	}
	get pendingTimeframe() {
		return this._timeframeClock.pendingTimeframe;
	}
	get targetTimeframe() {
		return this._targetTimeframe ? this._targetTimeframe : new Timeframe();
	}
	get reachedTarget() {
		return this._reachedTarget;
	}
	get feeds() {
		return Array.from(this._feeds.values());
	}
	async waitUntilTimeframe(target) {
		await this._timeframeClock.waitUntilReached(target);
	}
	setTargetTimeframe(target) {
		this._targetTimeframe = target;
	}
	/**
	* Wait until the pipeline processes all messages in the feed and reaches the target timeframe if that is set.
	*
	* This function will resolve immediately if the pipeline is stalled.
	*
	* @param timeout Timeout in milliseconds to specify the maximum wait time.
	*/
	async waitUntilReachedTargetTimeframe({ ctx = new Context(void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$27,
		L: 131
	}), timeout, breakOnStall = true } = {}) {
		log("waitUntilReachedTargetTimeframe", {
			timeout,
			current: this.timeframe,
			target: this.targetTimeframe
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$27,
			L: 135,
			S: this
		});
		this._reachedTargetPromise ??= Promise.race([this._timeframeClock.update.waitForCondition(() => {
			return Timeframe.dependencies(this.targetTimeframe, this.timeframe).isEmpty();
		}), ...breakOnStall ? [this.stalled.discardParameter().waitForCount(1)] : []]);
		let done = false;
		if (timeout) return Promise.race([
			rejectOnDispose(ctx),
			rejectOnDispose(this._ctx),
			this._reachedTargetPromise.then(() => {
				done = true;
				this._reachedTarget = true;
			}),
			sleepWithContext(this._ctx, timeout).then(() => {
				if (done) return;
				log.warn("waitUntilReachedTargetTimeframe timed out", {
					timeout,
					current: this.timeframe,
					target: this.targetTimeframe,
					dependencies: Timeframe.dependencies(this.targetTimeframe, this.timeframe)
				}, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$27,
					L: 163,
					S: this
				});
			})
		]);
		else return this._reachedTargetPromise;
	}
};
/**
* A multi-reader pipeline that operates on feeds.
* Might have a single writable feed.
* Has a timeframe clock to handle message ordering.
*
* NOTE:
*  - Feeds passed in must have value encoding consistent with the type expected by the iterator/writer.
*
* # Usage examples
*
* ## Create a new space.
*
* 1. Generate space key, genesis feed key.
* 2. Create and open pipeline reading from {}.
* 3. Create and add the writable genesis feed.
* 4. Write the initial sequence of control and credential messages.
*
* ## Load an existing space from storage
*
* 1. Load space key, genesis feed key, get starting timeframe from saved snapshot.
* 2. Create and open pipeline reading from the initial timeframe.
* 3. Open and add the genesis feed.
* 4. Once the writable feed is added, the pipeline becomes writable.
*
* ## Join an existing space created by another agent/device.
*
* 1. Get the space key, genesis feed key from another agent.
* 2. (optionally) Download the snapshot from another agent.
* 3. Create and open pipeline.
* 4. Generate the writable feed key.
* 5. Wait for the writable feed to be added.
*/
var Pipeline = class {
	_timeframeClock = new TimeframeClock(new Timeframe());
	_feeds = new ComplexMap(PublicKey.hash);
	_state = new PipelineState(this._feeds, this._timeframeClock);
	_processingTrigger = new Trigger().wake();
	_pauseTrigger = new Trigger().wake();
	_downloads = new ComplexMap((value) => PublicKey.hash(value.key));
	_feedSetIterator;
	_writer;
	_isStopping = false;
	_isStarted = false;
	_isBeingConsumed = false;
	_isPaused = false;
	get state() {
		return this._state;
	}
	get writer() {
		invariant(this._writer, "Writer not set.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$27,
			L: 245,
			S: this,
			A: ["this._writer", "'Writer not set.'"]
		});
		return this._writer;
	}
	hasFeed(feedKey) {
		return this._feeds.has(feedKey);
	}
	getFeeds() {
		return this._feedSetIterator.feeds;
	}
	async addFeed(feed) {
		this._feeds.set(feed.key, feed);
		if (this._feedSetIterator) await this._feedSetIterator.addFeed(feed);
		if (this._isStarted && !this._isPaused) this._setFeedDownloadState(feed);
	}
	setWriteFeed(feed) {
		invariant(!this._writer, "Writer already set.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$27,
			L: 272,
			S: this,
			A: ["!this._writer", "'Writer already set.'"]
		});
		invariant(feed.properties.writable, "Feed must be writable.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$27,
			L: 273,
			S: this,
			A: ["feed.properties.writable", "'Feed must be writable.'"]
		});
		this._writer = createMappedFeedWriter((payload) => ({
			timeframe: this._timeframeClock.timeframe,
			payload
		}), feed.createFeedWriter());
	}
	async start() {
		invariant(!this._isStarted, "Pipeline is already started.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$27,
			L: 286,
			S: this,
			A: ["!this._isStarted", "'Pipeline is already started.'"]
		});
		log("starting...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$27,
			L: 287,
			S: this
		});
		await this._initIterator();
		await this._feedSetIterator.open();
		this._isStarted = true;
		log("started", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$27,
			L: 291,
			S: this
		});
		if (!this._isPaused) for (const feed of this._feeds.values()) this._setFeedDownloadState(feed);
	}
	async stop() {
		log("stopping...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$27,
			L: 302,
			S: this
		});
		this._isStopping = true;
		for (const [feed, handle] of this._downloads.entries()) feed.undownload(handle);
		this._downloads.clear();
		await this._feedSetIterator?.close();
		await this._processingTrigger.wait();
		await this._state._ctx.dispose();
		this._state._ctx = new Context(void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$27,
			L: 311
		});
		this._state._reachedTargetPromise = void 0;
		this._state._reachedTarget = false;
		this._isStarted = false;
		log("stopped", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$27,
			L: 315,
			S: this
		});
	}
	/**
	* @param timeframe Timeframe of already processed messages.
	*  The pipeline will start processing messages AFTER this timeframe.
	*/
	async setCursor(timeframe) {
		invariant(!this._isStarted || this._isPaused, "Invalid state.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$27,
			L: 324,
			S: this,
			A: ["!this._isStarted || this._isPaused", "'Invalid state.'"]
		});
		this._state._startTimeframe = timeframe;
		this._timeframeClock.setTimeframe(timeframe);
		if (this._feedSetIterator) {
			await this._feedSetIterator.close();
			await this._initIterator();
			await this._feedSetIterator.open();
		}
	}
	/**
	* Calling pause while processing will cause a deadlock.
	*/
	async pause() {
		if (this._isPaused) return;
		this._pauseTrigger.reset();
		await this._processingTrigger.wait();
		this._isPaused = true;
	}
	async unpause() {
		invariant(this._isPaused, "Pipeline is not paused.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$27,
			L: 353,
			S: this,
			A: ["this._isPaused", "'Pipeline is not paused.'"]
		});
		this._pauseTrigger.wake();
		this._isPaused = false;
		for (const feed of this._feeds.values()) this._setFeedDownloadState(feed);
	}
	/**
	* Starts to iterate over the ordered messages from the added feeds.
	* Updates the timeframe clock after the message has bee processed.
	*/
	async *consume() {
		invariant(!this._isBeingConsumed, "Pipeline is already being consumed.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$27,
			L: 368,
			S: this,
			A: ["!this._isBeingConsumed", "'Pipeline is already being consumed.'"]
		});
		this._isBeingConsumed = true;
		invariant(this._feedSetIterator, "Iterator not initialized.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$27,
			L: 371,
			S: this,
			A: ["this._feedSetIterator", "'Iterator not initialized.'"]
		});
		let lastFeedSetIterator = this._feedSetIterator;
		let iterable = lastFeedSetIterator[Symbol.asyncIterator]();
		while (!this._isStopping) {
			await this._pauseTrigger.wait();
			if (lastFeedSetIterator !== this._feedSetIterator) {
				invariant(this._feedSetIterator, "Iterator not initialized.", {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$27,
					L: 380,
					S: this,
					A: ["this._feedSetIterator", "'Iterator not initialized.'"]
				});
				lastFeedSetIterator = this._feedSetIterator;
				iterable = lastFeedSetIterator[Symbol.asyncIterator]();
			}
			const { done, value } = await iterable.next();
			if (!done) {
				const block = value ?? failUndefined();
				this._processingTrigger.reset();
				this._timeframeClock.updatePendingTimeframe(PublicKey.from(block.feedKey), block.seq);
				yield block;
				this._processingTrigger.wake();
				this._timeframeClock.updateTimeframe();
			}
		}
		this._isBeingConsumed = false;
	}
	_setFeedDownloadState(feed) {
		let handle = this._downloads.get(feed);
		if (handle) feed.undownload(handle);
		const seq = this._state._startTimeframe.get(feed.key) ?? -1;
		log("download", {
			feed: feed.key.truncate(),
			seq,
			length: feed.length
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$27,
			L: 409,
			S: this
		});
		handle = feed.download({
			start: seq + 1,
			linear: true
		}, (err, data) => {
			if (err) {} else log("downloaded", { data }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$27,
				L: 414,
				S: this
			});
		});
		this._downloads.set(feed, handle);
	}
	async _initIterator() {
		this._feedSetIterator = new FeedSetIterator(createMessageSelector(this._timeframeClock), {
			start: startAfter(this._timeframeClock.timeframe),
			stallTimeout: 1e3
		});
		this._feedSetIterator.stalled.on((iterator) => {
			log.warn(`Stalled after ${iterator.options.stallTimeout}ms with ${iterator.size} feeds.`, {
				currentTimeframe: this._timeframeClock.timeframe,
				targetTimeframe: this._state.targetTimeframe
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$27,
				L: 428,
				S: this
			});
			this._state.stalled.emit();
		});
		for (const feed of this._feeds.values()) await this._feedSetIterator.addFeed(feed);
	}
};
__decorate([synchronized], Pipeline.prototype, "start", null);
__decorate([synchronized], Pipeline.prototype, "stop", null);
__decorate([synchronized], Pipeline.prototype, "setCursor", null);
__decorate([synchronized], Pipeline.prototype, "pause", null);
__decorate([synchronized], Pipeline.prototype, "unpause", null);
/**
* Value encoding used by feed store.
*/
var valueEncoding = createCodecEncoding(schema.getCodecForType("dxos.echo.feed.FeedMessage"));
//#endregion
//#region src/packlets/space/control-pipeline.ts
var __dxlog_file$26 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/space/control-pipeline.ts";
var TIMEFRAME_SAVE_DEBOUNCE_INTERVAL = 500;
var CONTROL_PIPELINE_SNAPSHOT_DELAY = 1e4;
var ControlPipeline = class ControlPipeline {
	_ctx = new Context(void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$26,
		L: 46
	});
	_pipeline;
	_spaceStateMachine;
	_spaceKey;
	_metadata;
	_targetTimeframe;
	_lastTimeframeSaveTime = Date.now();
	onFeedAdmitted = new Callback();
	onMemberRoleChanged;
	onCredentialProcessed;
	onDelegatedInvitation;
	onDelegatedInvitationRemoved;
	_snapshotTask = new DeferredTask(this._ctx, async () => {
		await sleepWithContext(this._ctx, CONTROL_PIPELINE_SNAPSHOT_DELAY);
		await this._saveSnapshot();
	});
	constructor({ spaceKey, genesisFeed, feedProvider, metadataStore }) {
		this._spaceKey = spaceKey;
		this._metadata = metadataStore;
		this._pipeline = new Pipeline();
		this._pipeline.addFeed(genesisFeed);
		this._spaceStateMachine = new SpaceStateMachine(spaceKey);
		this._spaceStateMachine.onFeedAdmitted.set(async (info) => {
			log("feed admitted", { key: info.key }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$26,
				L: 75,
				S: this
			});
			if (info.assertion.designation === AdmittedFeed.Designation.CONTROL && !info.key.equals(genesisFeed.key)) scheduleMicroTask(this._ctx, async () => {
				try {
					const feed = await feedProvider(info.key);
					if (this._ctx.disposed) return;
					if (!this._pipeline.hasFeed(feed.key)) await this._pipeline.addFeed(feed);
				} catch (err) {
					log.catch(err, void 0, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$26,
						L: 89,
						S: this
					});
				}
			});
			await this.onFeedAdmitted.callIfSet(info);
		});
		this.onMemberRoleChanged = this._spaceStateMachine.onMemberRoleChanged;
		this.onCredentialProcessed = this._spaceStateMachine.onCredentialProcessed;
		this.onDelegatedInvitation = this._spaceStateMachine.onDelegatedInvitation;
		this.onDelegatedInvitationRemoved = this._spaceStateMachine.onDelegatedInvitationRemoved;
	}
	get spaceState() {
		return this._spaceStateMachine;
	}
	get pipeline() {
		return this._pipeline;
	}
	async setWriteFeed(feed) {
		await this._pipeline.addFeed(feed);
		this._pipeline.setWriteFeed(feed);
	}
	async start(ctx) {
		const snapshot = this._metadata.getSpaceControlPipelineSnapshot(this._spaceKey);
		log("load snapshot", {
			key: this._spaceKey,
			present: !!snapshot,
			tf: snapshot?.timeframe
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$26,
			L: 119,
			S: this
		});
		if (snapshot) await this._processSnapshot(snapshot);
		log("starting...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$26,
			L: 124,
			S: this
		});
		setTimeout(async () => {
			this._consumePipeline(ctx);
		});
		await this._pipeline.start();
		log("started", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$26,
			L: 130,
			S: this
		});
	}
	async _processSnapshot(snapshot) {
		await this._pipeline.setCursor(snapshot.timeframe);
		for (const message of snapshot.messages ?? []) if (!await this._spaceStateMachine.process(message.credential, {
			sourceFeed: message.feedKey,
			skipVerification: true
		})) log.warn("credential processing failed from snapshot", { message }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$26,
			L: 143,
			S: this
		});
	}
	async _saveSnapshot() {
		await this._pipeline.pause();
		const snapshot = {
			timeframe: this._pipeline.state.timeframe,
			messages: this._spaceStateMachine.credentialEntries.map((entry) => ({
				feedKey: entry.sourceFeed,
				credential: entry.credential
			}))
		};
		await this._pipeline.unpause();
		log("save snapshot", {
			key: this._spaceKey,
			snapshot: getSnapshotLoggerContext(snapshot)
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$26,
			L: 159,
			S: this
		});
		await this._metadata.setSpaceControlPipelineSnapshot(this._spaceKey, snapshot);
	}
	async _consumePipeline(ctx) {
		for await (const msg of this._pipeline.consume()) try {
			await this._processMessage(ctx, msg);
		} catch (err) {
			log.catch(err, void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$26,
				L: 168,
				S: this
			});
		}
	}
	async _processMessage(ctx, msg) {
		log("processing", {
			key: msg.feedKey,
			seq: msg.seq
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$26,
			L: 175,
			S: this
		});
		if (msg.data.payload.credential) {
			const timer = tracer.mark("dxos.echo.pipeline.control");
			const result = await this._spaceStateMachine.process(msg.data.payload.credential.credential, { sourceFeed: PublicKey.from(msg.feedKey) });
			timer.end();
			if (!result) log.warn("processing failed", { msg }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$26,
				L: 184,
				S: this
			});
			else await this._noteTargetStateIfNeeded(this._pipeline.state.pendingTimeframe);
			this._snapshotTask.schedule();
		}
	}
	async _noteTargetStateIfNeeded(timeframe) {
		if (Date.now() - this._lastTimeframeSaveTime > TIMEFRAME_SAVE_DEBOUNCE_INTERVAL) {
			this._lastTimeframeSaveTime = Date.now();
			await this._saveTargetTimeframe(timeframe);
		}
	}
	async stop() {
		log("stopping...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$26,
			L: 204,
			S: this
		});
		await this._ctx.dispose();
		await this._pipeline.stop();
		await this._saveTargetTimeframe(this._pipeline.state.timeframe);
		log("stopped", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$26,
			L: 208,
			S: this
		});
	}
	async _saveTargetTimeframe(timeframe) {
		try {
			const newTimeframe = Timeframe.merge(this._targetTimeframe ?? new Timeframe(), timeframe);
			await this._metadata.setSpaceControlLatestTimeframe(this._spaceKey, newTimeframe);
			this._targetTimeframe = newTimeframe;
		} catch (err) {
			log(err, void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$26,
				L: 217,
				S: this
			});
		}
	}
};
__decorate([trace.span({
	showInBrowserTimeline: true,
	op: "lifecycle"
})], ControlPipeline.prototype, "start", null);
__decorate([trace.span({
	showInBrowserTimeline: true,
	showInRemoteTracing: false
})], ControlPipeline.prototype, "_processMessage", null);
ControlPipeline = __decorate([trackLeaks("start", "stop")], ControlPipeline);
var getSnapshotLoggerContext = (snapshot) => {
	return snapshot.messages?.map((msg) => {
		return {
			issuer: msg.credential.issuer,
			subject: msg.credential.subject.id,
			type: msg.credential.subject.assertion["@type"]
		};
	});
};
//#endregion
//#region src/packlets/space/space.ts
var __dxlog_file$25 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/space/space.ts";
var Space = class Space extends Resource {
	onCredentialProcessed = new Callback();
	stateUpdate = new Event();
	protocol;
	_id;
	_key;
	_genesisFeedKey;
	_feedProvider;
	_controlPipeline;
	_controlFeed;
	_dataFeed;
	constructor(params) {
		super();
		invariant(params.spaceKey && params.feedProvider, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$25,
			L: 69,
			S: this,
			A: ["params.spaceKey && params.feedProvider", ""]
		});
		this._id = params.id;
		this._key = params.spaceKey;
		this._genesisFeedKey = params.genesisFeed.key;
		this._feedProvider = params.feedProvider;
		this._controlPipeline = new ControlPipeline({
			spaceKey: params.spaceKey,
			genesisFeed: params.genesisFeed,
			feedProvider: params.feedProvider,
			metadataStore: params.metadataStore
		});
		this._controlPipeline.onFeedAdmitted.set(async (info) => {
			const sparse = info.assertion.designation === AdmittedFeed.Designation.DATA;
			if (!info.key.equals(params.genesisFeed.key)) scheduleMicroTask(this._ctx, async () => {
				await this.protocol.addFeed(await params.feedProvider(info.key, { sparse }));
			});
		});
		this._controlPipeline.onCredentialProcessed.set(async (credential) => {
			await this.onCredentialProcessed.callIfSet(credential);
			log("onCredentialProcessed", { credential }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$25,
				L: 96,
				S: this
			});
			this.stateUpdate.emit();
		});
		this._controlPipeline.onDelegatedInvitation.set(async (invitation) => {
			log("onDelegatedInvitation", { invitation }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$25,
				L: 100,
				S: this
			});
			await params.onDelegatedInvitationStatusChange(invitation, true);
		});
		this._controlPipeline.onDelegatedInvitationRemoved.set(async (invitation) => {
			log("onDelegatedInvitationRemoved", { invitation }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$25,
				L: 104,
				S: this
			});
			await params.onDelegatedInvitationStatusChange(invitation, false);
		});
		this._controlPipeline.onMemberRoleChanged.set(async (changedMembers) => {
			log("onMemberRoleChanged", () => ({ changedMembers: changedMembers.map((m) => [m.key, m.role]) }), {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$25,
				L: 108,
				S: this
			});
			await params.onMemberRolesChanged(changedMembers);
		});
		this.protocol = params.protocol;
	}
	get id() {
		return this._id;
	}
	get key() {
		return this._key;
	}
	get genesisFeedKey() {
		return this._genesisFeedKey;
	}
	get controlFeedKey() {
		return this._controlFeed?.key;
	}
	get dataFeedKey() {
		return this._dataFeed?.key;
	}
	get spaceState() {
		return this._controlPipeline.spaceState;
	}
	/**
	* @test-only
	*/
	get controlPipeline() {
		return this._controlPipeline.pipeline;
	}
	async setControlFeed(feed) {
		invariant(!this._controlFeed, "Control feed already set.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$25,
			L: 150,
			S: this,
			A: ["!this._controlFeed", "'Control feed already set.'"]
		});
		this._controlFeed = feed;
		await this._controlPipeline.setWriteFeed(feed);
		return this;
	}
	async setDataFeed(feed) {
		invariant(!this._dataFeed, "Data feed already set.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$25,
			L: 157,
			S: this,
			A: ["!this._dataFeed", "'Data feed already set.'"]
		});
		this._dataFeed = feed;
		return this;
	}
	/**
	* Use for diagnostics.
	*/
	getControlFeeds() {
		return Array.from(this._controlPipeline.spaceState.feeds.values());
	}
	async _open(ctx) {
		log("opening...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$25,
			L: 171,
			S: this
		});
		await this._controlPipeline.start(ctx);
		log("opened", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$25,
			L: 176,
			S: this
		});
	}
	async startProtocol(ctx) {
		invariant(this.isOpen, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$25,
			L: 181,
			S: this,
			A: ["this.isOpen", ""]
		});
		await this.protocol.start(ctx);
		await this.protocol.addFeed(await this._feedProvider(this._genesisFeedKey));
	}
	async _close(ctx) {
		log("closing...", { key: this._key }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$25,
			L: 188,
			S: this
		});
		await this.protocol.stop(ctx);
		await this._controlPipeline.stop();
		log("closed", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$25,
			L: 194,
			S: this
		});
	}
};
__decorate([logInfo], Space.prototype, "id", null);
__decorate([logInfo], Space.prototype, "key", null);
__decorate([trace.span({ op: "lifecycle" })], Space.prototype, "_open", null);
__decorate([synchronized], Space.prototype, "startProtocol", null);
__decorate([synchronized], Space.prototype, "_close", null);
Space = __decorate([trackLeaks("open", "close")], Space);
//#endregion
//#region src/packlets/space/admission-discovery-extension.ts
var __dxlog_file$24 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/space/admission-discovery-extension.ts";
/**
* Guest's side for a connection to a concrete peer in p2p network during invitation.
*/
var CredentialRetrieverExtension = class extends RpcExtension {
	_request;
	_onResult;
	_ctx = new Context(void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$24,
		L: 26
	});
	constructor(_request, _onResult) {
		super({ requested: { AdmissionDiscoveryService: schema.getService("dxos.mesh.teleport.AdmissionDiscoveryService") } });
		this._request = _request;
		this._onResult = _onResult;
	}
	async getHandlers() {
		return {};
	}
	async onOpen(context) {
		await super.onOpen(context);
		scheduleTask(this._ctx, async () => {
			try {
				const result = await this.rpc.AdmissionDiscoveryService.getAdmissionCredential(this._request);
				this._onResult.wake(result.admissionCredential);
			} catch (err) {
				context.close(err);
			}
		});
	}
	async onClose() {
		await this._ctx.dispose();
	}
	async onAbort() {
		await this._ctx.dispose();
	}
};
var CredentialServerExtension = class extends RpcExtension {
	_space;
	constructor(_space) {
		super({ exposed: { AdmissionDiscoveryService: schema.getService("dxos.mesh.teleport.AdmissionDiscoveryService") } });
		this._space = _space;
	}
	async getHandlers() {
		return { AdmissionDiscoveryService: { getAdmissionCredential: async (request) => {
			const memberInfo = this._space.spaceState.members.get(request.memberKey);
			if (!memberInfo?.credential) throw new ProtocolError({
				message: "Space member not found.",
				context: { ...request }
			});
			return { admissionCredential: memberInfo.credential };
		} } };
	}
};
//#endregion
//#region src/packlets/space/space-protocol.ts
var __dxlog_file$23 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/space/space-protocol.ts";
var MOCK_AUTH_PROVIDER = async (nonce) => Buffer.from("mock");
var MOCK_AUTH_VERIFIER = async (nonce, credential) => true;
/**
* Manages Teleport protocol stream creation and joining swarms with replication and presence extensions.
*/
var SpaceProtocol = class {
	_networkManager;
	_swarmIdentity;
	_onSessionAuth;
	_onAuthFailure;
	blobSync;
	_disableP2pReplication;
	_topic;
	_spaceKey;
	_feeds = /* @__PURE__ */ new Set();
	_sessions = new ComplexMap(PublicKey.hash);
	_topology = new MMSTTopology({
		originateConnections: 4,
		maxPeers: 10,
		sampleSize: 20
	});
	_connection;
	feedAdded = new CallbackCollection();
	get sessions() {
		return this._sessions;
	}
	get feeds() {
		return this._feeds;
	}
	get _ownPeerKey() {
		return this._swarmIdentity.peerKey;
	}
	constructor({ topic, swarmIdentity, networkManager, onSessionAuth, onAuthFailure, blobStore, disableP2pReplication }) {
		this._spaceKey = topic;
		this._networkManager = networkManager;
		this._swarmIdentity = swarmIdentity;
		this._onSessionAuth = onSessionAuth;
		this._onAuthFailure = onAuthFailure;
		this.blobSync = new BlobSync({ blobStore });
		this._topic = createIdFromSpaceKey(topic).then((spaceId) => PublicKey.from(SpaceId.decode(spaceId)));
		this._disableP2pReplication = disableP2pReplication ?? false;
	}
	async addFeed(feed) {
		log("addFeed", { key: feed.key }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$23,
			L: 128,
			S: this
		});
		this._feeds.add(feed);
		for (const session of this._sessions.values()) session.replicator.addFeed(feed);
		await this.feedAdded.callSerial(feed);
	}
	async start(ctx) {
		if (this._connection) return;
		const credentials = await this._swarmIdentity.credentialProvider(Buffer.from(""));
		await this.blobSync.open();
		log("starting...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$23,
			L: 149,
			S: this
		});
		const topic = await this._topic;
		this._connection = await this._networkManager.joinSwarm(ctx, {
			protocolProvider: this._createProtocolProvider(credentials),
			topic,
			topology: this._topology,
			label: `swarm ${topic.truncate()} for space ${this._spaceKey.truncate()}`
		});
		log("started", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$23,
			L: 158,
			S: this
		});
	}
	updateTopology() {
		this._topology.forceUpdate();
	}
	async stop(ctx) {
		await this.blobSync.close();
		if (this._connection) {
			log("stopping...", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$23,
				L: 169,
				S: this
			});
			await this._connection.close(ctx);
			log("stopped", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$23,
				L: 171,
				S: this
			});
		}
	}
	_createProtocolProvider(credentials) {
		return (wireProps) => {
			const session = new SpaceProtocolSession({
				wireProps,
				swarmIdentity: this._swarmIdentity,
				onSessionAuth: this._onSessionAuth,
				onAuthFailure: this._onAuthFailure,
				blobSync: this.blobSync,
				disableP2pReplication: this._disableP2pReplication
			});
			this._sessions.set(wireProps.remotePeerId, session);
			for (const feed of this._feeds) session.replicator.addFeed(feed);
			return session;
		};
	}
};
__decorate([logInfo], SpaceProtocol.prototype, "_topic", void 0);
__decorate([logInfo], SpaceProtocol.prototype, "_ownPeerKey", null);
var AuthStatus = /* @__PURE__ */ function(AuthStatus) {
	AuthStatus["INITIAL"] = "INITIAL";
	AuthStatus["SUCCESS"] = "SUCCESS";
	AuthStatus["FAILURE"] = "FAILURE";
	return AuthStatus;
}({});
/**
* Represents a single connection to a remote peer
*/
var SpaceProtocolSession = class {
	_wireProps;
	_disableP2pReplication;
	_onSessionAuth;
	_onAuthFailure;
	_swarmIdentity;
	_blobSync;
	_teleport;
	replicator = new ReplicatorExtension().setOptions({ upload: true });
	_authStatus = "INITIAL";
	get authStatus() {
		return this._authStatus;
	}
	get stats() {
		return this._teleport.stats;
	}
	constructor({ wireProps, swarmIdentity, onSessionAuth, onAuthFailure, blobSync, disableP2pReplication }) {
		this._wireProps = wireProps;
		this._swarmIdentity = swarmIdentity;
		this._onSessionAuth = onSessionAuth;
		this._onAuthFailure = onAuthFailure;
		this._blobSync = blobSync;
		this._teleport = new Teleport(wireProps);
		this._disableP2pReplication = disableP2pReplication ?? false;
	}
	get stream() {
		return this._teleport.stream;
	}
	async open(sessionId) {
		await this._teleport.open(sessionId);
		this._teleport.addExtension("dxos.mesh.teleport.auth", new AuthExtension({
			provider: this._swarmIdentity.credentialProvider,
			verifier: this._swarmIdentity.credentialAuthenticator,
			onAuthSuccess: () => {
				log("Peer authenticated", void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$23,
					L: 282,
					S: this
				});
				this._authStatus = "SUCCESS";
				this._onSessionAuth?.(this._teleport);
			},
			onAuthFailure: () => {
				this._authStatus = "FAILURE";
				this._onAuthFailure?.(this._teleport);
			}
		}));
		if (!this._disableP2pReplication) this._teleport.addExtension("dxos.mesh.teleport.replicator", this.replicator);
		this._teleport.addExtension("dxos.mesh.teleport.blobsync", this._blobSync.createExtension());
	}
	async close() {
		log("close", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$23,
			L: 301,
			S: this
		});
		await this._teleport.close();
	}
	async abort() {
		await this._teleport.abort();
	}
};
__decorate([logInfo], SpaceProtocolSession.prototype, "_wireProps", void 0);
__decorate([logInfo], SpaceProtocolSession.prototype, "authStatus", null);
//#endregion
//#region src/packlets/space/space-manager.ts
var __dxlog_file$22 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/space/space-manager.ts";
/**
* Effect service tag for {@link SpaceManager}.
*/
var SpaceManagerService = class extends EffectContext.Tag("@dxos/client-services/SpaceManager")() {};
var SpaceManager = class SpaceManager {
	_spaces = new ComplexMap(PublicKey.hash);
	_feedStore;
	_networkManager;
	_metadataStore;
	_blobStore;
	_disableP2pReplication;
	constructor({ feedStore, networkManager, metadataStore, blobStore, disableP2pReplication }) {
		this._feedStore = feedStore;
		this._networkManager = networkManager;
		this._metadataStore = metadataStore;
		this._blobStore = blobStore;
		this._disableP2pReplication = disableP2pReplication ?? false;
	}
	get spaces() {
		return this._spaces;
	}
	async open() {}
	async close() {
		await Promise.all([...this._spaces.values()].map((space) => space.close()));
	}
	async constructSpace({ metadata, swarmIdentity, onAuthorizedConnection, onAuthFailure, onDelegatedInvitationStatusChange, onMemberRolesChanged, memberKey }) {
		log("constructing space...", { spaceKey: metadata.genesisFeedKey }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$22,
			L: 112,
			S: this
		});
		const genesisFeed = await this._feedStore.openFeed(metadata.genesisFeedKey ?? failUndefined());
		const spaceKey = metadata.key;
		const space = new Space({
			id: await createIdFromSpaceKey(spaceKey),
			spaceKey,
			protocol: new SpaceProtocol({
				topic: spaceKey,
				swarmIdentity,
				networkManager: this._networkManager,
				onSessionAuth: onAuthorizedConnection,
				onAuthFailure,
				blobStore: this._blobStore,
				disableP2pReplication: this._disableP2pReplication
			}),
			genesisFeed,
			feedProvider: (feedKey, opts) => this._feedStore.openFeed(feedKey, opts),
			metadataStore: this._metadataStore,
			memberKey,
			onDelegatedInvitationStatusChange,
			onMemberRolesChanged
		});
		this._spaces.set(space.key, space);
		return space;
	}
	async requestSpaceAdmissionCredential(ctx, params) {
		log("requesting space admission credential...", { spaceKey: params.spaceKey }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$22,
			L: 149,
			S: this
		});
		const onCredentialResolved = new Trigger();
		const protocol = new SpaceProtocol({
			topic: params.spaceKey,
			swarmIdentity: params.swarmIdentity,
			networkManager: this._networkManager,
			onSessionAuth: (session) => {
				session.addExtension("dxos.mesh.teleport.admission-discovery", new CredentialRetrieverExtension({
					spaceKey: params.spaceKey,
					memberKey: params.identityKey
				}, onCredentialResolved));
			},
			onAuthFailure: (session) => session.close(),
			blobStore: this._blobStore,
			disableP2pReplication: this._disableP2pReplication
		});
		try {
			await protocol.start(ctx);
			return await onCredentialResolved.wait({ timeout: params.timeout });
		} catch (err) {
			throw err;
		} finally {
			await protocol.stop(ctx);
		}
	}
	findSpaceByRootDocumentId(documentId) {
		return [...this._spaces.values()].find((space) => {
			return space.spaceState.credentials.some((credential) => {
				const assertion = getCredentialAssertion(credential);
				if (assertion["@type"] !== "dxos.halo.credentials.Epoch") return false;
				if (!assertion?.automergeRoot) return false;
				return parseAutomergeUrl(assertion.automergeRoot).documentId === documentId;
			});
		});
	}
};
__decorate([synchronized], SpaceManager.prototype, "open", null);
__decorate([synchronized], SpaceManager.prototype, "close", null);
SpaceManager = __decorate([trackLeaks("open", "close")], SpaceManager);
/**
* Effect Layer constructing a {@link SpaceManager} from ambient service dependencies.
*/
var SpaceManagerLayer = (options = {}) => Layer.effect(SpaceManagerService, Effect.gen(function* () {
	const feedStore = yield* FeedStoreService;
	const networkManager = yield* SwarmNetworkManagerService;
	const metadataStore = yield* IMetadataStoreService;
	const blobStore = yield* BlobStoreApiService;
	return new SpaceManager({
		feedStore,
		networkManager,
		metadataStore,
		blobStore,
		disableP2pReplication: options.disableP2pReplication
	});
}));
//#endregion
//#region src/packlets/spaces/automerge-space-state.ts
var AutomergeSpaceState = class extends Resource {
	_onNewRoot;
	rootUrl = void 0;
	lastEpoch = void 0;
	onNewEpoch = new Event();
	_isProcessingRootDocs = false;
	constructor(_onNewRoot) {
		super();
		this._onNewRoot = _onNewRoot;
	}
	async _open(ctx) {}
	async _close(ctx) {
		this._isProcessingRootDocs = false;
	}
	async processCredential(credential) {
		if (!checkCredentialType(credential, "dxos.halo.credentials.Epoch")) return;
		this.lastEpoch = credential;
		if (credential.subject.assertion.automergeRoot) {
			this.rootUrl = credential.subject.assertion.automergeRoot;
			if (this._isProcessingRootDocs) this._onNewRoot(this.rootUrl);
		}
		this.onNewEpoch.emit(credential);
	}
	startProcessingRootDocs() {
		if (this._isProcessingRootDocs) return;
		if (this.rootUrl) this._onNewRoot(this.rootUrl);
		this._isProcessingRootDocs = true;
	}
	async ensureEpochInitialized() {
		await this.onNewEpoch.waitForCondition(() => !!this.lastEpoch);
	}
};
//#endregion
//#region \0@oxc-project+runtime@0.139.0/helpers/esm/usingCtx.js
function _usingCtx() {
	var r = "function" == typeof SuppressedError ? SuppressedError : function(r, e) {
		var n = Error();
		return n.name = "SuppressedError", n.error = r, n.suppressed = e, n;
	}, e = {}, n = [];
	function using(r, e) {
		if (null != e) {
			if (Object(e) !== e) throw new TypeError("using declarations can only be used with objects, functions, null, or undefined.");
			if (r) var o = e[Symbol.asyncDispose || Symbol["for"]("Symbol.asyncDispose")];
			if (void 0 === o && (o = e[Symbol.dispose || Symbol["for"]("Symbol.dispose")], r)) var t = o;
			if ("function" != typeof o) throw new TypeError("Object is not disposable.");
			t && (o = function o() {
				try {
					t.call(e);
				} catch (r) {
					return Promise.reject(r);
				}
			}), n.push({
				v: e,
				d: o,
				a: r
			});
		} else r && n.push({
			d: e,
			a: r
		});
		return e;
	}
	return {
		e,
		u: using.bind(null, !1),
		a: using.bind(null, !0),
		d: function d() {
			var o, t = this.e, s = 0;
			function next() {
				for (; o = n.pop();) try {
					if (!o.a && 1 === s) return s = 0, n.push(o), Promise.resolve().then(next);
					if (o.d) {
						var r = o.d.call(o.v);
						if (o.a) return s |= 2, Promise.resolve(r).then(next, err);
					} else s |= 1;
				} catch (r) {
					return err(r);
				}
				if (1 === s) return t !== e ? Promise.reject(t) : Promise.resolve();
				if (t !== e) throw t;
			}
			function err(n) {
				return t = t !== e ? new r(n, t) : n, next();
			}
			return next();
		}
	};
}
//#endregion
//#region src/packlets/spaces/edge-feed-replicator.ts
var __dxlog_file$21 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/spaces/edge-feed-replicator.ts";
var EdgeFeedReplicator = class extends Resource {
	_messenger;
	_spaceId;
	_feeds = new ComplexMap(PublicKey.hash);
	_connectionCtx = void 0;
	_connected = false;
	/**
	* Feed length at service.
	*/
	_remoteLength = new ComplexMap(PublicKey.hash);
	/**
	* Protects against concurrent pushes so that remote length is updated consistently.
	*/
	_pushMutex = new ComplexMap(PublicKey.hash);
	constructor({ messenger, spaceId }) {
		super();
		this._messenger = messenger;
		this._spaceId = spaceId;
	}
	async _open() {
		log("open", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$21,
			L: 57,
			S: this
		});
		this._ctx.onDispose(this._messenger.onMessage((message) => {
			if (!message.serviceId) return;
			const [service, ...rest] = message.serviceId.split(":");
			if (service !== EdgeService.FEED_REPLICATOR) return;
			const [spaceId] = rest;
			if (spaceId !== this._spaceId) {
				log("spaceID mismatch", {
					spaceId,
					_spaceId: this._spaceId
				}, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$21,
					L: 71,
					S: this
				});
				return;
			}
			const payload = decode(message.payload.value);
			log("receive", {
				from: message.source,
				feedKey: payload.feedKey,
				type: payload.type
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$21,
				L: 76,
				S: this
			});
			this._onMessage(payload);
		}));
		this._ctx.onDispose(this._messenger.onReconnected(() => {
			scheduleMicroTask(this._ctx, () => this._handleReconnect());
		}));
	}
	async _handleReconnect() {
		await this._resetConnection();
		if (this._messenger.status.state === EdgeStatus.ConnectionState.CONNECTED) this._startReplication();
	}
	async _close() {
		log("close", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$21,
			L: 96,
			S: this
		});
		await this._resetConnection();
	}
	_startReplication() {
		this._connected = true;
		const connectionCtx = this._createConnectionContext();
		this._connectionCtx = connectionCtx;
		log("connection context created", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$21,
			L: 104,
			S: this
		});
		scheduleMicroTask(connectionCtx, async () => {
			for (const feed of this._feeds.values()) await this._replicateFeed(connectionCtx, feed);
		});
	}
	async _resetConnection() {
		log("resetConnection", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$21,
			L: 113,
			S: this
		});
		this._connected = false;
		await this._connectionCtx?.dispose();
		this._connectionCtx = void 0;
		this._remoteLength.clear();
	}
	async addFeed(feed) {
		log("addFeed", {
			key: feed.key,
			connected: this._connected,
			hasConnectionCtx: !!this._connectionCtx
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$21,
			L: 121,
			S: this
		});
		this._feeds.set(feed.key, feed);
		if (this._connected && this._connectionCtx) await this._replicateFeed(this._connectionCtx, feed);
	}
	_getPushMutex(key) {
		return defaultMap(this._pushMutex, key, () => new Mutex());
	}
	async _replicateFeed(ctx, feed) {
		log("replicateFeed", { key: feed.key }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$21,
			L: 134,
			S: this
		});
		await this._sendMessage(ctx, {
			type: "get-metadata",
			feedKey: feed.key.toHex()
		});
		Event.wrap(feed.core, "append").on(ctx, async () => {
			await this._pushBlocksIfNeeded(feed);
		});
	}
	async _sendMessage(ctx, message) {
		if (!this._connectionCtx) {
			log("message dropped because connection was disposed", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$21,
				L: 147,
				S: this
			});
			return;
		}
		if (message.type === "data") log("sending blocks", {
			feedKey: message.feedKey,
			blocks: message.blocks.map((b) => b.index)
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$21,
			L: 152,
			S: this
		});
		invariant(message.feedKey, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$21,
			L: 158,
			S: this,
			A: ["message.feedKey", ""]
		});
		const payloadValue = bufferToArray(encode(message));
		log("send", { type: message.type }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$21,
			L: 161,
			S: this
		});
		await this._messenger.send(ctx, buf.create(MessageSchema$1, {
			source: {
				identityDid: this._messenger.identityDid,
				peerKey: this._messenger.peerKey
			},
			serviceId: `${EdgeService.FEED_REPLICATOR}:${this._spaceId}`,
			payload: { value: payloadValue }
		}));
	}
	_onMessage(message) {
		if (!this._connectionCtx) {
			log.warn("received message after connection context was disposed", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$21,
				L: 177,
				S: this
			});
			return;
		}
		scheduleMicroTask(this._connectionCtx, async () => {
			switch (message.type) {
				case "metadata": try {
					var _usingCtx$5 = _usingCtx();
					const feedKey = PublicKey.fromHex(message.feedKey);
					const feed = this._feeds.get(feedKey);
					if (!feed) {
						log.warn("Feed not found", { feedKey }, {
							"~LogMeta": "~LogMeta",
							F: __dxlog_file$21,
							L: 186,
							S: this
						});
						return;
					}
					_usingCtx$5.u(await this._getPushMutex(feed.key).acquire());
					this._remoteLength.set(feedKey, message.length);
					const logMeta = {
						localLength: feed.length,
						remoteLength: message.length,
						feedKey
					};
					if (message.length > feed.length) {
						log("requesting missing blocks", logMeta, {
							"~LogMeta": "~LogMeta",
							F: __dxlog_file$21,
							L: 196,
							S: this
						});
						await this._sendMessage(this._connectionCtx, {
							type: "request",
							feedKey: feedKey.toHex(),
							range: {
								from: feed.length,
								to: message.length
							}
						});
					} else if (message.length < feed.length) {
						log("pushing blocks to remote", logMeta, {
							"~LogMeta": "~LogMeta",
							F: __dxlog_file$21,
							L: 204,
							S: this
						});
						await this._pushBlocks(this._connectionCtx, feed, message.length, feed.length);
					}
					break;
				} catch (_) {
					_usingCtx$5.e = _;
				} finally {
					_usingCtx$5.d();
				}
				case "data": {
					log("received data", {
						feed: message.feedKey,
						blocks: message.blocks.map((b) => b.index)
					}, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$21,
						L: 213,
						S: this
					});
					const feedKey = PublicKey.fromHex(message.feedKey);
					const feed = this._feeds.get(feedKey);
					if (!feed) {
						log.warn("Feed not found", { feedKey }, {
							"~LogMeta": "~LogMeta",
							F: __dxlog_file$21,
							L: 218,
							S: this
						});
						return;
					}
					await this._integrateBlocks(feed, message.blocks);
					break;
				}
				default: log.warn("Unknown message", { ...message }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$21,
					L: 227,
					S: this
				});
			}
		});
	}
	async _pushBlocks(ctx, feed, from, to) {
		log("pushing blocks", {
			feed: feed.key.toHex(),
			from,
			to
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$21,
			L: 234,
			S: this
		});
		const blocks = await Promise.all(rangeFromTo(from, to).map(async (index) => {
			const data = await feed.get(index, { valueEncoding: "binary" });
			invariant(data instanceof Uint8Array, void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$21,
				L: 239,
				S: this,
				A: ["data instanceof Uint8Array", ""]
			});
			const proof = await feed.proof(index);
			return {
				index,
				data,
				nodes: proof.nodes,
				signature: proof.signature
			};
		}));
		await this._sendMessage(ctx, {
			type: "data",
			feedKey: feed.key.toHex(),
			blocks
		});
		this._remoteLength.set(feed.key, to);
	}
	async _integrateBlocks(feed, blocks) {
		log("integrating blocks", {
			feed: feed.key.toHex(),
			blocks: blocks.length
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$21,
			L: 260,
			S: this
		});
		for (const block of blocks) {
			if (feed.has(block.index)) continue;
			const blockBuffer = bufferizeBlock(block);
			await feed.putBuffer(block.index, blockBuffer.data, {
				nodes: blockBuffer.nodes,
				signature: blockBuffer.signature
			}, null);
		}
	}
	async _pushBlocksIfNeeded(feed) {
		try {
			var _usingCtx3 = _usingCtx();
			_usingCtx3.u(await this._getPushMutex(feed.key).acquire());
			if (!this._remoteLength.has(feed.key)) {
				log("blocks not pushed because remote length is unknown", void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$21,
					L: 281,
					S: this
				});
				return;
			}
			const remoteLength = this._remoteLength.get(feed.key);
			if (remoteLength < feed.length) await this._pushBlocks(this._connectionCtx, feed, remoteLength, feed.length);
		} catch (_) {
			_usingCtx3.e = _;
		} finally {
			_usingCtx3.d();
		}
	}
	_createConnectionContext() {
		const connectionCtx = new Context({
			parent: this._ctx,
			onError: async (err) => {
				if (connectionCtx !== this._connectionCtx) return;
				if (err instanceof EdgeIdentityChangedError || err instanceof EdgeConnectionClosedError) {
					log("resetting on reconnect", void 0, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$21,
						L: 299,
						S: this
					});
					await this._resetConnection();
				} else this._ctx.raise(err);
			}
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$21,
			L: 292
		});
		return connectionCtx;
	}
};
__decorate([logInfo], EdgeFeedReplicator.prototype, "_spaceId", void 0);
var bufferizeBlock = (block) => ({
	index: block.index,
	data: arrayToBuffer(block.data),
	nodes: block.nodes.map((node) => ({
		index: node.index,
		hash: arrayToBuffer(node.hash),
		size: node.size
	})),
	signature: arrayToBuffer(block.signature)
});
//#endregion
//#region src/packlets/spaces/epoch-migrations.ts
var __dxlog_file$20 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/spaces/epoch-migrations.ts";
var LOAD_DOC_TIMEOUT = 1e4;
var runEpochMigration = async (ctx, context) => {
	switch (context.migration) {
		case CreateEpochRequest.Migration.INIT_AUTOMERGE: {
			const document = await context.echoHost.createDoc();
			await context.echoHost.flush(ctx);
			return { newRoot: document.url };
		}
		case CreateEpochRequest.Migration.PRUNE_AUTOMERGE_ROOT_HISTORY: {
			if (!context.currentRoot) throw new Error("Space does not have an automerge root");
			const rootHandle = await context.echoHost.loadDoc(ctx, context.currentRoot, { timeout: LOAD_DOC_TIMEOUT });
			invariant(rootHandle, "Automerge root document must load for history prune migration.", {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$20,
				L: 50,
				S: void 0,
				A: ["rootHandle", "'Automerge root document must load for history prune migration.'"]
			});
			const newRoot = await context.echoHost.createDoc(rootHandle.doc());
			await context.echoHost.flush(ctx);
			return { newRoot: newRoot.url };
		}
		case CreateEpochRequest.Migration.FRAGMENT_AUTOMERGE_ROOT: throw new Error("Migration not available");
		case CreateEpochRequest.Migration.MIGRATE_REFERENCES_TO_DXN: throw new Error("Migration not available");
		case CreateEpochRequest.Migration.REPLACE_AUTOMERGE_ROOT:
			invariant(context.newAutomergeRoot, void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$20,
				L: 64,
				S: void 0,
				A: ["context.newAutomergeRoot", ""]
			});
			await context.echoHost.flush(ctx);
			return { newRoot: context.newAutomergeRoot };
	}
	return {};
};
//#endregion
//#region src/packlets/spaces/notarization-plugin.ts
var __dxlog_file$19 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/spaces/notarization-plugin.ts";
var DEFAULT_RETRY_TIMEOUT = 1e3;
var DEFAULT_SUCCESS_DELAY = 1e3;
var DEFAULT_NOTARIZE_TIMEOUT = 1e4;
var DEFAULT_ACTIVE_EDGE_POLLING_INTERVAL = 3e3;
var MAX_EDGE_RETRIES = 2;
var WRITER_NOT_SET_ERROR_CODE = "WRITER_NOT_SET";
var credentialCodec = schema.getCodecForType("dxos.halo.credentials.Credential");
/**
* See NotarizationService proto.
*/
var NotarizationPlugin = class extends Resource {
	_extensionOpened = new Event();
	_writer;
	_extensions = /* @__PURE__ */ new Set();
	_processedCredentials = new ComplexSet(PublicKey.hash);
	_processCredentialsTriggers = new ComplexMap(PublicKey.hash);
	_activeEdgePollingIntervalHandle = void 0;
	_activeEdgePollingInterval;
	_activeEdgePollingEnabled = false;
	_spaceId;
	_edgeClient;
	constructor(params) {
		super();
		this._spaceId = params.spaceId;
		this._activeEdgePollingInterval = params.activeEdgePollingInterval ?? DEFAULT_ACTIVE_EDGE_POLLING_INTERVAL;
		if (params.edgeClient && params.edgeFeatures?.feedReplicator) this._edgeClient = params.edgeClient;
	}
	setActiveEdgePollingEnabled(enabled) {
		const client = this._edgeClient;
		invariant(client, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$19,
			L: 111,
			S: this,
			A: ["client", ""]
		});
		this._activeEdgePollingEnabled = enabled;
		if (this.isOpen) {
			if (enabled && !this._activeEdgePollingIntervalHandle) this._startPeriodicEdgePolling(client);
			else if (!enabled && this._activeEdgePollingIntervalHandle) this._stopPeriodicEdgePolling();
		}
	}
	get hasWriter() {
		return !!this._writer;
	}
	async _open() {
		if (this._edgeClient) {
			if (this._activeEdgePollingEnabled) this._startPeriodicEdgePolling(this._edgeClient);
			if (this._writer) this._notarizePendingEdgeCredentials(this._edgeClient, this._writer);
		}
	}
	async _close() {
		this._stopPeriodicEdgePolling();
		await this._ctx.dispose();
	}
	/**
	* Request credentials to be notarized.
	*/
	async notarize({ ctx: opCtx, credentials, timeout = DEFAULT_NOTARIZE_TIMEOUT, retryTimeout = DEFAULT_RETRY_TIMEOUT, successDelay = DEFAULT_SUCCESS_DELAY, edgeRetryJitter }) {
		log("notarize", { credentials }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$19,
			L: 153,
			S: this
		});
		invariant(credentials.every((credential) => credential.id), "Credentials must have an id", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$19,
			L: 154,
			S: this,
			A: ["credentials.every((credential) => credential.id)", "'Credentials must have an id'"]
		});
		const errors = new Trigger();
		const ctx = this._ctx.derive({ onError: (err) => {
			log.warn("Notarization error", { err }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$19,
				L: 162,
				S: this
			});
			ctx.dispose();
			errors.throw(err);
		} });
		opCtx?.onDispose(() => ctx.dispose());
		if (timeout !== 0) this._scheduleTimeout(ctx, errors, timeout);
		const allNotarized = Promise.all(credentials.map((credential) => this._waitUntilProcessed(credential.id)));
		this._tryNotarizeCredentialsWithPeers(ctx, credentials, {
			retryTimeout,
			successDelay
		});
		if (this._edgeClient) this._tryNotarizeCredentialsWithEdge(ctx, this._edgeClient, credentials, {
			retryTimeout,
			successDelay,
			jitter: edgeRetryJitter
		});
		try {
			await Promise.race([
				rejectOnDispose(ctx),
				allNotarized,
				errors.wait()
			]);
			log("done", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$19,
				L: 187,
				S: this
			});
		} finally {
			await ctx.dispose();
		}
	}
	_tryNotarizeCredentialsWithPeers(ctx, credentials, { retryTimeout, successDelay }) {
		const peersTried = /* @__PURE__ */ new Set();
		const notarizeTask = new DeferredTask(ctx, async () => {
			try {
				if (this._extensions.size === 0) return;
				const peer = [...this._extensions].find((peer) => !peersTried.has(peer));
				if (!peer) {
					log.info("Exhausted all peers to notarize with", { retryIn: retryTimeout }, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$19,
						L: 210,
						S: this
					});
					peersTried.clear();
					scheduleTask(ctx, () => notarizeTask.schedule(), retryTimeout);
					return;
				}
				peersTried.add(peer);
				log("try notarizing", {
					peer: peer.localPeerId,
					credentialId: credentials.map((credential) => credential.id)
				}, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$19,
					L: 217,
					S: this
				});
				await peer.rpc.NotarizationService.notarize({ credentials: credentials.filter((credential) => !this._processedCredentials.has(credential.id)) });
				log("success", void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$19,
					L: 221,
					S: this
				});
				await sleep(successDelay);
			} catch (err) {
				if (!ctx.disposed && !err.message.includes(WRITER_NOT_SET_ERROR_CODE)) log.info("error notarizing (recoverable)", err, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$19,
					L: 226,
					S: this
				});
				notarizeTask.schedule();
			}
		});
		notarizeTask.schedule();
		this._extensionOpened.on(ctx, () => notarizeTask.schedule());
	}
	_tryNotarizeCredentialsWithEdge(ctx, client, credentials, timeouts) {
		const encodedCredentials = credentials.map((credential) => {
			const binary = credentialCodec.encode(credential);
			return Buffer.from(binary).toString("base64");
		});
		scheduleTask(ctx, async () => {
			try {
				await client.notarizeCredentials(ctx, this._spaceId, { credentials: encodedCredentials }, { retry: {
					count: MAX_EDGE_RETRIES,
					timeout: timeouts.retryTimeout,
					jitter: timeouts.jitter
				} });
				log("edge notarization success", void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$19,
					L: 255,
					S: this
				});
			} catch (error) {
				handleEdgeError(error);
			}
		});
	}
	/**
	* Called with credentials arriving from the control pipeline.
	*/
	async processCredential(credential) {
		if (!credential.id) return;
		this._processCredentialsTriggers.get(credential.id)?.wake();
		this._processedCredentials.add(credential.id);
		this._processCredentialsTriggers.delete(credential.id);
	}
	setWriter(writer) {
		invariant(!this._writer, "Writer already set.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$19,
			L: 275,
			S: this,
			A: ["!this._writer", "'Writer already set.'"]
		});
		this._writer = writer;
		if (this._edgeClient && this.isOpen) this._notarizePendingEdgeCredentials(this._edgeClient, writer);
	}
	_startPeriodicEdgePolling(client) {
		this._activeEdgePollingIntervalHandle = setInterval(() => {
			if (this._writer) this._notarizePendingEdgeCredentials(client, this._writer);
		}, this._activeEdgePollingInterval);
	}
	_stopPeriodicEdgePolling() {
		if (this._activeEdgePollingIntervalHandle) {
			clearInterval(this._activeEdgePollingIntervalHandle);
			this._activeEdgePollingIntervalHandle = void 0;
		}
	}
	/**
	* The method is used only for adding agent feeds to spaces.
	* When an agent is created we can admit them into all the existing spaces. In case the operation fails
	* this method will fix it on the next space open.
	* Given how rarely this happens there's no need to poll the endpoint.
	*/
	_notarizePendingEdgeCredentials(client, writer) {
		scheduleMicroTask(this._ctx, async () => {
			try {
				const credentials = (await client.getCredentialsForNotarization(this._ctx, this._spaceId, { retry: { count: MAX_EDGE_RETRIES } })).awaitingNotarization.credentials;
				if (!credentials.length) {
					log("edge did not return credentials for notarization", void 0, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$19,
						L: 312,
						S: this
					});
					return;
				}
				log("got edge credentials for notarization", { count: credentials.length }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$19,
					L: 316,
					S: this
				});
				const decodedCredentials = credentials.map((credential) => {
					const binary = Buffer.from(credential, "base64");
					return credentialCodec.decode(binary);
				});
				await this._notarizeCredentials(writer, decodedCredentials);
				log.info("notarized edge credentials", { count: decodedCredentials.length }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$19,
					L: 325,
					S: this
				});
			} catch (error) {
				handleEdgeError(error);
			}
		});
	}
	async _waitUntilProcessed(id) {
		if (this._processedCredentials.has(id)) return;
		await entry(this._processCredentialsTriggers, id).orInsert(new Trigger()).value.wait();
	}
	/**
	* Requests from other peers to notarize credentials.
	*/
	async _onNotarize(request) {
		if (!this._writer) throw new Error(WRITER_NOT_SET_ERROR_CODE);
		await this._notarizeCredentials(this._writer, request.credentials ?? []);
	}
	async _notarizeCredentials(writer, credentials) {
		for (const credential of credentials) {
			invariant(credential.id, "Credential must have an id", {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$19,
				L: 351,
				S: this,
				A: ["credential.id", "'Credential must have an id'"]
			});
			if (this._processedCredentials.has(credential.id)) continue;
			const verificationResult = await verifyCredential(credential);
			if (verificationResult.kind === "fail") throw new Error(`Credential verification failed: ${verificationResult.errors.join("\n")}.`);
			await writer.write(credential);
		}
	}
	createExtension() {
		const extension = new NotarizationTeleportExtension({
			onOpen: async () => {
				log("extension opened", { peer: extension.localPeerId }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$19,
					L: 366,
					S: this
				});
				this._extensions.add(extension);
				this._extensionOpened.emit();
			},
			onClose: async () => {
				log("extension closed", { peer: extension.localPeerId }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$19,
					L: 371,
					S: this
				});
				this._extensions.delete(extension);
			},
			onNotarize: this._onNotarize.bind(this)
		});
		return extension;
	}
	_scheduleTimeout(ctx, errors, timeout) {
		scheduleTask(ctx, () => {
			log.warn("Notarization timeout", {
				timeout,
				peers: Array.from(this._extensions).map((extension) => extension.remotePeerId)
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$19,
				L: 383,
				S: this
			});
			ctx.dispose();
			errors.throw(new TimeoutError(timeout, "Notarization timed out"));
		}, timeout);
	}
};
__decorate([logInfo], NotarizationPlugin.prototype, "_spaceId", void 0);
var handleEdgeError = (error) => {
	if (!(error instanceof EdgeCallFailedError) || error.data) log.catch(error, void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$19,
		L: 397,
		S: void 0
	});
	else log.info("Edge notarization failure", { message: error.message }, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$19,
		L: 399,
		S: void 0
	});
};
var NotarizationTeleportExtension = class extends RpcExtension {
	_params;
	constructor(_params) {
		super({
			requested: { NotarizationService: schema.getService("dxos.mesh.teleport.notarization.NotarizationService") },
			exposed: { NotarizationService: schema.getService("dxos.mesh.teleport.notarization.NotarizationService") }
		});
		this._params = _params;
	}
	async getHandlers() {
		return { NotarizationService: { notarize: async (request) => {
			await this._params.onNotarize(request);
		} } };
	}
	async onOpen(ctx) {
		await super.onOpen(ctx);
		await this._params.onOpen();
	}
	async onClose(err) {
		await this._params.onClose();
		await super.onClose(err);
	}
};
//#endregion
//#region src/packlets/spaces/data-space.ts
var __dxlog_file$18 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/spaces/data-space.ts";
var DataSpace = class DataSpace {
	_ctx = new Context(void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$18,
		L: 97
	});
	_inner;
	_gossip;
	_presence;
	_keyring;
	_feedStore;
	_metadataStore;
	_signingContext;
	_notarizationPlugin;
	_callbacks;
	_cache = void 0;
	_echoHost;
	_edgeFeedReplicator = void 0;
	_automergeSpaceState = new AutomergeSpaceState((rootUrl) => this._onNewAutomergeRoot(rootUrl));
	_epochProcessingMutex = new Mutex();
	_state = SpaceState.SPACE_CLOSED;
	/** Immutable tags from space metadata, available immediately. */
	tags;
	_databaseRoot = null;
	/**
	* Error for _state === SpaceState.SPACE_ERROR.
	*/
	error = void 0;
	authVerifier;
	stateUpdate = new Event();
	postOpen = new CallbackCollection();
	preClose = new CallbackCollection();
	metrics = {};
	constructor(params) {
		this._inner = params.inner;
		this._inner.stateUpdate.on(this._ctx, () => this.stateUpdate.emit());
		this._gossip = params.gossip;
		this._presence = params.presence;
		this._keyring = params.keyring;
		this._feedStore = params.feedStore;
		this._metadataStore = params.metadataStore;
		this._signingContext = params.signingContext;
		this._callbacks = params.callbacks ?? {};
		this._echoHost = params.echoHost;
		this._notarizationPlugin = new NotarizationPlugin({
			spaceId: this._inner.id,
			edgeClient: params.edgeHttpClient,
			edgeFeatures: params.edgeFeatures,
			activeEdgePollingInterval: params.activeEdgeNotarizationPollingInterval
		});
		this.authVerifier = new TrustedKeySetAuthVerifier({
			trustedKeysProvider: () => new ComplexSet(PublicKey.hash, Array.from(this._inner.spaceState.members.values()).filter((member) => member.role !== SpaceMember$1.Role.REMOVED).map((member) => member.key)),
			update: this._inner.stateUpdate,
			authTimeout: AUTH_TIMEOUT
		});
		this._cache = params.cache;
		this.tags = params.tags ?? [];
		if (params.edgeConnection && params.edgeFeatures?.feedReplicator) this._edgeFeedReplicator = new EdgeFeedReplicator({
			messenger: params.edgeConnection,
			spaceId: this.id
		});
		this._state = params.initialState;
		log("new state", { state: SpaceState[this._state] }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$18,
			L: 176,
			S: this
		});
	}
	get id() {
		return this._inner.id;
	}
	get key() {
		return this._inner.key;
	}
	get isOpen() {
		return this._inner.isOpen;
	}
	get state() {
		return this._state;
	}
	get inner() {
		return this._inner;
	}
	get presence() {
		return this._presence;
	}
	get notarizationPlugin() {
		return this._notarizationPlugin;
	}
	get cache() {
		return this._cache;
	}
	/** Membership policy from the genesis credential, defaults to INVITE. */
	get membershipPolicy() {
		return this._inner.spaceState.genesisCredential ? this._inner.spaceState.membershipPolicy : MembershipPolicy.INVITE;
	}
	get automergeSpaceState() {
		return this._automergeSpaceState;
	}
	get databaseRoot() {
		return this._databaseRoot;
	}
	get _automergeInfo() {
		return {
			rootUrl: this._automergeSpaceState.rootUrl,
			lastEpoch: this._automergeSpaceState.lastEpoch
		};
	}
	async open(ctx) {
		if (this._state === SpaceState.SPACE_CLOSED) await this._open(ctx);
	}
	async _open(ctx) {
		await this._presence.open();
		await this._gossip.open();
		await this._notarizationPlugin.open();
		await this._inner.spaceState.addCredentialProcessor(this._notarizationPlugin);
		await this._automergeSpaceState.open();
		await this._inner.spaceState.addCredentialProcessor(this._automergeSpaceState);
		if (this._edgeFeedReplicator) this.inner.protocol.feedAdded.append(this._onFeedAdded);
		await this._inner.open(ctx);
		await this._inner.startProtocol(ctx);
		await this._edgeFeedReplicator?.open();
		this._state = SpaceState.SPACE_CONTROL_ONLY;
		log("new state", { state: SpaceState[this._state] }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$18,
			L: 258,
			S: this
		});
		this.stateUpdate.emit();
		this.metrics = {};
		this.metrics.open = /* @__PURE__ */ new Date();
		await this.postOpen.callSerial();
	}
	async close(ctx) {
		await this._close(ctx);
	}
	async _close(ctx) {
		await this._callbacks.beforeClose?.();
		await this.preClose.callSerial();
		this._state = SpaceState.SPACE_CLOSED;
		log("new state", { state: SpaceState[this._state] }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$18,
			L: 278,
			S: this
		});
		await this._ctx.dispose();
		this._ctx = new Context(void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$18,
			L: 280
		});
		if (this._edgeFeedReplicator) this.inner.protocol.feedAdded.remove(this._onFeedAdded);
		await this._edgeFeedReplicator?.close();
		await this.authVerifier.close();
		await this._inner.close(ctx);
		await this._inner.spaceState.removeCredentialProcessor(this._automergeSpaceState);
		await this._automergeSpaceState.close();
		await this._inner.spaceState.removeCredentialProcessor(this._notarizationPlugin);
		await this._notarizationPlugin.close();
		await this._presence.close();
		await this._gossip.close();
	}
	async postMessage(channel, message) {
		return this._gossip.postMessage(channel, message);
	}
	listen(channel, callback) {
		return this._gossip.listen(channel, callback);
	}
	/**
	* Initialize the data pipeline in a separate task.
	* @param callerCtx - Trace context from the caller (e.g., activate or createSpace) for span parenting.
	*/
	initializeDataPipelineAsync(callerCtx) {
		const traceCtx = callerCtx ?? this._ctx;
		scheduleTask(this._ctx, async () => {
			try {
				this.metrics.pipelineInitBegin = /* @__PURE__ */ new Date();
				await this.initializeDataPipeline(traceCtx);
			} catch (err) {
				if (err instanceof CancelledError || err instanceof ContextDisposedError) {
					log("data pipeline initialization cancelled", err, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$18,
						L: 320,
						S: this
					});
					return;
				}
				log.error("Error initializing data pipeline", err, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$18,
					L: 324,
					S: this
				});
				this._state = SpaceState.SPACE_ERROR;
				log("new state", { state: SpaceState[this._state] }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$18,
					L: 326,
					S: this
				});
				this.error = err;
				this.stateUpdate.emit();
			} finally {
				this.metrics.ready = /* @__PURE__ */ new Date();
			}
		});
	}
	async initializeDataPipeline(ctx) {
		if (this._state !== SpaceState.SPACE_CONTROL_ONLY) throw new SystemError({ message: "Invalid operation" });
		this._state = SpaceState.SPACE_INITIALIZING;
		log("new state", { state: SpaceState[this._state] }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$18,
			L: 342,
			S: this
		});
		log("initializing control pipeline", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$18,
			L: 344,
			S: this
		});
		await this._initializeAndReadControlPipeline(ctx);
		await sleep(1);
		const ready = this.stateUpdate.waitForCondition(() => this._state === SpaceState.SPACE_READY);
		log("initializing automerge root", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$18,
			L: 352,
			S: this
		});
		if (this._echoHost.spaces.some((s) => s.spaceId === this.id)) try {
			log("opening persisted space root", { spaceId: this.id }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$18,
				L: 356,
				S: this
			});
			const root = await this._echoHost.openSpaceRoot(ctx, this.id);
			this._databaseRoot = root;
			if (root.getVersion() !== SpaceDocVersion.CURRENT) {
				this._state = SpaceState.SPACE_REQUIRES_MIGRATION;
				this.stateUpdate.emit();
			} else await this._enterReadyState();
		} catch (err) {
			log.warn("failed to open persisted space root, will wait for credentials", {
				spaceId: this.id,
				err
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$18,
				L: 366,
				S: this
			});
		}
		this._automergeSpaceState.startProcessingRootDocs();
		log("waiting for space to be ready", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$18,
			L: 373,
			S: this
		});
		await ready;
		log("space is ready", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$18,
			L: 375,
			S: this
		});
	}
	async *getAllDocuments() {
		invariant(this._databaseRoot, "Space is not ready", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$18,
			L: 379,
			S: this,
			A: ["this._databaseRoot", "'Space is not ready'"]
		});
		const root = save(this._databaseRoot.doc() ?? failedInvariant());
		yield [this._databaseRoot.documentId, root];
		for (const documentUrl of this._databaseRoot.getAllLinkedDocuments()) {
			const data = await this._echoHost.exportDoc(documentUrl);
			yield [documentUrl.replace(/^automerge:/, ""), data];
		}
	}
	/**
	* Get all feeds and their blocks for this space.
	* Used for space archive export.
	*/
	async getAllFeeds() {
		return this._echoHost.getAllFeedsForSpace(this.id);
	}
	async _enterReadyState() {
		await this._callbacks.beforeReady?.();
		this._state = SpaceState.SPACE_READY;
		log("new state", { state: SpaceState[this._state] }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$18,
			L: 402,
			S: this
		});
		this.stateUpdate.emit();
		await this._callbacks.afterReady?.();
	}
	async _initializeAndReadControlPipeline(ctx) {
		await this._inner.controlPipeline.state.waitUntilReachedTargetTimeframe({
			ctx,
			timeout: 1e4,
			breakOnStall: false
		});
		this.metrics.controlPipelineReady = /* @__PURE__ */ new Date();
		await this._createWritableFeeds();
		log("writable feeds created", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$18,
			L: 419,
			S: this
		});
		this.stateUpdate.emit();
		if (!this.notarizationPlugin.hasWriter) this.notarizationPlugin.setWriter(createMappedFeedWriter((credential) => ({ credential: { credential } }), this._inner.controlPipeline.writer));
	}
	async _createWritableFeeds() {
		const credentials = [];
		if (!this.inner.controlFeedKey) {
			const controlFeed = await this._feedStore.openFeed(await this._keyring.createKey(), { writable: true });
			await this.inner.setControlFeed(controlFeed);
			credentials.push(await this._signingContext.credentialSigner.createCredential({
				subject: controlFeed.key,
				assertion: {
					"@type": "dxos.halo.credentials.AdmittedFeed",
					"spaceKey": this.key,
					"deviceKey": this._signingContext.deviceKey,
					"identityKey": this._signingContext.identityKey,
					"designation": AdmittedFeed.Designation.CONTROL
				}
			}));
		}
		if (!this.inner.dataFeedKey) {
			const dataFeed = await this._feedStore.openFeed(await this._keyring.createKey(), {
				writable: true,
				sparse: true
			});
			await this.inner.setDataFeed(dataFeed);
			credentials.push(await this._signingContext.credentialSigner.createCredential({
				subject: dataFeed.key,
				assertion: {
					"@type": "dxos.halo.credentials.AdmittedFeed",
					"spaceKey": this.key,
					"deviceKey": this._signingContext.deviceKey,
					"identityKey": this._signingContext.identityKey,
					"designation": AdmittedFeed.Designation.DATA
				}
			}));
		}
		if (credentials.length > 0) {
			try {
				log("will notarize credentials for feed admission", { count: credentials.length }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$18,
					L: 477,
					S: this
				});
				await this.notarizationPlugin.notarize({
					ctx: this._ctx,
					credentials,
					timeout: 0
				});
				log("credentials notarized", void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$18,
					L: 481,
					S: this
				});
			} catch (err) {
				if (err instanceof ContextDisposedError) return;
				log.error("error notarizing credentials for feed admission", err, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$18,
					L: 486,
					S: this
				});
				throw err;
			}
			await this._metadataStore.setWritableFeedKeys(this.key, this.inner.controlFeedKey, this.inner.dataFeedKey);
		}
	}
	_onNewAutomergeRoot(rootUrl) {
		log("loading automerge root doc for space", {
			space: this.key,
			rootUrl
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$18,
			L: 496,
			S: this
		});
		let handle = null;
		queueMicrotask(async () => {
			try {
				try {
					var _usingCtx$4 = _usingCtx();
					await warnAfterTimeout(5e3, "Automerge root doc load timeout (DataSpace)", async () => {
						handle = await cancelWithContext(this._ctx, this._echoHost.loadDoc(this._ctx, rootUrl, { fetchFromNetwork: true }));
					});
					if (this._ctx.disposed) return;
					if (!handle) {
						log.warn("automerge root doc not available yet", {
							space: this.key,
							rootUrl
						}, {
							"~LogMeta": "~LogMeta",
							F: __dxlog_file$18,
							L: 515,
							S: this
						});
						return;
					}
					_usingCtx$4.u(await this._epochProcessingMutex.acquire());
					const doc = handle.doc();
					if (!doc.access?.spaceId || !doc.access?.spaceKey) handle.change((doc) => {
						doc.access ??= {};
						doc.access.spaceId ??= this.id;
						doc.access.spaceKey ??= this.key.toHex();
					});
					const root = await this._echoHost.updateSpaceRoot(this._ctx, this.id, handle.url);
					this._databaseRoot = root;
					if (root.getVersion() !== SpaceDocVersion.CURRENT) {
						this._state = SpaceState.SPACE_REQUIRES_MIGRATION;
						this.stateUpdate.emit();
					} else if (this._state !== SpaceState.SPACE_READY) await this._enterReadyState();
					else this.stateUpdate.emit();
				} catch (_) {
					_usingCtx$4.e = _;
				} finally {
					_usingCtx$4.d();
				}
			} catch (err) {
				if (err instanceof ContextDisposedError) return;
				log.warn("error loading automerge root doc", {
					space: this.key,
					rootUrl,
					err
				}, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$18,
					L: 551,
					S: this
				});
			}
		});
	}
	async updateOwnProfile(profile) {
		const credential = await this._signingContext.credentialSigner.createCredential({
			subject: this._signingContext.identityKey,
			assertion: {
				"@type": "dxos.halo.credentials.MemberProfile",
				profile
			}
		});
		await this.inner.controlPipeline.writer.write({ credential: { credential } });
	}
	async createEpoch(options) {
		const ctx = this._ctx.derive();
		if (!options?.migration) return null;
		const { newRoot } = await runEpochMigration(ctx, {
			echoHost: this._echoHost,
			spaceId: this.id,
			spaceKey: this.key,
			migration: options.migration,
			currentRoot: this._automergeSpaceState.rootUrl ?? null,
			newAutomergeRoot: options.newAutomergeRoot
		});
		const epoch = {
			previousId: this._automergeSpaceState.lastEpoch?.id,
			number: (this._automergeSpaceState.lastEpoch?.subject.assertion.number ?? -1) + 1,
			timeframe: this._automergeSpaceState.lastEpoch?.subject.assertion.timeframe ?? new Timeframe(),
			automergeRoot: newRoot ?? this._automergeSpaceState.rootUrl
		};
		const credential = await this._signingContext.credentialSigner.createCredential({
			subject: this.key,
			assertion: {
				"@type": "dxos.halo.credentials.Epoch",
				...epoch
			}
		});
		const receipt = await this.inner.controlPipeline.writer.write({ credential: { credential } });
		const timeframe = new Timeframe([[receipt.feedKey, receipt.seq]]);
		await this.inner.controlPipeline.state.waitUntilTimeframe(timeframe);
		await this._echoHost.updateIndexes();
		return {
			credential,
			timeframe
		};
	}
	async activate(ctx) {
		if (![SpaceState.SPACE_CLOSED, SpaceState.SPACE_INACTIVE].includes(this._state)) return;
		await this._metadataStore.setSpaceState(this.key, SpaceState.SPACE_ACTIVE);
		await this._open(ctx);
		this.initializeDataPipelineAsync(ctx);
	}
	async deactivate(ctx) {
		if (this._state === SpaceState.SPACE_INACTIVE) return;
		await this._metadataStore.setSpaceState(this.key, SpaceState.SPACE_INACTIVE);
		if (this._state !== SpaceState.SPACE_CLOSED) await this._close(ctx);
		this._state = SpaceState.SPACE_INACTIVE;
		log("new state", { state: SpaceState[this._state] }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$18,
			L: 632,
			S: this
		});
		this.stateUpdate.emit();
	}
	/**
	* Tombstones (soft-deletes) the space by moving it to a terminal state.
	* This is intentionally separate from teardown: the caller is responsible for {@link close}-ing the
	* space (teardown uses the resource lifecycle, distinct from this state transition).
	* Terminal: {@link activate} will not re-open a deleted space. Data is not removed until garbage
	* collection (future work).
	*/
	async delete() {
		if (this._state === SpaceState.SPACE_DELETED) return;
		await this._metadataStore.setSpaceState(this.key, SpaceState.SPACE_DELETED);
		this._state = SpaceState.SPACE_DELETED;
		log("new state", { state: SpaceState[this._state] }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$18,
			L: 650,
			S: this
		});
		this.stateUpdate.emit();
	}
	getEdgeReplicationSetting() {
		return this._metadataStore.getSpaceEdgeReplicationSetting(this.key);
	}
	_onFeedAdded = async (feed) => {
		await this._edgeFeedReplicator.addFeed(feed);
	};
};
__decorate([synchronized, trace.span({
	showInBrowserTimeline: true,
	op: "lifecycle"
})], DataSpace.prototype, "open", null);
__decorate([synchronized, trace.span({
	showInBrowserTimeline: true,
	op: "lifecycle"
})], DataSpace.prototype, "close", null);
__decorate([trace.span({
	showInBrowserTimeline: true,
	op: "lifecycle"
})], DataSpace.prototype, "initializeDataPipeline", null);
__decorate([trace.span({
	showInBrowserTimeline: true,
	op: "lifecycle"
})], DataSpace.prototype, "_initializeAndReadControlPipeline", null);
__decorate([timed(1e4)], DataSpace.prototype, "_createWritableFeeds", null);
__decorate([synchronized], DataSpace.prototype, "activate", null);
__decorate([synchronized], DataSpace.prototype, "deactivate", null);
__decorate([synchronized], DataSpace.prototype, "delete", null);
DataSpace = __decorate([trackLeaks("open", "close")], DataSpace);
//#endregion
//#region src/packlets/spaces/genesis.ts
var spaceGenesis = async (keyring, signingContext, space, automergeRoot, tags, membershipPolicy) => {
	const credentials = [
		await createCredential({
			signer: keyring,
			issuer: space.key,
			subject: space.key,
			assertion: {
				"@type": "dxos.halo.credentials.SpaceGenesis",
				"spaceKey": space.key,
				"tags": tags ?? [],
				"membershipPolicy": membershipPolicy ?? MembershipPolicy.INVITE
			}
		}),
		await createCredential({
			signer: keyring,
			issuer: space.key,
			subject: signingContext.identityKey,
			assertion: {
				"@type": "dxos.halo.credentials.SpaceMember",
				"spaceKey": space.key,
				"role": SpaceMember$1.Role.OWNER,
				"profile": signingContext.getProfile(),
				"genesisFeedKey": space.controlFeedKey ?? failUndefined(),
				"tags": tags ?? []
			}
		}),
		await signingContext.credentialSigner.createCredential({
			subject: space.controlFeedKey ?? failUndefined(),
			assertion: {
				"@type": "dxos.halo.credentials.AdmittedFeed",
				"spaceKey": space.key,
				"identityKey": signingContext.identityKey,
				"deviceKey": signingContext.deviceKey,
				"designation": AdmittedFeed.Designation.CONTROL
			}
		}),
		await signingContext.credentialSigner.createCredential({
			subject: space.dataFeedKey ?? failUndefined(),
			assertion: {
				"@type": "dxos.halo.credentials.AdmittedFeed",
				"spaceKey": space.key,
				"identityKey": signingContext.identityKey,
				"deviceKey": signingContext.deviceKey,
				"designation": AdmittedFeed.Designation.DATA
			}
		}),
		await signingContext.credentialSigner.createCredential({
			subject: space.key ?? failUndefined(),
			assertion: {
				"@type": "dxos.halo.credentials.Epoch",
				"number": 0,
				"previousId": void 0,
				"timeframe": new Timeframe(),
				"snapshotCid": void 0,
				automergeRoot
			}
		})
	];
	for (const credential of credentials) await space.controlPipeline.writer.write({ credential: { credential } });
	return credentials;
};
//#endregion
//#region src/packlets/spaces/data-space-manager.ts
var __dxlog_file$17 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/spaces/data-space-manager.ts";
var PRESENCE_ANNOUNCE_INTERVAL = 1e4;
var PRESENCE_OFFLINE_TIMEOUT = 2e4;
/**
* Effect service tag for {@link SigningContextProvider}.
*/
var SigningContextProviderService = class extends EffectContext.Tag("@dxos/client-services/SigningContextProvider")() {};
/**
* Builds a {@link SigningContextProvider} from an identity resolver.
*/
var createSigningContextProvider = (getIdentity) => () => {
	const identity = getIdentity();
	return {
		credentialSigner: identity.getIdentityCredentialSigner(),
		identityKey: identity.identityKey,
		deviceKey: identity.deviceKey,
		getProfile: () => identity.profileDocument,
		recordCredential: async (credential) => {
			await identity.controlPipeline.writer.write({ credential: { credential } });
		}
	};
};
/**
* Effect Layer providing {@link SigningContextProvider} from {@link IdentityProviderService}.
*/
var SigningContextProviderLayer = Layer.effect(SigningContextProviderService, Effect.gen(function* () {
	return createSigningContextProvider(yield* IdentityProviderService);
}));
var DataSpaceManager = class DataSpaceManager extends Resource {
	updated = new Event();
	_spaces = new ComplexMap(PublicKey.hash);
	_spaceManager;
	_metadataStore;
	_keyring;
	_signingContextProvider;
	_feedStore;
	_echoHost;
	_invitationsManager;
	_edgeConnection = void 0;
	_edgeHttpClient = void 0;
	_edgeFeatures = void 0;
	_meshReplicator = void 0;
	_echoEdgeReplicator = void 0;
	_runtimeProps = void 0;
	constructor(params) {
		super();
		this._spaceManager = params.spaceManager;
		this._metadataStore = params.metadataStore;
		this._keyring = params.keyring;
		this._signingContextProvider = params.signingContextProvider;
		this._feedStore = params.feedStore;
		this._echoHost = params.echoHost;
		this._meshReplicator = params.meshReplicator;
		this._invitationsManager = params.invitationsManager;
		this._edgeConnection = params.edgeConnection;
		this._edgeFeatures = params.edgeFeatures;
		this._echoEdgeReplicator = params.echoEdgeReplicator;
		this._edgeHttpClient = params.edgeHttpClient;
		this._runtimeProps = params.runtimeProps;
		trace.diagnostic({
			id: "spaces",
			name: "Spaces",
			fetch: async () => {
				return Promise.all(Array.from(this._spaces.values()).map(async (space) => {
					const rootUrl = space.automergeSpaceState.rootUrl;
					const rootDoc = (rootUrl ? await this._echoHost.loadDoc(this._ctx, rootUrl) : void 0)?.doc();
					const properties = rootDoc && findInlineObjectOfType(rootDoc, Type.getTypename(SpaceProperties));
					return {
						key: space.key.toHex(),
						state: SpaceState[space.state],
						name: properties?.[1].data.name ?? null,
						inlineObjects: rootDoc ? Object.keys(rootDoc.objects ?? {}).length : null,
						linkedObjects: rootDoc ? Object.keys(rootDoc.links ?? {}).length : null,
						credentials: space.inner.spaceState.credentials.length,
						members: space.inner.spaceState.members.size,
						rootUrl
					};
				}));
			}
		});
	}
	get signingContext() {
		return this._signingContextProvider();
	}
	get spaces() {
		return this._spaces;
	}
	getSpaceById(spaceId) {
		return [...this._spaces.values()].find((space) => space.id === spaceId);
	}
	async _open(ctx) {
		log("open", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 280,
			S: this
		});
		log("metadata loaded", { spaces: this._metadataStore.spaces.length }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 281,
			S: this
		});
		const spacesToActivate = [];
		await forEachAsync(this._metadataStore.spaces, async (spaceMetadata) => {
			try {
				if (spaceMetadata.state === SpaceState.SPACE_DELETED || this.isSpaceDeleted(spaceMetadata.key)) {
					log("skipping deleted space", { spaceKey: spaceMetadata.key }, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$17,
						L: 288,
						S: this
					});
					return;
				}
				log("load space", { spaceMetadata }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$17,
					L: 291,
					S: this
				});
				const space = await this._constructSpace(ctx, spaceMetadata);
				if (this._runtimeProps?.autoActivateSpaces && spaceMetadata.state === SpaceState.SPACE_ACTIVE) spacesToActivate.push(space);
			} catch (err) {
				log.error("Error loading space", {
					spaceMetadata,
					err
				}, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$17,
					L: 298,
					S: this
				});
			}
		});
		for (const space of spacesToActivate) {
			log("auto-activating space", { spaceKey: space.key }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$17,
				L: 304,
				S: this
			});
			space.activate(ctx).catch((err) => {
				log.error("Error auto-activating space", {
					spaceKey: space.key,
					err
				}, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$17,
					L: 306,
					S: this
				});
			});
		}
		this.updated.emit();
	}
	async _close(ctx) {
		log("close", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 315,
			S: this
		});
		for (const space of this._spaces.values()) await space.close(ctx);
		this._spaces.clear();
	}
	/**
	* Creates a new space writing the genesis credentials to the control feed.
	*/
	async createSpace(ctx, options = {}) {
		assertArgument(!!options.rootUrl === !!options.documents, "options", "root url must be required when providing documents");
		assertState(this._lifecycleState === LifecycleState.OPEN, "Not open.");
		const tags = options.tags ? Array.from(options.tags) : [];
		const spaceKey = await this._keyring.createKey();
		const controlFeedKey = await this._keyring.createKey();
		const dataFeedKey = await this._keyring.createKey();
		const spaceId = await createIdFromSpaceKey(spaceKey);
		const metadata = {
			key: spaceKey,
			genesisFeedKey: controlFeedKey,
			controlFeedKey,
			dataFeedKey,
			state: SpaceState.SPACE_ACTIVE,
			tags
		};
		log("creating space...", {
			spaceId,
			spaceKey
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 352,
			S: this
		});
		const documentIdMapping = {};
		if (options.documents) {
			invariant(Object.keys(options.documents).every((documentId) => /^[a-zA-Z0-9]+$/.test(documentId)), "Invalid document IDs", {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$17,
				L: 357,
				S: this,
				A: ["Object.keys(options.documents).every((documentId) => /^[a-zA-Z0-9]+$/.test(documentId))", "'Invalid document IDs'"]
			});
			await Promise.all(Object.entries(options.documents).map(async ([documentId, data]) => {
				log("creating document...", { documentId }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$17,
					L: 364,
					S: this
				});
				const newDoc = await this._echoHost.createDoc(data, { preserveHistory: true });
				if (newDoc.doc().access !== void 0 && newDoc.doc().access.spaceKey !== spaceKey.toHex()) newDoc.change((doc) => {
					doc.access.spaceKey = spaceKey.toHex();
				});
				documentIdMapping[documentId] = newDoc.documentId;
			}));
		}
		log("opening space...", { spaceKey }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 382,
			S: this
		});
		let root;
		if (options.rootUrl) {
			const newRootDocId = documentIdMapping[interpretAsDocumentId(options.rootUrl)] ?? failedInvariant();
			const rootDocHandle = await this._echoHost.loadDoc(ctx, newRootDocId);
			invariant(rootDocHandle, "Root document must be available after import.", {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$17,
				L: 388,
				S: this,
				A: ["rootDocHandle", "'Root document must be available after import.'"]
			});
			DatabaseRoot.mapLinks(rootDocHandle, documentIdMapping);
			root = await this._echoHost.updateSpaceRoot(ctx, spaceId, `automerge:${newRootDocId}`);
		} else root = await this._echoHost.createSpaceRoot(ctx, spaceKey);
		await this._echoHost.flush(ctx);
		log("constructing space...", { spaceKey }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 397,
			S: this
		});
		const space = await this._constructSpace(ctx, metadata);
		await space.open(ctx);
		log("adding space...", { spaceKey }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 402,
			S: this
		});
		const credentials = await spaceGenesis(this._keyring, this.signingContext, space.inner, root.url, tags, options.membershipPolicy);
		await this._metadataStore.addSpace(metadata);
		const memberCredential = credentials[1];
		invariant(getCredentialAssertion(memberCredential)["@type"] === "dxos.halo.credentials.SpaceMember", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 415,
			S: this,
			A: ["getCredentialAssertion(memberCredential)['@type'] === 'dxos.halo.credentials.SpaceMember'", ""]
		});
		await this.signingContext.recordCredential(memberCredential);
		await space.initializeDataPipeline(ctx);
		log("space ready.", {
			spaceId,
			spaceKey
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 420,
			S: this
		});
		this.updated.emit();
		return space;
	}
	/**
	* Accepts an existing space by joining its swarm and initializing the data pipeline.
	* @param ctx - Caller context for cancellation and tracing.
	* @param opts - Space keys and optional timeframes for catch-up.
	*/
	async acceptSpace(ctx, opts) {
		log("accept space", { opts }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 435,
			S: this
		});
		invariant(this._lifecycleState === LifecycleState.OPEN, "Not open.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 436,
			S: this,
			A: ["this._lifecycleState === LifecycleState.OPEN", "'Not open.'"]
		});
		invariant(!this._spaces.has(opts.spaceKey), "Space already exists.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 437,
			S: this,
			A: ["!this._spaces.has(opts.spaceKey)", "'Space already exists.'"]
		});
		invariant(!this.isSpaceDeleted(opts.spaceKey), "Cannot accept a deleted space.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 438,
			S: this,
			A: ["!this.isSpaceDeleted(opts.spaceKey)", "'Cannot accept a deleted space.'"]
		});
		const tags = opts.tags ? Array.from(opts.tags) : [];
		const metadata = {
			key: opts.spaceKey,
			genesisFeedKey: opts.genesisFeedKey,
			controlTimeframe: opts.controlTimeframe,
			dataTimeframe: opts.dataTimeframe,
			tags
		};
		const space = await this._constructSpace(ctx, metadata);
		await space.open(ctx);
		await this._metadataStore.addSpace(metadata);
		space.initializeDataPipelineAsync(this._ctx);
		this.updated.emit();
		return space;
	}
	/**
	* Whether the space has been tombstoned (soft-deleted). Deleted spaces are never opened or replicated.
	*/
	isSpaceDeleted(spaceKey) {
		return this._metadataStore.deletedSpaces.some((key) => key.equals(spaceKey)) || this._metadataStore.spaces.some((spaceMetadata) => spaceMetadata.key.equals(spaceKey) && spaceMetadata.state === SpaceState.SPACE_DELETED);
	}
	/**
	* Tombstones (soft-deletes) a space initiated locally on this device.
	* Records a SpaceDeleted credential in the HALO so the deletion replicates to the user's other devices,
	* then unloads the space locally. Data is not removed until garbage collection (future work).
	*/
	async markSpaceDeleted(ctx, spaceKey) {
		if (this.isSpaceDeleted(spaceKey)) return;
		const credential = await this.signingContext.credentialSigner.createCredential({
			subject: spaceKey,
			assertion: {
				"@type": "dxos.halo.credentials.SpaceDeleted",
				spaceKey,
				"deletedAt": /* @__PURE__ */ new Date()
			}
		});
		await this.signingContext.recordCredential(credential);
		await this._tombstoneSpace(ctx, spaceKey);
	}
	/**
	* Tombstones a space in response to a SpaceDeleted credential replicated from another device.
	* Does not write a credential (one already exists in the HALO).
	*/
	async handleRemoteSpaceDeleted(ctx, spaceKey) {
		if (this.isSpaceDeleted(spaceKey)) return;
		await this._tombstoneSpace(ctx, spaceKey);
	}
	/**
	* Persists the tombstone and unloads the space if it is currently loaded.
	* Must be called while holding the DataSpaceManager lock (see callers).
	*/
	async _tombstoneSpace(ctx, spaceKey) {
		await this._metadataStore.addDeletedSpace(spaceKey);
		const space = this._spaces.get(spaceKey);
		if (space) {
			if (space.isOpen) await space.close(ctx);
			await space.delete();
			this._spaces.delete(spaceKey);
		}
		this.updated.emit();
	}
	async admitMember(options) {
		const space = this._spaceManager.spaces.get(options.spaceKey);
		invariant(space, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 535,
			S: this,
			A: ["space", ""]
		});
		if (space.spaceState.getMemberRole(options.identityKey) !== SpaceMember$1.Role.REMOVED) throw new AlreadyJoinedError();
		const credentials = await createAdmissionCredentials(this.signingContext.credentialSigner, options.identityKey, space.key, space.genesisFeedKey, options.role, space.spaceState.membershipChainHeads, options.profile, options.delegationCredentialId, space.spaceState.tags);
		invariant(credentials[0].credential, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 555,
			S: this,
			A: ["credentials[0].credential", ""]
		});
		const spaceMemberCredential = credentials[0].credential.credential;
		invariant(getCredentialAssertion(spaceMemberCredential)["@type"] === "dxos.halo.credentials.SpaceMember", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 557,
			S: this,
			A: ["getCredentialAssertion(spaceMemberCredential)['@type'] === 'dxos.halo.credentials.SpaceMember'", ""]
		});
		await writeMessages(space.controlPipeline.writer, credentials);
		return spaceMemberCredential;
	}
	/**
	* Wait until the space data pipeline is fully initialized.
	* Used by invitation handler.
	* TODO(dmaretskyi): Consider removing.
	*/
	async waitUntilSpaceReady(spaceKey) {
		await cancelWithContext(this._ctx, this.updated.waitForCondition(() => {
			const space = this._spaces.get(spaceKey);
			return !!space && space.state === SpaceState.SPACE_READY;
		}));
	}
	async requestSpaceAdmissionCredential(ctx, spaceKey) {
		return this._spaceManager.requestSpaceAdmissionCredential(ctx, {
			spaceKey,
			identityKey: this.signingContext.identityKey,
			timeout: 15e3,
			swarmIdentity: {
				identityKey: this.signingContext.identityKey,
				peerKey: this.signingContext.deviceKey,
				credentialProvider: createAuthProvider(this.signingContext.credentialSigner),
				credentialAuthenticator: async () => true
			}
		});
	}
	async setSpaceEdgeReplicationSetting(ctx, spaceKey, setting) {
		const space = this._spaces.get(spaceKey);
		invariant(space, "Space not found.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 598,
			S: this,
			A: ["space", "'Space not found.'"]
		});
		await this._metadataStore.setSpaceEdgeReplicationSetting(spaceKey, setting);
		if (space.isOpen) switch (setting) {
			case EdgeReplicationSetting.DISABLED:
				await this._echoEdgeReplicator?.disconnectFromSpace(space.id);
				break;
			case EdgeReplicationSetting.ENABLED:
				await this._echoEdgeReplicator?.connectToSpace(ctx, space.id);
				break;
		}
		space.stateUpdate.emit();
	}
	async _constructSpace(ctx, metadata) {
		log("construct space", { metadata }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 617,
			S: this
		});
		const gossip = new Gossip({ localPeerId: this.signingContext.deviceKey });
		const presence = new Presence({
			announceInterval: this._runtimeProps?.spaceMemberPresenceAnnounceInterval ?? PRESENCE_ANNOUNCE_INTERVAL,
			offlineTimeout: this._runtimeProps?.spaceMemberPresenceOfflineTimeout ?? PRESENCE_OFFLINE_TIMEOUT,
			identityKey: this.signingContext.identityKey,
			gossip
		});
		const controlFeed = metadata.controlFeedKey && await this._feedStore.openFeed(metadata.controlFeedKey, { writable: true });
		const dataFeed = metadata.dataFeedKey && await this._feedStore.openFeed(metadata.dataFeedKey, {
			writable: true,
			sparse: true
		});
		const space = await this._spaceManager.constructSpace({
			metadata,
			swarmIdentity: {
				identityKey: this.signingContext.identityKey,
				peerKey: this.signingContext.deviceKey,
				credentialProvider: createAuthProvider(this.signingContext.credentialSigner),
				credentialAuthenticator: deferFunction(() => dataSpace.authVerifier.verifier)
			},
			onAuthorizedConnection: (session) => queueMicrotask(async () => {
				try {
					if (!session.isOpen) return;
					session.addExtension("dxos.mesh.teleport.admission-discovery", new CredentialServerExtension(space));
					session.addExtension("dxos.mesh.teleport.gossip", gossip.createExtension({ remotePeerId: session.remotePeerId }));
					session.addExtension("dxos.mesh.teleport.notarization", dataSpace.notarizationPlugin.createExtension());
					await this._connectEchoMeshReplicator(space, session);
				} catch (err) {
					log.warn("error on authorized connection", { err }, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$17,
						L: 659,
						S: this
					});
					await session.close(err);
				}
			}),
			onAuthFailure: () => {
				log.warn("auth failure", void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$17,
					L: 664,
					S: this
				});
			},
			onMemberRolesChanged: async (members) => {
				if (dataSpace?.state === SpaceState.SPACE_READY) this._handleMemberRoleChanges(presence, space.protocol, members);
			},
			memberKey: this.signingContext.identityKey,
			onDelegatedInvitationStatusChange: (invitation, isActive) => {
				return this._handleInvitationStatusChange(dataSpace, invitation, isActive);
			}
		});
		controlFeed && await space.setControlFeed(controlFeed);
		dataFeed && await space.setDataFeed(dataFeed);
		const dataSpace = new DataSpace({
			inner: space,
			initialState: metadata.state === SpaceState.SPACE_INACTIVE ? SpaceState.SPACE_INACTIVE : SpaceState.SPACE_CLOSED,
			metadataStore: this._metadataStore,
			gossip,
			presence,
			keyring: this._keyring,
			feedStore: this._feedStore,
			echoHost: this._echoHost,
			signingContext: this.signingContext,
			callbacks: {
				beforeReady: async () => {
					log("before space ready", { space: space.key }, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$17,
						L: 691,
						S: this
					});
				},
				afterReady: async () => {
					log("after space ready", {
						space: space.key,
						open: this._lifecycleState === LifecycleState.OPEN
					}, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$17,
						L: 694,
						S: this
					});
					if (this._lifecycleState === LifecycleState.OPEN) {
						await this._createDelegatedInvitations(dataSpace, [...space.spaceState.invitations.entries()]);
						this._handleMemberRoleChanges(presence, space.protocol, [...space.spaceState.members.values()]);
						this.updated.emit();
					}
				},
				beforeClose: async () => {
					log("before space close", { space: space.key }, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$17,
						L: 702,
						S: this
					});
				}
			},
			cache: metadata.cache,
			tags: metadata.tags,
			edgeConnection: this._edgeConnection,
			edgeHttpClient: this._edgeHttpClient,
			edgeFeatures: this._edgeFeatures,
			activeEdgeNotarizationPollingInterval: this._runtimeProps?.activeEdgeNotarizationPollingInterval
		});
		dataSpace.postOpen.append(async () => {
			const setting = dataSpace.getEdgeReplicationSetting();
			if (!setting || setting === EdgeReplicationSetting.ENABLED) await this._echoEdgeReplicator?.connectToSpace(this._ctx, dataSpace.id);
			else if (this._echoEdgeReplicator) log("not connecting edge replicator because of EdgeReplicationSetting", { spaceId: dataSpace.id }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$17,
				L: 718,
				S: this
			});
		});
		dataSpace.preClose.append(async () => {
			const setting = dataSpace.getEdgeReplicationSetting();
			if (!setting || setting === EdgeReplicationSetting.ENABLED) await this._echoEdgeReplicator?.disconnectFromSpace(dataSpace.id);
		});
		presence.newPeer.on((peerState) => {
			if (dataSpace.state === SpaceState.SPACE_READY) this._handleNewPeerConnected(space, peerState);
		});
		if (metadata.controlTimeframe) dataSpace.inner.controlPipeline.state.setTargetTimeframe(metadata.controlTimeframe);
		this._spaces.set(metadata.key, dataSpace);
		return dataSpace;
	}
	async _connectEchoMeshReplicator(space, session) {
		const replicator = this._meshReplicator;
		if (!replicator) {
			log.warn("p2p automerge replication disabled", { space: space.key }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$17,
				L: 745,
				S: this
			});
			return;
		}
		await replicator.authorizeDevice(space.key, session.remotePeerId);
		if (session.isOpen) session.addExtension("dxos.mesh.teleport.automerge", replicator.createExtension());
	}
	_handleMemberRoleChanges(presence, spaceProtocol, memberInfo) {
		let closedSessions = 0;
		for (const member of memberInfo) {
			if (member.key.equals(presence.getLocalState().identityKey)) continue;
			const sessionsToClose = presence.getPeersByIdentityKey(member.key).map((p) => p.peerId && spaceProtocol.sessions.get(p.peerId)).filter((s) => {
				return (s && member.role === SpaceMember$1.Role.REMOVED !== (s.authStatus === AuthStatus.FAILURE)) ?? false;
			});
			sessionsToClose.forEach((session) => {
				session.close().catch(log.error);
			});
			closedSessions += sessionsToClose.length;
		}
		log("processed member role changes", {
			roleChangeCount: memberInfo.length,
			peersOnline: presence.getPeersOnline().length,
			closedSessions
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$17,
			L: 771,
			S: this
		});
		spaceProtocol.updateTopology();
	}
	_handleNewPeerConnected(space, peerState) {
		if (space.spaceState.getMemberRole(peerState.identityKey) === SpaceMember$1.Role.REMOVED) {
			const session = peerState.peerId && space.protocol.sessions.get(peerState.peerId);
			if (session != null) {
				log("closing a session with a removed peer", { peerId: peerState.peerId }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$17,
					L: 785,
					S: this
				});
				session.close().catch(log.error);
			}
		}
	}
	async _handleInvitationStatusChange(dataSpace, delegatedInvitation, isActive) {
		if (dataSpace?.state !== SpaceState.SPACE_READY) return;
		if (isActive) await this._createDelegatedInvitations(dataSpace, [[delegatedInvitation.credentialId, delegatedInvitation.invitation]]);
		else await this._invitationsManager.cancelInvitation(delegatedInvitation.invitation);
	}
	async _createDelegatedInvitations(space, invitations) {
		const tasks = invitations.map(([credentialId, invitation]) => {
			return this._invitationsManager.createInvitation(this._ctx, {
				type: Invitation.Type.DELEGATED,
				kind: Invitation.Kind.SPACE,
				spaceKey: space.key,
				authMethod: invitation.authMethod,
				invitationId: invitation.invitationId,
				swarmKey: invitation.swarmKey,
				guestKeypair: invitation.guestKey ? { publicKey: invitation.guestKey } : void 0,
				lifetime: invitation.expiresOn ? (invitation.expiresOn.getTime() - Date.now()) / 1e3 : void 0,
				multiUse: invitation.multiUse,
				delegationCredentialId: credentialId,
				persistent: false
			});
		});
		await Promise.all(tasks);
	}
};
__decorate([synchronized, trace.span({
	showInBrowserTimeline: true,
	op: "lifecycle"
})], DataSpaceManager.prototype, "_open", null);
__decorate([synchronized], DataSpaceManager.prototype, "_close", null);
__decorate([synchronized, trace.span({
	showInBrowserTimeline: true,
	op: "lifecycle"
})], DataSpaceManager.prototype, "createSpace", null);
__decorate([synchronized, trace.span({
	showInBrowserTimeline: true,
	op: "lifecycle"
})], DataSpaceManager.prototype, "acceptSpace", null);
__decorate([synchronized], DataSpaceManager.prototype, "markSpaceDeleted", null);
__decorate([synchronized], DataSpaceManager.prototype, "handleRemoteSpaceDeleted", null);
DataSpaceManager = __decorate([trackLeaks("open", "close")], DataSpaceManager);
var DataSpaceManagerService = class extends EffectContext.Tag("@dxos/client-services/DataSpaceManager")() {};
/**
* Effect Layer constructing a dormant {@link DataSpaceManager}.
*/
var DataSpaceManagerLayer = (options = {}) => Layer.effect(DataSpaceManagerService, Effect.gen(function* () {
	const spaceManager = yield* SpaceManagerService;
	const metadataStore = yield* IMetadataStoreService;
	const keyring = yield* KeyringApiService;
	const signingContextProvider = yield* SigningContextProviderService;
	const feedStore = yield* FeedStoreService;
	const echoHost = yield* EchoHostService;
	const invitationsManager = yield* InvitationsManagerService;
	const edgeConnection = yield* Effect.serviceOption(EdgeConnectionService);
	const edgeHttpClient = yield* Effect.serviceOption(EdgeHttpClientService);
	const meshReplicator = yield* Effect.serviceOption(MeshEchoReplicatorService);
	const echoEdgeReplicator = yield* Effect.serviceOption(EdgeAutomergeReplicatorService);
	return new DataSpaceManager({
		spaceManager,
		metadataStore,
		keyring,
		signingContextProvider,
		feedStore,
		echoHost,
		invitationsManager,
		edgeConnection: Option.getOrUndefined(edgeConnection),
		edgeHttpClient: Option.getOrUndefined(edgeHttpClient),
		meshReplicator: Option.getOrUndefined(meshReplicator),
		echoEdgeReplicator: Option.getOrUndefined(echoEdgeReplicator),
		...options
	});
}));
//#endregion
//#region src/packlets/space-export/archive-format.ts
var JSON_EXTENSIONS = [
	".dx.json",
	".dx.json.gz",
	".json"
];
var BINARY_EXTENSIONS = [".tar", ".tar.gz"];
/**
* Detect the format of a space archive.
*
* Uses filename extension as the primary signal, and falls back to sniffing
* the first bytes of the archive contents to distinguish JSON from tar.
*/
var detectSpaceArchiveFormat = (archive) => {
	const filename = archive.filename?.toLowerCase() ?? "";
	if (JSON_EXTENSIONS.some((ext) => filename.endsWith(ext))) return SpaceArchive.Format.JSON;
	if (BINARY_EXTENSIONS.some((ext) => filename.endsWith(ext))) return SpaceArchive.Format.BINARY;
	const bytes = archive.contents;
	if (bytes && bytes.length > 0) for (let i = 0; i < Math.min(bytes.length, 16); i++) {
		const byte = bytes[i];
		if (byte === 32 || byte === 9 || byte === 10 || byte === 13) continue;
		if (byte === 123) return SpaceArchive.Format.JSON;
		break;
	}
	return SpaceArchive.Format.BINARY;
};
//#endregion
//#region src/packlets/space-export/serialized-space-reader.ts
var ATTR_TYPE$1 = "@type";
var ATTR_META$1 = "@meta";
var ATTR_DELETED$1 = "@deleted";
var ATTR_PARENT$1 = "@parent";
var ATTR_RELATION_SOURCE$1 = "@relationSource";
var ATTR_RELATION_TARGET$1 = "@relationTarget";
/**
* Type URI of the meta-schema (`TypeSchema` / `Type.Type`). Objects with this
* `@type` represent persisted ECHO type definitions and must be branded
* `system.kind = 'type'` so `Filter.type(Type.Type)` and `Type.isType` recognize
* them after import. Anything else defaults to `'object'` (or `'relation'` when
* source/target attrs are present).
*/
var TYPE_KIND_SCHEMA_URI = Type.getURI(Type.Type).toString();
var INTERNAL_KEYS = /* @__PURE__ */ new Set([
	"id",
	ATTR_TYPE$1,
	ATTR_META$1,
	ATTR_DELETED$1,
	ATTR_PARENT$1,
	ATTR_RELATION_SOURCE$1,
	ATTR_RELATION_TARGET$1
]);
/**
* Parse a JSON space archive.
*
* The archive contents are expected to be the UTF-8 encoding of
* `JSON.stringify(serializedSpace)`.
*/
var readSerializedSpaceArchive = (archive) => {
	const text = new TextDecoder().decode(archive.contents);
	const parsed = JSON.parse(text);
	assertArgument(typeof parsed === "object" && parsed !== null, "archive", "Invalid JSON archive payload");
	assertArgument(typeof parsed.version === "number", "archive", "Missing SerializedSpace.version");
	assertArgument(Array.isArray(parsed.objects), "archive", "Missing SerializedSpace.objects");
	return parsed;
};
/**
* Convert an {@link Obj.JSON} back into an internal {@link EntityStructure} suitable
* for embedding into a {@link DatabaseDirectory}.
*/
var objJsonToObjectStructure = (obj) => {
	const data = {};
	for (const [key, value] of Object.entries(obj)) {
		if (INTERNAL_KEYS.has(key)) continue;
		data[key] = value;
	}
	const system = {};
	const type = obj[ATTR_TYPE$1];
	if (type) system.type = { "/": URI.make(type) };
	const parent = obj[ATTR_PARENT$1];
	if (typeof parent === "string") system.parent = { "/": URI.make(parent) };
	const relationSource = obj[ATTR_RELATION_SOURCE$1];
	const relationTarget = obj[ATTR_RELATION_TARGET$1];
	if (typeof relationSource === "string" || typeof relationTarget === "string") {
		system.kind = "relation";
		if (typeof relationSource === "string") system.source = { "/": URI.make(relationSource) };
		if (typeof relationTarget === "string") system.target = { "/": URI.make(relationTarget) };
	} else if (type === TYPE_KIND_SCHEMA_URI) system.kind = "type";
	else system.kind = "object";
	if (obj[ATTR_DELETED$1]) system.deleted = true;
	const meta = obj[ATTR_META$1];
	return {
		system,
		meta: {
			keys: meta?.keys ?? [],
			...meta?.tags ? { tags: meta.tags } : {},
			...meta?.key !== void 0 ? { key: meta.key } : {},
			...meta?.version !== void 0 ? { version: meta.version } : {},
			...meta?.annotations ? { annotations: meta.annotations } : {}
		},
		data
	};
};
/**
* Build a new {@link DatabaseDirectory} containing every object from the archive,
* keyed by object id. The caller is responsible for stamping the `access` (space id/key)
* and version fields after the document is created.
*/
var buildDatabaseDirectoryFromObjects = (objects) => {
	const map = {};
	for (const obj of objects) map[obj.id] = objJsonToObjectStructure(obj);
	return {
		objects: map,
		links: {}
	};
};
//#endregion
//#region src/packlets/space-export/serialized-space-writer.ts
var __dxlog_file$16 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/space-export/serialized-space-writer.ts";
var SERIALIZED_SPACE_VERSION = 1;
var FEED_TYPENAME = "org.dxos.type.feed";
var ATTR_ID = "id";
var ATTR_TYPE = "@type";
var ATTR_META = "@meta";
var ATTR_DELETED = "@deleted";
var ATTR_PARENT = "@parent";
var ATTR_RELATION_SOURCE = "@relationSource";
var ATTR_RELATION_TARGET = "@relationTarget";
/**
* Canonical order of well-known system fields in a serialized object.
* All remaining `@*` fields follow in the order they appear on the source
* object, and finally the data fields are appended in their existing order.
*/
var SYSTEM_FIELD_ORDER = [
	ATTR_ID,
	ATTR_TYPE,
	ATTR_META,
	ATTR_DELETED,
	ATTR_PARENT,
	ATTR_RELATION_SOURCE,
	ATTR_RELATION_TARGET
];
/**
* Reorder the keys of an {@link Obj.JSON} so that system fields appear first
* (`id`, `@type`, `@meta`, then any other `@*` attributes), followed by data
* fields. The returned object has identical values to the input — only the key
* iteration order changes.
*/
var orderObjJsonFields = (obj) => {
	const source = obj;
	const result = {};
	for (const key of SYSTEM_FIELD_ORDER) if (key in source) result[key] = source[key];
	for (const key of Object.keys(source)) if (key.startsWith("@") && !(key in result)) result[key] = source[key];
	for (const key of Object.keys(source)) if (!(key in result)) result[key] = source[key];
	return result;
};
/**
* Write a JSON space archive from a live {@link DataSpace}.
*
* This runs entirely inside the worker and walks automerge documents directly —
* it does not require a client-side {@link EchoDatabase}. The output conforms to
* {@link SerializedSpace} and is compatible with the JSON format consumed by the
* importer in {@link readSerializedSpaceArchive}.
*/
var writeSerializedSpaceArchive = async (options) => {
	const { space, echoHost, exportedBy } = options;
	const rootUrl = space.automergeSpaceState.lastEpoch?.subject.assertion.automergeRoot;
	assertState(rootUrl, "Space does not have a root URL");
	const databaseRoot = space.databaseRoot;
	assertState(databaseRoot, "Space database root is not ready");
	const rootDoc = databaseRoot.doc();
	invariant(rootDoc, "Space database root document is not loaded", {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$16,
		L: 105,
		S: void 0,
		A: ["rootDoc", "'Space database root document is not loaded'"]
	});
	const objects = [];
	collectObjectsFromDoc(rootDoc, objects);
	for (const linkedUrl of databaseRoot.getAllLinkedDocuments()) {
		const handle = await echoHost.loadDoc(Context.default(void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$16,
			L: 112
		}), linkedUrl);
		if (!handle) {
			log.warn("linked document handle not available; skipping", { url: linkedUrl }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$16,
				L: 114,
				S: void 0
			});
			continue;
		}
		collectObjectsFromDoc(handle.doc(), objects);
	}
	const feeds = await exportFeedData(space, echoHost, objects);
	const serialized = {
		version: SERIALIZED_SPACE_VERSION,
		timestamp: (/* @__PURE__ */ new Date()).toISOString(),
		originalSpaceId: space.id,
		exportedBy,
		createdAt: Date.now(),
		objects,
		...feeds.length > 0 ? { feeds } : {}
	};
	const encoded = new TextEncoder().encode(JSON.stringify(serialized));
	return {
		filename: createFilename({
			parts: [space.id],
			ext: "dx.json"
		}),
		contents: encoded,
		format: SpaceArchive.Format.JSON
	};
};
var collectObjectsFromDoc = (doc, out) => {
	const docObjects = doc.objects ?? {};
	for (const [objectId, structure] of Object.entries(docObjects)) out.push(objectStructureToObjJson(objectId, structure));
};
/**
* Convert an internal {@link EntityStructure} into an {@link Obj.JSON}.
*
* Unlike the equivalent helper used for indexing, this preserves the object's
* `@meta` section so archives produced by this writer can be round-tripped
* through {@link Obj.fromJSON}.
*/
var objectStructureToObjJson = (objectId, structure) => {
	const result = {
		[ATTR_ID]: objectId,
		[ATTR_TYPE]: structure.system?.type?.["/"] ?? ""
	};
	if (structure.meta) result[ATTR_META] = {
		keys: structure.meta.keys ?? [],
		...structure.meta.tags ? { tags: structure.meta.tags } : {},
		...structure.meta.key !== void 0 ? { key: structure.meta.key } : {},
		...structure.meta.version !== void 0 ? { version: structure.meta.version } : {},
		...structure.meta.annotations && Object.keys(structure.meta.annotations).length > 0 ? { annotations: structure.meta.annotations } : {}
	};
	if (structure.system?.deleted) result[ATTR_DELETED] = true;
	if (structure.system?.parent) result[ATTR_PARENT] = structure.system.parent["/"];
	if (structure.system?.source) result[ATTR_RELATION_SOURCE] = structure.system.source["/"];
	if (structure.system?.target) result[ATTR_RELATION_TARGET] = structure.system.target["/"];
	Object.assign(result, structure.data);
	return result;
};
var exportFeedData = async (space, echoHost, objects) => {
	const feeds = [];
	const spaceId = space.id;
	for (const obj of objects) {
		if (obj[ATTR_TYPE] == null) continue;
		const typeDxn = obj[ATTR_TYPE];
		if ((DXN.isDXN(typeDxn) ? DXN.getName(typeDxn) : void 0) !== FEED_TYPENAME) continue;
		const namespace = obj.namespace === "trace" ? "trace" : "data";
		try {
			const messages = await collectFeedMessages(echoHost, spaceId, obj.id, namespace);
			if (messages.length > 0) feeds.push({
				feedObjectId: obj.id,
				namespace,
				messages
			});
		} catch (err) {
			log.warn("failed to export feed data", {
				feedObjectId: obj.id,
				error: err
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$16,
				L: 223,
				S: void 0
			});
		}
	}
	return feeds;
};
var collectFeedMessages = async (echoHost, spaceId, feedId, namespace) => {
	const feedNamespace = namespace === "trace" ? FeedProtocol.WellKnownNamespaces.trace : FeedProtocol.WellKnownNamespaces.data;
	const messages = [];
	let cursor;
	const scope = Effect.runSync(Scope.make());
	const feedClient = await EffectEx.runPromise(makeInProcessClient(FeedService.Rpcs, echoHost.feedService).pipe(Effect.provideService(Scope.Scope, scope)));
	try {
		while (true) {
			const result = await EffectEx.runPromise(feedClient.FeedService.queryFeed({ query: {
				spaceId,
				feedIds: [feedId],
				feedNamespace,
				after: cursor
			} }));
			const batch = (result.objects ?? []).flatMap((encoded) => {
				try {
					return [JSON.parse(encoded)];
				} catch (err) {
					log.verbose("feed object JSON parse failed; object ignored", {
						encoded,
						error: err
					}, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$16,
						L: 264,
						S: void 0
					});
					return [];
				}
			});
			if (batch.length === 0) break;
			for (const message of batch) messages.push(orderObjJsonFields(message));
			if (!result.nextCursor || result.nextCursor === cursor) break;
			cursor = result.nextCursor;
		}
	} finally {
		await EffectEx.runPromise(Scope.close(scope, Exit.void));
	}
	return messages;
};
//#endregion
//#region src/packlets/space-export/space-archive-reader.ts
var __dxlog_file$15 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/space-export/space-archive-reader.ts";
var extractSpaceArchive = async (archive) => {
	const { Archive } = await import("@obsidize/tar-browserify");
	const { entries } = await Archive.extract(archive.contents);
	const metadataEntry = entries.find((entry) => entry.fileName === SpaceArchiveFileStructure.metadata);
	assertArgument(metadataEntry, "metadataEntry", "Metadata entry not found");
	const metadata = JSON.parse(metadataEntry.getContentAsText());
	const documents = {};
	for (const entry of entries.filter((entry) => entry.fileName.startsWith(`${SpaceArchiveFileStructure.documents}/`))) {
		const documentId = entry.fileName.replace(`${SpaceArchiveFileStructure.documents}/`, "").replace(/\.bin$/, "");
		invariant(!documentId.includes("/"), void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$15,
			L: 42,
			S: void 0,
			A: ["!documentId.includes('/')", ""]
		});
		documents[documentId] = entry.content ?? failedInvariant();
	}
	const feeds = {};
	const feedsPrefix = `${SpaceArchiveFileStructure.feeds}/`;
	const feedEntries = entries.filter((entry) => entry.fileName.startsWith(feedsPrefix));
	const feedMetadataByFeedId = /* @__PURE__ */ new Map();
	const feedBlocksByFeedId = /* @__PURE__ */ new Map();
	for (const entry of feedEntries) {
		const pathParts = entry.fileName.slice(feedsPrefix.length).split("/");
		if (pathParts.length !== 2) continue;
		const [feedId, fileName] = pathParts;
		invariant(feedId, "Feed ID is required", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$15,
			L: 61,
			S: void 0,
			A: ["feedId", "'Feed ID is required'"]
		});
		invariant(fileName, "File name is required", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$15,
			L: 62,
			S: void 0,
			A: ["fileName", "'File name is required'"]
		});
		if (fileName === SpaceArchiveFileStructure.feedMetadata) {
			const feedMetadata = JSON.parse(entry.getContentAsText());
			feedMetadataByFeedId.set(feedId, feedMetadata);
		} else if (fileName.startsWith(SpaceArchiveFileStructure.feedBlocksPrefix) && fileName.endsWith(".json")) {
			const chunkIndexStr = fileName.slice(SpaceArchiveFileStructure.feedBlocksPrefix.length).replace(/\.json$/, "");
			const chunkIndex = parseInt(chunkIndexStr, 10);
			invariant(!isNaN(chunkIndex), `Invalid chunk index: ${chunkIndexStr}`, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$15,
				L: 70,
				S: void 0,
				A: ["!isNaN(chunkIndex)", "`Invalid chunk index: ${chunkIndexStr}`"]
			});
			const blocks = JSON.parse(entry.getContentAsText());
			if (!feedBlocksByFeedId.has(feedId)) feedBlocksByFeedId.set(feedId, /* @__PURE__ */ new Map());
			feedBlocksByFeedId.get(feedId).set(chunkIndex, blocks);
		}
	}
	for (const [feedId, feedMetadata] of feedMetadataByFeedId) {
		const blockChunks = feedBlocksByFeedId.get(feedId) ?? /* @__PURE__ */ new Map();
		const sortedChunkIndices = Array.from(blockChunks.keys()).sort((a, b) => a - b);
		const allBlocks = [];
		for (const chunkIndex of sortedChunkIndices) allBlocks.push(...blockChunks.get(chunkIndex));
		feeds[feedId] = {
			metadata: feedMetadata,
			blocks: allBlocks
		};
	}
	log("extracted space archive", {
		metadata,
		documents,
		feedCount: Object.keys(feeds).length
	}, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file$15,
		L: 93,
		S: void 0
	});
	return {
		metadata,
		documents,
		feeds
	};
};
//#endregion
//#region src/packlets/space-export/space-archive-writer.ts
var CURRENT_VERSION = SpaceArchiveVersion.V1;
var SpaceArchiveWriter = class extends Resource {
	_tar;
	_archive;
	_meta = void 0;
	_currentRootUrl = void 0;
	async _open(ctx) {
		this._tar = await import("@obsidize/tar-browserify");
	}
	async _close() {
		return Promise.resolve();
	}
	async begin(meta) {
		assertState(this._tar, "Not open");
		assertState(!this._meta, "Already started");
		this._meta = meta;
		this._archive = new this._tar.Archive();
	}
	async setCurrentRootUrl(url) {
		assertArgument(url.startsWith("automerge:"), "url", "Invalid root URL");
		assertState(this._tar, "Not open");
		assertState(this._meta, "Not started");
		this._currentRootUrl = url;
	}
	async writeDocument(documentId, data) {
		assertArgument(!documentId.startsWith("automerge:"), "documentId", "Invalid document ID");
		assertState(this._archive, "Not open");
		this._archive.addBinaryFile(`${SpaceArchiveFileStructure.documents}/${documentId}.bin`, data);
	}
	/**
	* Writes a feed with its metadata and blocks to the archive.
	* Blocks are written in chunks of {@link FEED_ARCHIVE_BLOCKS_PER_CHUNK}.
	*/
	async writeFeed(feedId, namespace, blocks) {
		assertArgument(feedId, "feedId", "Feed ID is required");
		assertArgument(namespace, "namespace", "Namespace is required");
		assertState(this._archive, "Not open");
		const feedPath = `${SpaceArchiveFileStructure.feeds}/${feedId}`;
		const metadata = {
			id: feedId,
			namespace
		};
		this._archive.addTextFile(`${feedPath}/${SpaceArchiveFileStructure.feedMetadata}`, JSON.stringify(metadata));
		for (let chunkIndex = 0; chunkIndex * FEED_ARCHIVE_BLOCKS_PER_CHUNK < blocks.length; chunkIndex++) {
			const start = chunkIndex * FEED_ARCHIVE_BLOCKS_PER_CHUNK;
			const end = Math.min(start + FEED_ARCHIVE_BLOCKS_PER_CHUNK, blocks.length);
			const chunk = blocks.slice(start, end);
			this._archive.addTextFile(`${feedPath}/${SpaceArchiveFileStructure.feedBlocksPrefix}${chunkIndex}.json`, JSON.stringify(chunk));
		}
	}
	async finish() {
		assertState(this._archive, "Not open");
		assertState(this._meta, "Not started");
		assertState(this._meta.spaceId, "No space ID set");
		assertState(this._currentRootUrl, "No root URL set");
		const metadata = {
			version: CURRENT_VERSION,
			createdAt: Date.now(),
			exportedBy: this._meta.exportedBy,
			originalSpaceId: this._meta.spaceId,
			echo: { currentRootUrl: this._currentRootUrl }
		};
		this._archive.addTextFile(SpaceArchiveFileStructure.metadata, JSON.stringify(metadata));
		const binary = this._archive.toUint8Array();
		return {
			filename: createFilename({
				parts: [this._meta.spaceId],
				ext: "tar"
			}),
			contents: binary,
			format: SpaceArchive.Format.BINARY
		};
	}
};
//#endregion
//#region src/packlets/spaces/spaces-service.ts
var __dxlog_file$14 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/spaces/spaces-service.ts";
var SpacesServiceImpl = class {
	_identityManager;
	_spaceManager;
	_echoHost;
	_getDataSpaceManager;
	"constructor"(_identityManager, _spaceManager, _echoHost, _getDataSpaceManager) {
		this._identityManager = _identityManager;
		this._spaceManager = _spaceManager;
		this._echoHost = _echoHost;
		this._getDataSpaceManager = _getDataSpaceManager;
	}
	["SpacesService.createSpace"](request) {
		return Effect.tryPromise({
			try: async () => {
				this._requireIdentity();
				const ctx = new Context(void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$14,
					L: 89
				});
				const space = await (await this._getDataSpaceManager()).createSpace(ctx, {
					tags: request?.tags,
					membershipPolicy: request?.membershipPolicy
				});
				await this._updateMetrics();
				return this._serializeSpace(space);
			},
			catch: (error) => error
		});
	}
	["SpacesService.updateSpace"]({ spaceKey, state, edgeReplication }) {
		return Effect.tryPromise({
			try: async () => {
				const ctx = Context.default(void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$14,
					L: 105
				});
				const dataSpaceManager = await this._getDataSpaceManager();
				const space = dataSpaceManager.spaces.get(spaceKey) ?? raise(new SpaceNotFoundError(spaceKey));
				if (state) switch (state) {
					case SpaceState.SPACE_ACTIVE:
						await space.activate(ctx);
						break;
					case SpaceState.SPACE_INACTIVE:
						await space.deactivate(ctx);
						break;
					case SpaceState.SPACE_DELETED:
						await dataSpaceManager.markSpaceDeleted(ctx, spaceKey);
						return;
					default: throw new ApiError({ message: "Invalid space state" });
				}
				if (edgeReplication !== void 0) await dataSpaceManager.setSpaceEdgeReplicationSetting(ctx, spaceKey, edgeReplication);
			},
			catch: (error) => error
		});
	}
	["SpacesService.updateMemberRole"](request) {
		return Effect.tryPromise({
			try: async () => {
				const identity = this._requireIdentity();
				const space = this._spaceManager.spaces.get(request.spaceKey);
				if (space == null) throw new SpaceNotFoundError(request.spaceKey);
				if (!space.spaceState.hasMembershipManagementPermission(identity.identityKey)) throw new AuthorizationError({
					message: "No member management permission.",
					context: {
						spaceKey: space.key,
						role: space.spaceState.getMemberRole(identity.identityKey)
					}
				});
				const credentials = await createAdmissionCredentials(identity.getIdentityCredentialSigner(), request.memberKey, space.key, space.genesisFeedKey, request.newRole, space.spaceState.membershipChainHeads);
				invariant(credentials[0].credential, void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$14,
					L: 161,
					S: this,
					A: ["credentials[0].credential", ""]
				});
				const spaceMemberCredential = credentials[0].credential.credential;
				invariant(getCredentialAssertion(spaceMemberCredential)["@type"] === "dxos.halo.credentials.SpaceMember", void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$14,
					L: 163,
					S: this,
					A: ["getCredentialAssertion(spaceMemberCredential)['@type'] === 'dxos.halo.credentials.SpaceMember'", ""]
				});
				await writeMessages(space.controlPipeline.writer, credentials);
			},
			catch: (error) => error
		});
	}
	["SpacesService.querySpaces"]() {
		return EffectStream.async((emit) => {
			const ctx = Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$14,
				L: 172
			});
			const scheduler = new UpdateScheduler(ctx, async () => {
				const dataSpaceManager = await this._getDataSpaceManager();
				const spaces = await Promise.all(Array.from(dataSpaceManager.spaces.values()).map((space) => this._serializeSpace(space)));
				log("update", () => ({ ids: spaces.map((space) => space.id) }), {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$14,
					L: 180,
					S: this
				});
				await this._updateMetrics();
				emit.single({ spaces });
			}, { maxFrequency: process.env.NODE_ENV === "test" ? void 0 : 2 });
			scheduleTask(ctx, async () => {
				const dataSpaceManager = await this._getDataSpaceManager();
				const subscriptions = new SubscriptionList();
				ctx.onDispose(() => subscriptions.clear());
				const subscribeSpaces = () => {
					subscriptions.clear();
					for (const space of dataSpaceManager.spaces.values()) {
						let lastState;
						subscriptions.add(space.stateUpdate.on(ctx, () => {
							if (space.state !== lastState) scheduler.forceTrigger();
							else scheduler.trigger();
							lastState = space.state;
						}));
						subscriptions.add(space.presence.updated.on(ctx, () => scheduler.trigger()));
						subscriptions.add(space.automergeSpaceState.onNewEpoch.on(ctx, () => scheduler.trigger()));
						subscriptions.add(space.inner.controlPipeline.state.timeframeUpdate.on(ctx, () => scheduler.trigger()));
					}
				};
				dataSpaceManager.updated.on(ctx, () => {
					subscribeSpaces();
					scheduler.trigger();
				});
				subscribeSpaces();
				scheduler.trigger();
			});
			if (!this._identityManager.identity) emit.single({ spaces: [] });
			return Effect.promise(() => ctx.dispose());
		});
	}
	["SpacesService.postMessage"]({ spaceKey, channel, message }) {
		return Effect.tryPromise({
			try: async () => {
				await ((await this._getDataSpaceManager()).spaces.get(spaceKey) ?? raise(new SpaceNotFoundError(spaceKey))).postMessage(getChannelId(channel), message);
			},
			catch: (error) => error
		});
	}
	["SpacesService.subscribeMessages"]({ spaceKey, channel }) {
		return EffectStream.async((emit) => {
			const ctx = Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$14,
				L: 252
			});
			scheduleTask(ctx, async () => {
				const handle = ((await this._getDataSpaceManager()).spaces.get(spaceKey) ?? raise(new SpaceNotFoundError(spaceKey))).listen(getChannelId(channel), (message) => {
					emit.single(message);
				});
				ctx.onDispose(() => handle.unsubscribe());
			});
			return Effect.promise(() => ctx.dispose());
		});
	}
	["SpacesService.queryCredentials"]({ spaceKey, noTail }) {
		return EffectStream.async((emit) => {
			const ctx = Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$14,
				L: 271
			});
			const space = this._spaceManager.spaces.get(spaceKey) ?? raise(new SpaceNotFoundError(spaceKey));
			const processor = { processCredential: async (credential) => {
				emit.single(credential);
			} };
			ctx.onDispose(() => space.spaceState.removeCredentialProcessor(processor));
			scheduleTask(ctx, async () => {
				await space.spaceState.addCredentialProcessor(processor);
				if (noTail) emit.end();
			});
			return Effect.promise(() => ctx.dispose());
		});
	}
	["SpacesService.writeCredentials"]({ spaceKey, credentials }) {
		return Effect.tryPromise({
			try: async () => {
				const space = this._spaceManager.spaces.get(spaceKey) ?? raise(new SpaceNotFoundError(spaceKey));
				for (const credential of credentials ?? []) if (credential.proof) await space.controlPipeline.writer.write({ credential: { credential } });
				else {
					invariant(!credential.id, "Id on unsigned credentials is not allowed", {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$14,
						L: 299,
						S: this,
						A: ["!credential.id", "'Id on unsigned credentials is not allowed'"]
					});
					invariant(this._identityManager.identity, "Identity is not available", {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$14,
						L: 300,
						S: this,
						A: ["this._identityManager.identity", "'Identity is not available'"]
					});
					const signer = this._identityManager.identity.getIdentityCredentialSigner();
					invariant(credential.issuer.equals(signer.getIssuer()), void 0, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$14,
						L: 302,
						S: this,
						A: ["credential.issuer.equals(signer.getIssuer())", ""]
					});
					const signedCredential = await signer.createCredential({
						subject: credential.subject.id,
						assertion: credential.subject.assertion
					});
					await space.controlPipeline.writer.write({ credential: { credential: signedCredential } });
				}
			},
			catch: (error) => error
		});
	}
	["SpacesService.createEpoch"]({ spaceKey, migration, automergeRootUrl }) {
		return Effect.tryPromise({
			try: async () => {
				const result = await ((await this._getDataSpaceManager()).spaces.get(spaceKey) ?? raise(new SpaceNotFoundError(spaceKey))).createEpoch({
					migration,
					newAutomergeRoot: automergeRootUrl
				});
				return {
					epochCredential: result?.credential,
					controlTimeframe: result?.timeframe
				};
			},
			catch: (error) => error
		});
	}
	["SpacesService.admitContact"](request) {
		return Effect.tryPromise({
			try: async () => {
				await (await this._getDataSpaceManager()).admitMember({
					spaceKey: request.spaceKey,
					identityKey: request.contact.identityKey,
					role: request.role
				});
			},
			catch: (error) => error
		});
	}
	["SpacesService.joinBySpaceKey"]({ spaceKey }) {
		return Effect.tryPromise({
			try: async () => {
				const ctx = Context.default(void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$14,
					L: 348
				});
				const credential = await (await this._getDataSpaceManager()).requestSpaceAdmissionCredential(ctx, spaceKey);
				return this._joinByAdmission(ctx, { credential });
			},
			catch: (error) => error
		});
	}
	["SpacesService.exportSpace"](request) {
		return Effect.tryPromise({
			try: async () => {
				try {
					var _usingCtx$3 = _usingCtx();
					assertArgument(SpaceId.isValid(request.spaceId), "spaceId", "Invalid space ID");
					const space = (await this._getDataSpaceManager()).getSpaceById(request.spaceId) ?? raise(/* @__PURE__ */ new Error("Space not found"));
					if ((request.format ?? SpaceArchive.Format.BINARY) === SpaceArchive.Format.JSON) return { archive: await writeSerializedSpaceArchive({
						space,
						echoHost: this._echoHost
					}) };
					const writer = _usingCtx$3.a(await new SpaceArchiveWriter().open());
					await writer.begin({ spaceId: space.id });
					const rootUrl = space.automergeSpaceState.lastEpoch?.subject.assertion.automergeRoot;
					assertState(rootUrl, "Space does not have a root URL");
					await writer.setCurrentRootUrl(rootUrl);
					for await (const [documentId, data] of space.getAllDocuments()) await writer.writeDocument(documentId, data);
					const feeds = await space.getAllFeeds();
					for (const feed of feeds) {
						const archiveBlocks = feed.blocks.map((block) => ({
							actorId: block.actorId,
							sequence: block.sequence,
							prevActorId: block.prevActorId,
							prevSequence: block.prevSequence,
							position: block.position,
							timestamp: block.timestamp,
							data: Buffer.from(block.data).toString("base64")
						}));
						await writer.writeFeed(feed.feedId, feed.feedNamespace, archiveBlocks);
					}
					return { archive: await writer.finish() };
				} catch (_) {
					_usingCtx$3.e = _;
				} finally {
					await _usingCtx$3.d();
				}
			},
			catch: (error) => error
		});
	}
	["SpacesService.importSpace"](request) {
		return Effect.tryPromise({
			try: async () => {
				const ctx = Context.default(void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$14,
					L: 405
				});
				const dataSpaceManager = await this._getDataSpaceManager();
				if ((request.archive.format ?? detectSpaceArchiveFormat(request.archive)) === SpaceArchive.Format.JSON) {
					const serialized = readSerializedSpaceArchive(request.archive);
					const space = await dataSpaceManager.createSpace(ctx, { tags: request.tags });
					await this._hydrateSpaceFromSerialized(space, serialized);
					await this._updateMetrics();
					return { newSpaceId: space.id };
				}
				const extracted = await extractSpaceArchive(request.archive);
				invariant(extracted.metadata.echo?.currentRootUrl, "Space archive does not contain a root URL", {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$14,
					L: 418,
					S: this,
					A: ["extracted.metadata.echo?.currentRootUrl", "'Space archive does not contain a root URL'"]
				});
				const space = await dataSpaceManager.createSpace(ctx, {
					documents: extracted.documents,
					rootUrl: extracted.metadata.echo?.currentRootUrl,
					tags: request.tags
				});
				await this._updateMetrics();
				return { newSpaceId: space.id };
			},
			catch: (error) => error
		});
	}
	/**
	* Populate a freshly-created space with the objects and feed messages described in a {@link SerializedSpace}.
	*
	* Objects are written directly into the space's automerge root document as inline
	* {@link EntityStructure} entries; feed messages are appended to the appropriate feed
	* via {@link EchoHost.feedService}.
	*/
	async "_hydrateSpaceFromSerialized"(space, serialized) {
		const databaseRoot = space.databaseRoot;
		assertState(databaseRoot, "Space database root is not ready");
		databaseRoot.handle.change((doc) => {
			if (!doc.objects) doc.objects = {};
			for (const obj of serialized.objects) doc.objects[obj.id] = objJsonToObjectStructure(obj);
		});
		for (const feed of serialized.feeds ?? []) {
			if (feed.messages.length === 0) continue;
			const namespace = feed.namespace === "trace" ? FeedProtocol.WellKnownNamespaces.trace : FeedProtocol.WellKnownNamespaces.data;
			try {
				const feedService = this._echoHost.feedService;
				await EffectEx.runPromise(Effect.gen(function* () {
					yield* (yield* makeInProcessClient(FeedService.Rpcs, feedService)).FeedService.insertIntoFeed({
						spaceId: space.id,
						feedId: feed.feedObjectId,
						subspaceTag: namespace,
						objects: feed.messages.map((message) => JSON.stringify(message))
					});
				}).pipe(Effect.scoped));
			} catch (err) {
				log.warn("failed to import feed data", {
					feedObjectId: feed.feedObjectId,
					error: err
				}, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$14,
					L: 476,
					S: this
				});
			}
		}
	}
	async "_joinByAdmission"(ctx, { credential }) {
		const assertion = getCredentialAssertion(credential);
		invariant(assertion["@type"] === "dxos.halo.credentials.SpaceMember", "Invalid credential", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$14,
			L: 483,
			S: this,
			A: ["assertion['@type'] === 'dxos.halo.credentials.SpaceMember'", "'Invalid credential'"]
		});
		const myIdentity = this._identityManager.identity;
		invariant(myIdentity && credential.subject.id.equals(myIdentity.identityKey), void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$14,
			L: 485,
			S: this,
			A: ["myIdentity && credential.subject.id.equals(myIdentity.identityKey)", ""]
		});
		const dataSpaceManager = await this._getDataSpaceManager();
		let dataSpace = dataSpaceManager.spaces.get(assertion.spaceKey);
		if (!dataSpace) {
			dataSpace = await dataSpaceManager.acceptSpace(ctx, {
				spaceKey: assertion.spaceKey,
				genesisFeedKey: assertion.genesisFeedKey,
				tags: assertion.tags
			});
			await myIdentity.controlPipeline.writer.write({ credential: { credential } });
		}
		return { space: await this._serializeSpace(dataSpace) };
	}
	async "_serializeSpace"(space) {
		return {
			id: space.id,
			spaceKey: space.key,
			state: space.state,
			error: space.error ? encodeError(space.error) : void 0,
			pipeline: {
				currentEpoch: space.automergeSpaceState.lastEpoch,
				appliedEpoch: space.automergeSpaceState.lastEpoch,
				controlFeeds: space.inner.controlPipeline.state.feeds.map((feed) => feed.key),
				currentControlTimeframe: space.inner.controlPipeline.state.timeframe,
				targetControlTimeframe: space.inner.controlPipeline.state.targetTimeframe,
				totalControlTimeframe: space.inner.controlPipeline.state.endTimeframe,
				dataFeeds: void 0,
				startDataTimeframe: void 0,
				currentDataTimeframe: void 0,
				targetDataTimeframe: void 0,
				totalDataTimeframe: void 0,
				spaceRootUrl: space.databaseRoot?.url
			},
			members: await Promise.all(Array.from(space.inner.spaceState.members.values()).map(async (member) => {
				const peers = space.presence.getPeersOnline().filter(({ identityKey }) => identityKey.equals(member.key));
				if (this._identityManager.identity?.identityKey.equals(member.key)) peers.push(space.presence.getLocalState());
				return {
					identity: {
						did: await createDidFromIdentityKey(member.key),
						identityKey: member.key,
						profile: member.profile ?? {}
					},
					role: member.role,
					presence: peers.length > 0 ? SpaceMember.PresenceState.ONLINE : SpaceMember.PresenceState.OFFLINE,
					peerStates: peers
				};
			})),
			creator: space.inner.spaceState.creator?.key,
			tags: space.tags,
			membershipPolicy: space.membershipPolicy,
			cache: space.cache,
			metrics: space.metrics,
			edgeReplication: space.getEdgeReplicationSetting()
		};
	}
	"_requireIdentity"() {
		if (!this._identityManager.identity) throw new IdentityNotInitializedError({ message: "This device has no HALO identity available. See https://docs.dxos.org/guide/platform/halo" });
		return this._identityManager.identity;
	}
	async "_updateMetrics"() {
		const dataSpaceManager = await this._getDataSpaceManager();
		const identity = this._identityManager.identity?.identityKey.truncate();
		if (identity) trace.metrics.gauge("dxos.echo.space.count", dataSpaceManager.spaces.size, { tags: { identity } });
	}
};
var getChannelId = (channel) => `user-channel/${channel}`;
//#endregion
//#region src/packlets/identity/identity.ts
var __dxlog_file$13 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/identity/identity.ts";
/**
* Agent identity manager, which includes the agent's Halo space.
*/
var Identity = class {
	space;
	_signer;
	_presence;
	_deviceStateMachine;
	_profileStateMachine;
	_edgeFeedReplicator = void 0;
	authVerifier;
	did;
	identityKey;
	deviceKey;
	stateUpdate = new Event();
	constructor(params) {
		this.space = params.space;
		this._signer = params.signer;
		this._presence = params.presence;
		this.did = params.did;
		this.identityKey = params.identityKey;
		this.deviceKey = params.deviceKey;
		log.trace("dxos.halo.device", { deviceKey: params.deviceKey }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$13,
			L: 78,
			S: this
		});
		this._deviceStateMachine = new DeviceStateMachine({
			identityKey: this.identityKey,
			deviceKey: this.deviceKey,
			onUpdate: () => this.stateUpdate.emit()
		});
		this._profileStateMachine = new ProfileStateMachine({
			identityKey: this.identityKey,
			onUpdate: () => this.stateUpdate.emit()
		});
		this.authVerifier = new TrustedKeySetAuthVerifier({
			trustedKeysProvider: () => new ComplexSet(PublicKey.hash, this.authorizedDeviceKeys.keys()),
			update: this.stateUpdate,
			authTimeout: AUTH_TIMEOUT
		});
		if (params.edgeConnection && params.edgeFeatures?.feedReplicator) this._edgeFeedReplicator = new EdgeFeedReplicator({
			messenger: params.edgeConnection,
			spaceId: this.space.id
		});
	}
	get authorizedDeviceKeys() {
		return this._deviceStateMachine.authorizedDeviceKeys;
	}
	async open(ctx) {
		await this._presence?.open();
		await this.space.spaceState.addCredentialProcessor(this._deviceStateMachine);
		await this.space.spaceState.addCredentialProcessor(this._profileStateMachine);
		if (this._edgeFeedReplicator) this.space.protocol.feedAdded.append(this._onFeedAdded);
		await this.space.open(ctx);
	}
	async joinNetwork(ctx) {
		await this.space.startProtocol(ctx);
		await this._edgeFeedReplicator?.open();
	}
	async close(ctx) {
		await this._presence?.close();
		await this.authVerifier.close();
		await this.space.spaceState.removeCredentialProcessor(this._profileStateMachine);
		await this.space.spaceState.removeCredentialProcessor(this._deviceStateMachine);
		if (this._edgeFeedReplicator) this.space.protocol.feedAdded.remove(this._onFeedAdded);
		await this._edgeFeedReplicator?.close();
		await this.space.close(ctx);
	}
	async ready() {
		await this._deviceStateMachine.deviceChainReady.wait();
		await this.controlPipeline.state.waitUntilReachedTargetTimeframe({ timeout: LOAD_CONTROL_FEEDS_TIMEOUT });
	}
	get profileDocument() {
		return this._profileStateMachine.profile;
	}
	/**
	* @test-only
	*/
	get controlPipeline() {
		return this.space.controlPipeline;
	}
	get haloSpaceId() {
		return this.space.id;
	}
	get haloSpaceKey() {
		return this.space.key;
	}
	get haloGenesisFeedKey() {
		return this.space.genesisFeedKey;
	}
	get deviceCredentialChain() {
		return this._deviceStateMachine.deviceCredentialChain;
	}
	get presence() {
		return this._presence;
	}
	get signer() {
		return this._signer;
	}
	/**
	* Issues credentials as identity.
	* Requires identity to be ready.
	*/
	getIdentityCredentialSigner() {
		invariant(this._deviceStateMachine.deviceCredentialChain, "Device credential chain is not ready.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$13,
			L: 184,
			S: this,
			A: ["this._deviceStateMachine.deviceCredentialChain", "'Device credential chain is not ready.'"]
		});
		return createCredentialSignerWithChain(this._signer, this._deviceStateMachine.deviceCredentialChain, this.deviceKey);
	}
	/**
	* Issues credentials as device.
	*/
	getDeviceCredentialSigner() {
		return createCredentialSignerWithKey(this._signer, this.deviceKey);
	}
	async admitDevice({ deviceKey, controlFeedKey, dataFeedKey }) {
		log("Admitting device:", {
			identityKey: this.identityKey,
			hostDevice: this.deviceKey,
			deviceKey,
			controlFeedKey,
			dataFeedKey
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$13,
			L: 200,
			S: this
		});
		const signer = this.getIdentityCredentialSigner();
		const deviceCredential = await signer.createCredential({
			subject: deviceKey,
			assertion: {
				"@type": "dxos.halo.credentials.AuthorizedDevice",
				"identityKey": this.identityKey,
				deviceKey
			}
		});
		await writeMessages(this.controlPipeline.writer, [
			deviceCredential,
			await signer.createCredential({
				subject: controlFeedKey,
				assertion: {
					"@type": "dxos.halo.credentials.AdmittedFeed",
					"spaceKey": this.haloSpaceKey,
					deviceKey,
					"identityKey": this.identityKey,
					"designation": AdmittedFeed.Designation.CONTROL
				}
			}),
			await signer.createCredential({
				subject: dataFeedKey,
				assertion: {
					"@type": "dxos.halo.credentials.AdmittedFeed",
					"spaceKey": this.haloSpaceKey,
					deviceKey,
					"identityKey": this.identityKey,
					"designation": AdmittedFeed.Designation.DATA
				}
			})
		].map((credential) => ({ credential: { credential } })));
		return deviceCredential;
	}
	_onFeedAdded = async (feed) => {
		await this._edgeFeedReplicator.addFeed(feed);
	};
};
__decorate([trace.span({ op: "lifecycle" })], Identity.prototype, "open", null);
__decorate([trace.span({ op: "lifecycle" })], Identity.prototype, "close", null);
//#endregion
//#region src/packlets/identity/identity-manager.ts
var __dxlog_file$12 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/identity/identity-manager.ts";
var DEVICE_PRESENCE_ANNOUNCE_INTERVAL = 1e4;
var DEVICE_PRESENCE_OFFLINE_TIMEOUT = 2e4;
/**
* Effect service tag for {@link IdentityProvider}.
*/
var IdentityProviderService = class extends EffectContext.Tag("@dxos/client-services/IdentityProvider")() {};
/**
* Builds an {@link IdentityProvider} from an {@link IdentityManager}.
*/
var identityProviderFromManager = (identityManager) => () => identityManager.identity ?? failUndefined();
/**
* Effect service tag for {@link IdentityManager}.
*/
var IdentityManagerService = class extends EffectContext.Tag("@dxos/client-services/IdentityManager")() {};
var IdentityManager = class {
	stateUpdate = new Event();
	_metadataStore;
	_keyring;
	_feedStore;
	_spaceManager;
	_devicePresenceAnnounceInterval;
	_devicePresenceOfflineTimeout;
	_edgeConnection;
	_edgeFeatures;
	_identity;
	constructor(params) {
		this._metadataStore = params.metadataStore;
		this._keyring = params.keyring;
		this._feedStore = params.feedStore;
		this._spaceManager = params.spaceManager;
		this._edgeConnection = params.edgeConnection;
		this._edgeFeatures = params.edgeFeatures;
		this._devicePresenceAnnounceInterval = params.devicePresenceAnnounceInterval ?? DEVICE_PRESENCE_ANNOUNCE_INTERVAL;
		this._devicePresenceOfflineTimeout = params.devicePresenceOfflineTimeout ?? DEVICE_PRESENCE_OFFLINE_TIMEOUT;
	}
	get identity() {
		return this._identity;
	}
	async open(ctx) {
		log("opening identity manager", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 148,
			S: this
		});
		const identityRecord = this._metadataStore.getIdentityRecord();
		log("identity record", { identityRecord }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 151,
			S: this
		});
		if (identityRecord) {
			this._identity = await this._constructIdentity(identityRecord);
			await this._identity.open(ctx);
			await this._identity.ready();
			log.trace("dxos.halo.identity", {
				identityKey: identityRecord.identityKey,
				displayName: this._identity.profileDocument?.displayName
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$12,
				L: 156,
				S: this
			});
			this.stateUpdate.emit();
		}
		log("opened identity manager", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 163,
			S: this
		});
	}
	async close(ctx) {
		await this._identity?.close(ctx);
	}
	async createIdentity({ profile, deviceProfile } = {}, ctx) {
		invariant(!this._identity, "Identity already exists.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 171,
			S: this,
			A: ["!this._identity", "'Identity already exists.'"]
		});
		log("creating identity...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 172,
			S: this
		});
		const controlFeedKey = await this._keyring.createKey();
		const identityRecord = {
			identityKey: await this._keyring.createKey(),
			deviceKey: await this._keyring.createKey(),
			haloSpace: {
				key: await this._keyring.createKey(),
				genesisFeedKey: controlFeedKey,
				controlFeedKey,
				dataFeedKey: await this._keyring.createKey()
			}
		};
		const identity = await this._constructIdentity(identityRecord);
		await identity.open(ctx ?? Context.default(void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 187
		}));
		{
			const generator = new CredentialGenerator(this._keyring, identityRecord.identityKey, identityRecord.deviceKey);
			invariant(identityRecord.haloSpace.genesisFeedKey, "Genesis feed key is required.", {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$12,
				L: 191,
				S: this,
				A: ["identityRecord.haloSpace.genesisFeedKey", "'Genesis feed key is required.'"]
			});
			invariant(identityRecord.haloSpace.dataFeedKey, "Data feed key is required.", {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$12,
				L: 192,
				S: this,
				A: ["identityRecord.haloSpace.dataFeedKey", "'Data feed key is required.'"]
			});
			const credentials = [...await generator.createSpaceGenesis(identityRecord.haloSpace.key, identityRecord.haloSpace.genesisFeedKey), await generator.createFeedAdmission(identityRecord.haloSpace.key, identityRecord.haloSpace.dataFeedKey, AdmittedFeed.Designation.DATA)];
			if (profile) credentials.push(await generator.createProfileCredential(profile));
			credentials.push(await generator.createDeviceAuthorization(identityRecord.deviceKey));
			credentials.push(await generator.createDeviceProfile({
				...this.createDefaultDeviceProfile(),
				...deviceProfile
			}));
			for (const credential of credentials) await identity.controlPipeline.writer.write({ credential: { credential } });
		}
		await this._metadataStore.setIdentityRecord(identityRecord);
		this._identity = identity;
		await this._identity.ready();
		log.trace("dxos.halo.identity", {
			identityKey: identityRecord.identityKey,
			displayName: this._identity.profileDocument?.displayName
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 230,
			S: this
		});
		this.stateUpdate.emit();
		log("created identity", {
			identityKey: identity.identityKey,
			deviceKey: identity.deviceKey,
			profile: identity.profileDocument
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 236,
			S: this
		});
		return identity;
	}
	createDefaultDeviceProfile() {
		let type;
		if (isNode()) type = DeviceType.AGENT;
		else if (platform.name?.startsWith("iOS") || platform.name?.startsWith("Android")) type = DeviceType.MOBILE;
		else if (isTauri() || !platform.name) type = DeviceType.NATIVE;
		else type = DeviceType.BROWSER;
		const os = platform.os?.family === "OS X" ? "macOS" : platform.os?.family;
		const name = type === DeviceType.NATIVE || type === DeviceType.MOBILE ? "App" : platform.name;
		return {
			type,
			platform: name,
			platformVersion: platform.version,
			architecture: typeof platform.os?.architecture === "number" ? String(platform.os.architecture) : void 0,
			os,
			osVersion: platform.os?.version
		};
	}
	/**
	* Prepare an identity object as the first step of acceptIdentity flow.
	*/
	async prepareIdentity(params, ctx) {
		log("accepting identity", { params }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 279,
			S: this
		});
		invariant(!this._identity, "Identity already exists.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 280,
			S: this,
			A: ["!this._identity", "'Identity already exists.'"]
		});
		const identityRecord = {
			identityKey: params.identityKey,
			deviceKey: params.deviceKey,
			haloSpace: {
				key: params.haloSpaceKey,
				genesisFeedKey: params.haloGenesisFeedKey,
				controlFeedKey: params.controlFeedKey,
				dataFeedKey: params.dataFeedKey,
				controlTimeframe: params.controlTimeframe
			}
		};
		const identity = await this._constructIdentity(identityRecord);
		await identity.open(ctx ?? Context.default(void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 294
		}));
		return {
			identity,
			identityRecord
		};
	}
	/**
	* Accept an existing identity. Expects its device key to be authorized (now or later).
	*/
	async acceptIdentity(identity, identityRecord, profile) {
		this._identity = identity;
		await this._identity.ready();
		await this._metadataStore.setIdentityRecord(identityRecord);
		log.trace("dxos.halo.identity", {
			identityKey: this._identity.identityKey,
			displayName: this._identity.profileDocument?.displayName
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 312,
			S: this
		});
		await this.updateDeviceProfile({
			...this.createDefaultDeviceProfile(),
			...profile
		});
		this.stateUpdate.emit();
		log("accepted identity", {
			identityKey: identity.identityKey,
			deviceKey: identity.deviceKey
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 323,
			S: this
		});
	}
	/**
	* Update the profile document of an existing identity.
	*/
	async updateProfile(profile) {
		invariant(this._identity, "Identity not initialized.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 330,
			S: this,
			A: ["this._identity", "'Identity not initialized.'"]
		});
		const credential = await this._identity.getIdentityCredentialSigner().createCredential({
			subject: this._identity.identityKey,
			assertion: {
				"@type": "dxos.halo.credentials.IdentityProfile",
				profile
			}
		});
		const receipt = await this._identity.controlPipeline.writer.write({ credential: { credential } });
		await this._identity.controlPipeline.state.waitUntilTimeframe(new Timeframe([[receipt.feedKey, receipt.seq]]));
		this.stateUpdate.emit();
		return profile;
	}
	async updateDeviceProfile(profile) {
		invariant(this._identity, "Identity not initialized.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 347,
			S: this,
			A: ["this._identity", "'Identity not initialized.'"]
		});
		const credential = await this._identity.getDeviceCredentialSigner().createCredential({
			subject: this._identity.deviceKey,
			assertion: {
				"@type": "dxos.halo.credentials.DeviceProfile",
				profile
			}
		});
		const receipt = await this._identity.controlPipeline.writer.write({ credential: { credential } });
		await this._identity.controlPipeline.state.waitUntilTimeframe(new Timeframe([[receipt.feedKey, receipt.seq]]));
		this.stateUpdate.emit();
		return {
			deviceKey: this._identity.deviceKey,
			kind: DeviceKind.CURRENT,
			presence: Device.PresenceState.ONLINE,
			profile
		};
	}
	async _constructIdentity(identityRecord) {
		invariant(!this._identity, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 373,
			S: this,
			A: ["!this._identity", ""]
		});
		log("constructing identity", { identityRecord }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 374,
			S: this
		});
		const gossip = new Gossip({ localPeerId: identityRecord.deviceKey });
		const presence = new Presence({
			announceInterval: this._devicePresenceAnnounceInterval,
			offlineTimeout: this._devicePresenceOfflineTimeout,
			identityKey: identityRecord.deviceKey,
			gossip
		});
		invariant(identityRecord.haloSpace.controlFeedKey, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 387,
			S: this,
			A: ["identityRecord.haloSpace.controlFeedKey", ""]
		});
		const controlFeed = await this._feedStore.openFeed(identityRecord.haloSpace.controlFeedKey, { writable: true });
		invariant(identityRecord.haloSpace.dataFeedKey, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 391,
			S: this,
			A: ["identityRecord.haloSpace.dataFeedKey", ""]
		});
		const dataFeed = await this._feedStore.openFeed(identityRecord.haloSpace.dataFeedKey, {
			writable: true,
			sparse: true
		});
		const space = await this._constructSpace({
			spaceRecord: identityRecord.haloSpace,
			swarmIdentity: {
				identityKey: identityRecord.identityKey,
				peerKey: identityRecord.deviceKey,
				credentialProvider: createAuthProvider(createCredentialSignerWithKey(this._keyring, identityRecord.deviceKey)),
				credentialAuthenticator: deferFunction(() => identity.authVerifier.verifier)
			},
			gossip,
			identityKey: identityRecord.identityKey
		});
		await space.setControlFeed(controlFeed);
		await space.setDataFeed(dataFeed);
		const did = await createDidFromIdentityKey(identityRecord.identityKey);
		const identity = new Identity({
			space,
			presence,
			signer: this._keyring,
			did,
			identityKey: identityRecord.identityKey,
			deviceKey: identityRecord.deviceKey,
			edgeConnection: this._edgeConnection,
			edgeFeatures: this._edgeFeatures
		});
		log("done", { identityKey: identityRecord.identityKey }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$12,
			L: 422,
			S: this
		});
		if (identityRecord.haloSpace.controlTimeframe) identity.controlPipeline.state.setTargetTimeframe(identityRecord.haloSpace.controlTimeframe);
		identity.stateUpdate.on(() => this.stateUpdate.emit());
		return identity;
	}
	async _constructSpace({ spaceRecord, swarmIdentity, identityKey, gossip }) {
		return this._spaceManager.constructSpace({
			metadata: {
				key: spaceRecord.key,
				genesisFeedKey: spaceRecord.genesisFeedKey
			},
			swarmIdentity,
			onAuthorizedConnection: (session) => {
				session.addExtension("dxos.mesh.teleport.gossip", gossip.createExtension({ remotePeerId: session.remotePeerId }));
			},
			onAuthFailure: () => {
				log.warn("auth failure", void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$12,
					L: 447,
					S: this
				});
			},
			memberKey: identityKey,
			onDelegatedInvitationStatusChange: async () => {},
			onMemberRolesChanged: async () => {}
		});
	}
};
__decorate([trace.span({ showInBrowserTimeline: true })], IdentityManager.prototype, "open", null);
/**
* Effect Layer constructing an {@link IdentityManager} from ambient service dependencies.
*/
var IdentityManagerLayer = (options = {}) => Layer.effect(IdentityManagerService, Effect.gen(function* () {
	const metadataStore = yield* IMetadataStoreService;
	const keyring = yield* KeyringApiService;
	const feedStore = yield* FeedStoreService;
	const spaceManager = yield* SpaceManagerService;
	const edgeConnection = yield* Effect.serviceOption(EdgeConnectionService);
	return new IdentityManager({
		metadataStore,
		keyring,
		feedStore,
		spaceManager,
		edgeConnection: Option.getOrUndefined(edgeConnection),
		...options
	});
}));
//#endregion
//#region src/packlets/identity/identity-service.ts
var __dxlog_file$11 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/identity/identity-service.ts";
var IdentityServiceImpl = class extends Resource {
	_identityManager;
	_recoveryManager;
	_keyring;
	_createIdentity;
	_onProfileUpdate;
	"constructor"(_identityManager, _recoveryManager, _keyring, _createIdentity, _onProfileUpdate) {
		super();
		this._identityManager = _identityManager;
		this._recoveryManager = _recoveryManager;
		this._keyring = _keyring;
		this._createIdentity = _createIdentity;
		this._onProfileUpdate = _onProfileUpdate;
	}
	["IdentityService.createIdentity"](request) {
		return Effect.tryPromise({
			try: async () => {
				const ctx = Context.default(void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$11,
					L: 43
				});
				await this._createIdentity({
					profile: request.profile,
					deviceProfile: request.deviceProfile
				}, ctx);
				return this._getIdentity();
			},
			catch: (error) => error
		});
	}
	["IdentityService.queryIdentity"]() {
		return EffectStream.async((emit) => {
			const emitNext = () => {
				const identity = this._getIdentity();
				emit.single(identity ? { identity } : {});
			};
			emitNext();
			const unsubscribe = this._identityManager.stateUpdate.on(emitNext);
			return Effect.sync(() => unsubscribe());
		});
	}
	["IdentityService.updateProfile"](profile) {
		return Effect.tryPromise({
			try: async () => {
				invariant(this._identityManager.identity, "Identity not initialized.", {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$11,
					L: 69,
					S: this,
					A: ["this._identityManager.identity", "'Identity not initialized.'"]
				});
				await this._identityManager.updateProfile(profile);
				await this._onProfileUpdate?.(this._identityManager.identity.profileDocument);
				return this._getIdentity();
			},
			catch: (error) => error
		});
	}
	["IdentityService.createRecoveryCredential"](request) {
		return Effect.tryPromise({
			try: async () => this._recoveryManager.createRecoveryCredential(request),
			catch: (error) => error
		});
	}
	["IdentityService.requestRecoveryChallenge"]() {
		return Effect.tryPromise({
			try: async () => this._recoveryManager.requestRecoveryChallenge(Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$11,
				L: 89
			})),
			catch: (error) => error
		});
	}
	["IdentityService.recoverIdentity"](request) {
		return Effect.tryPromise({
			try: async () => {
				const ctx = Context.default(void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$11,
					L: 97
				});
				if (request.recoveryCode) await this._recoveryManager.recoverIdentity(ctx, { recoveryCode: request.recoveryCode });
				else if (request.external) await this._recoveryManager.recoverIdentityWithExternalSignature(ctx, request.external);
				else if (request.token) await this._recoveryManager.recoverIdentityWithToken(ctx, { token: request.token });
				else if (request.recoveryProof) await this._recoveryManager.recoverIdentityWithToken(ctx, { recoveryProof: request.recoveryProof });
				else throw new Error("Invalid request.");
				return this._getIdentity();
			},
			catch: (error) => error
		});
	}
	["IdentityService.signPresentation"](request) {
		return Effect.tryPromise({
			try: async () => {
				const { presentation, nonce } = request;
				invariant(this._identityManager.identity, "Identity not initialized.", {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$11,
					L: 121,
					S: this,
					A: ["this._identityManager.identity", "'Identity not initialized.'"]
				});
				return await signPresentation({
					presentation,
					signer: this._keyring,
					signerKey: this._identityManager.identity.deviceKey,
					chain: this._identityManager.identity.deviceCredentialChain,
					nonce
				});
			},
			catch: (error) => error
		});
	}
	["IdentityService.createAuthCredential"]() {
		return Effect.tryPromise({
			try: async () => {
				const identity = this._identityManager.identity;
				invariant(identity, "Identity not initialized.", {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$11,
					L: 140,
					S: this,
					A: ["identity", "'Identity not initialized.'"]
				});
				return await createCredential({
					assertion: { "@type": "dxos.halo.credentials.Auth" },
					issuer: identity.identityKey,
					subject: identity.identityKey,
					chain: identity.deviceCredentialChain,
					signingKey: identity.deviceKey,
					signer: this._keyring
				});
			},
			catch: (error) => error
		});
	}
	"_getIdentity"() {
		if (!this._identityManager.identity) return;
		return {
			did: this._identityManager.identity.did,
			identityKey: this._identityManager.identity.identityKey,
			spaceKey: this._identityManager.identity.space.key,
			profile: this._identityManager.identity.profileDocument
		};
	}
};
//#endregion
//#region src/packlets/locks/index.ts
var locks_exports = /* @__PURE__ */ __exportAll({});
import * as import__locks_platform from "#locks-platform";
__reExport(locks_exports, import__locks_platform);
//#endregion
//#region src/packlets/agents/edge-agent-manager.ts
var __dxlog_file$10 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/agents/edge-agent-manager.ts";
var AGENT_STATUS_QUERY_RETRY_INTERVAL = 5e3;
var AGENT_STATUS_QUERY_RETRY_JITTER = 1e3;
var AGENT_FEED_ADDED_CHECK_INTERVAL_MS = 3e3;
/**
* Effect service tag for {@link EdgeAgentManager}.
*/
var EdgeAgentManagerService = class extends EffectContext.Tag("@dxos/client-services/EdgeAgentManager")() {};
var EdgeAgentManager = class extends Resource {
	_edgeFeatures;
	_edgeHttpClient;
	_dataSpaceManager;
	_identityProvider;
	agentStatusChanged = new Event();
	_agentDeviceKey;
	_agentStatus;
	_lastKnownDeviceCount = 0;
	_fetchAgentStatusTask;
	constructor(_edgeFeatures, _edgeHttpClient, _dataSpaceManager, _identityProvider) {
		super();
		this._edgeFeatures = _edgeFeatures;
		this._edgeHttpClient = _edgeHttpClient;
		this._dataSpaceManager = _dataSpaceManager;
		this._identityProvider = _identityProvider;
	}
	get identity() {
		return this._identityProvider();
	}
	get agentStatus() {
		return this._agentStatus;
	}
	get agentExists() {
		return this._agentStatus && this._agentStatus !== EdgeAgentStatus.NOT_FOUND;
	}
	async createAgent(ctx) {
		invariant(this.isOpen, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$10,
			L: 71,
			S: this,
			A: ["this.isOpen", ""]
		});
		invariant(this._edgeHttpClient, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$10,
			L: 72,
			S: this,
			A: ["this._edgeHttpClient", ""]
		});
		invariant(this._edgeFeatures?.agents, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$10,
			L: 73,
			S: this,
			A: ["this._edgeFeatures?.agents", ""]
		});
		const response = await this._edgeHttpClient.createAgent(ctx, {
			identityDid: this.identity.did,
			haloSpaceId: this.identity.haloSpaceId,
			haloSpaceKey: this.identity.haloSpaceKey.toHex()
		});
		const deviceKey = PublicKey.fromHex(response.deviceKey);
		if (await this.identity.authorizedDeviceKeys.has(deviceKey)) {
			log.info("agent was already added to HALO, ignoring response", { response }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$10,
				L: 84,
				S: this
			});
			this._updateStatus(EdgeAgentStatus.ACTIVE, deviceKey);
			return;
		}
		await this.identity.admitDevice({
			deviceKey,
			controlFeedKey: PublicKey.fromHex(response.feedKey),
			dataFeedKey: PublicKey.random()
		});
		log("agent created", response, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$10,
			L: 96,
			S: this
		});
		this._updateStatus(EdgeAgentStatus.ACTIVE, deviceKey);
	}
	async _open() {
		const isEnabled = this._edgeHttpClient && this._edgeFeatures?.agents;
		log("edge agent manager open", { isEnabled }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$10,
			L: 104,
			S: this
		});
		if (!isEnabled) return;
		this._lastKnownDeviceCount = this.identity.authorizedDeviceKeys.size;
		this._fetchAgentStatusTask = new DeferredTask(this._ctx, async () => {
			await this._fetchAgentStatus(this._ctx);
		});
		this._fetchAgentStatusTask.schedule();
		this._dataSpaceManager.updated.on(this._ctx, () => {
			if (this._agentDeviceKey) this._ensureAgentIsInSpaces(this._agentDeviceKey);
		});
		this.identity.stateUpdate.on(this._ctx, () => {
			const maybeAgentWasCreated = this.identity.authorizedDeviceKeys.size > this._lastKnownDeviceCount;
			if (this.agentExists || !maybeAgentWasCreated) return;
			this._lastKnownDeviceCount = this.identity.authorizedDeviceKeys.size;
			this._fetchAgentStatusTask?.schedule();
		});
	}
	async _close() {
		this._fetchAgentStatusTask = void 0;
		this._lastKnownDeviceCount = 0;
	}
	async _fetchAgentStatus(ctx) {
		invariant(this._edgeHttpClient, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$10,
			L: 138,
			S: this,
			A: ["this._edgeHttpClient", ""]
		});
		try {
			log("fetching agent status", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$10,
				L: 140,
				S: this
			});
			const { agent } = await this._edgeHttpClient.getAgentStatus(ctx, { ownerIdentityDid: this.identity.did });
			if (!(this._agentStatus === EdgeAgentStatus.ACTIVE)) {
				const deviceKey = agent.deviceKey ? PublicKey.fromHex(agent.deviceKey) : void 0;
				this._updateStatus(agent.status, deviceKey);
			}
		} catch (err) {
			if (err instanceof EdgeCallFailedError) {
				if (!err.isRetryable) {
					log.warn("non retryable error on agent status fetch attempt", { err }, {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$10,
						L: 152,
						S: this
					});
					return;
				}
			}
			const retryAfterMs = AGENT_STATUS_QUERY_RETRY_INTERVAL + Math.random() * AGENT_STATUS_QUERY_RETRY_JITTER;
			log.info("agent status fetching failed", {
				err,
				retryAfterMs
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$10,
				L: 157,
				S: this
			});
			scheduleTask(this._ctx, () => this._fetchAgentStatusTask?.schedule(), retryAfterMs);
		}
	}
	/**
	* We don't want notarization plugin to always actively poll edge looking for credentials to notarize,
	* because most of the time we'll be getting an empty response.
	* Instead, we stay in active polling mode while there are spaces where we don't see our agent's feed.
	*/
	_ensureAgentIsInSpaces(agentDeviceKey) {
		let activePollingEnabled = false;
		for (const space of this._dataSpaceManager.spaces.values()) {
			if (space.getEdgeReplicationSetting() === EdgeReplicationSetting.DISABLED) {
				space.notarizationPlugin.setActiveEdgePollingEnabled(false);
				continue;
			}
			if ([SpaceState.SPACE_INACTIVE, SpaceState.SPACE_CLOSED].includes(space.state)) {
				space.notarizationPlugin.setActiveEdgePollingEnabled(false);
				continue;
			}
			const agentFeedNeedsNotarization = ![...space.inner.spaceState.feeds.values()].some((feed) => feed.assertion.deviceKey.equals(agentDeviceKey));
			space.notarizationPlugin.setActiveEdgePollingEnabled(agentFeedNeedsNotarization);
			activePollingEnabled = activePollingEnabled || agentFeedNeedsNotarization;
			log.verbose("set active edge polling", {
				enabled: agentFeedNeedsNotarization,
				spaceId: space.id
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$10,
				L: 184,
				S: this
			});
		}
		if (activePollingEnabled) scheduleTask(this._ctx, () => this._ensureAgentIsInSpaces(agentDeviceKey), AGENT_FEED_ADDED_CHECK_INTERVAL_MS);
	}
	_updateStatus(status, deviceKey) {
		this._agentStatus = status;
		this._agentDeviceKey = deviceKey;
		this.agentStatusChanged.emit(status);
		if (deviceKey) this._ensureAgentIsInSpaces(deviceKey);
		log.verbose("agent status update", { status }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$10,
			L: 200,
			S: this
		});
	}
};
__decorate([synchronized], EdgeAgentManager.prototype, "createAgent", null);
/**
* Effect Layer constructing a dormant {@link EdgeAgentManager}.
*/
var EdgeAgentManagerLayer = (options = {}) => Layer.effect(EdgeAgentManagerService, Effect.gen(function* () {
	const dataSpaceManager = yield* DataSpaceManagerService;
	const identityProvider = yield* IdentityProviderService;
	const edgeHttpClient = yield* Effect.serviceOption(EdgeHttpClientService);
	return new EdgeAgentManager(options.edgeFeatures, Option.getOrUndefined(edgeHttpClient), dataSpaceManager, identityProvider);
}));
//#endregion
//#region src/packlets/agents/edge-agent-service.ts
var __dxlog_file$9 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/agents/edge-agent-service.ts";
var EdgeAgentServiceImpl = class {
	_agentManagerProvider;
	_edgeConnection;
	"constructor"(_agentManagerProvider, _edgeConnection) {
		this._agentManagerProvider = _agentManagerProvider;
		this._edgeConnection = _edgeConnection;
	}
	["EdgeAgentService.queryEdgeStatus"]() {
		return EffectStream.async((emit) => {
			const ctx = Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$9,
				L: 30
			});
			const update = () => {
				emit.single({ status: this._edgeConnection?.status ?? {
					state: EdgeStatus.ConnectionState.NOT_CONNECTED,
					rtt: 0,
					uptime: 0,
					rateBytesUp: 0,
					rateBytesDown: 0,
					messagesSent: 0,
					messagesReceived: 0
				} });
			};
			this._edgeConnection?.statusChanged.on(ctx, update);
			update();
			return Effect.promise(() => ctx.dispose());
		});
	}
	["EdgeAgentService.createAgent"]() {
		return Effect.tryPromise({
			try: async () => (await this._agentManagerProvider()).createAgent(Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$9,
				L: 54
			})),
			catch: (error) => error
		});
	}
	["EdgeAgentService.queryAgentStatus"]() {
		return EffectStream.async((emit) => {
			const ctx = Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$9,
				L: 61
			});
			emit.single({ status: QueryAgentStatusResponse.AgentStatus.UNKNOWN });
			this._agentManagerProvider().then((agentManager) => {
				emit.single({ status: mapStatus(agentManager.agentStatus) });
				agentManager.agentStatusChanged.on(ctx, (newStatus) => {
					emit.single({ status: mapStatus(newStatus) });
				});
			});
			return Effect.promise(() => ctx.dispose());
		});
	}
};
var mapStatus = (agentStatus) => {
	switch (agentStatus) {
		case EdgeAgentStatus.ACTIVE: return QueryAgentStatusResponse.AgentStatus.ACTIVE;
		case EdgeAgentStatus.INACTIVE: return QueryAgentStatusResponse.AgentStatus.INACTIVE;
		case EdgeAgentStatus.NOT_FOUND: return QueryAgentStatusResponse.AgentStatus.NOT_FOUND;
		case void 0: return QueryAgentStatusResponse.AgentStatus.UNKNOWN;
	}
};
//#endregion
//#region src/packlets/devices/devices-service.ts
var __dxlog_file$8 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/devices/devices-service.ts";
var DevicesServiceImpl = class {
	_identityManager;
	_edgeConnection;
	"constructor"(_identityManager, _edgeConnection) {
		this._identityManager = _identityManager;
		this._edgeConnection = _edgeConnection;
	}
	["DevicesService.updateDevice"](request) {
		return Effect.tryPromise({
			try: async () => this._identityManager.updateDeviceProfile(request),
			catch: (error) => error
		});
	}
	["DevicesService.queryDevices"]() {
		return EffectStream.async((emit) => {
			const update = () => {
				const deviceKeys = this._identityManager.identity?.authorizedDeviceKeys;
				if (!deviceKeys) emit.single({ devices: [] });
				else {
					invariant(this._identityManager.identity?.presence, "presence not present", {
						"~LogMeta": "~LogMeta",
						F: __dxlog_file$8,
						L: 37,
						S: this,
						A: ["this._identityManager.identity?.presence", "'presence not present'"]
					});
					const peers = this._identityManager.identity.presence.getPeersOnline();
					emit.single({ devices: Array.from(deviceKeys.entries()).map(([key, profile]) => {
						const isMe = this._identityManager.identity?.deviceKey.equals(key);
						let presence;
						if (isMe) presence = Device.PresenceState.ONLINE;
						else if (profile.os?.toUpperCase() === "EDGE") presence = this._edgeConnection?.status.state === EdgeStatus.ConnectionState.CONNECTED ? Device.PresenceState.ONLINE : Device.PresenceState.OFFLINE;
						else presence = peers.some((peer) => peer.identityKey.equals(key)) ? Device.PresenceState.ONLINE : Device.PresenceState.OFFLINE;
						return {
							deviceKey: key,
							kind: this._identityManager.identity?.deviceKey.equals(key) ? DeviceKind.CURRENT : DeviceKind.TRUSTED,
							profile,
							presence
						};
					}) });
				}
			};
			let identitySubscribed = false;
			let presenceSubscribed = false;
			const subscribeIdentity = () => {
				if (!identitySubscribed) {
					this._identityManager.identity?.stateUpdate.on(() => {
						update();
					});
					identitySubscribed = true;
				}
			};
			const subscribePresence = () => {
				if (!presenceSubscribed) {
					this._identityManager.identity?.presence?.updated.on(() => {
						update();
					});
					presenceSubscribed = true;
				}
			};
			const subscriptions = new SubscriptionList();
			if (this._identityManager.identity) {
				subscribeIdentity();
				subscribePresence();
			}
			subscriptions.add(this._identityManager.stateUpdate.on(() => {
				update();
				if (this._identityManager.identity) {
					subscribeIdentity();
					subscribePresence();
				}
			}));
			update();
			return Effect.sync(() => subscriptions.clear());
		});
	}
};
//#endregion
//#region src/packlets/identity/contacts-service.ts
var __dxlog_file$7 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/identity/contacts-service.ts";
var ContactsServiceImpl = class {
	_identityManager;
	_spaceManager;
	_dataSpaceManagerProvider;
	"constructor"(_identityManager, _spaceManager, _dataSpaceManagerProvider) {
		this._identityManager = _identityManager;
		this._spaceManager = _spaceManager;
		this._dataSpaceManagerProvider = _dataSpaceManagerProvider;
	}
	["ContactsService.getContacts"]() {
		return Effect.sync(() => this.#getContacts());
	}
	["ContactsService.queryContacts"]() {
		const subscribedSpaceKeySet = new ComplexSet(PublicKey.hash);
		return EffectStream.async((emit) => {
			const ctx = Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$7,
				L: 34
			});
			const pushUpdateTask = new UpdateScheduler(ctx, async () => {
				emit.single(this.#getContacts());
			}, { maxFrequency: 2 });
			scheduleTask(ctx, async () => {
				const subscriptions = new SubscriptionList();
				ctx.onDispose(() => subscriptions.clear());
				const subscribeToSpaceAndUpdate = () => {
					const oldSetSize = subscribedSpaceKeySet.size;
					for (const space of this._spaceManager.spaces.values()) if (!subscribedSpaceKeySet.has(space.key)) {
						subscriptions.add(space.stateUpdate.on(ctx, () => pushUpdateTask.trigger()));
						subscribedSpaceKeySet.add(space.key);
					}
					if (oldSetSize !== subscribedSpaceKeySet.size) pushUpdateTask.trigger();
				};
				const unsubscribe = (await this._dataSpaceManagerProvider()).updated.on(ctx, subscribeToSpaceAndUpdate);
				ctx.onDispose(unsubscribe);
				subscribeToSpaceAndUpdate();
			});
			return Effect.promise(() => ctx.dispose());
		});
	}
	#getContacts() {
		const identity = this._identityManager.identity;
		if (identity == null) return { contacts: [] };
		return { contacts: [...[...this._spaceManager.spaces.values()].flatMap((s) => [...s.spaceState.members.values()].map((m) => [s.key, m])).reduce((acc, v) => {
			const [spaceKey, memberInfo] = v;
			if (memberInfo.key.equals(identity.identityKey)) return acc;
			const existing = acc.get(memberInfo.key);
			if (existing != null) {
				existing.profile ??= memberInfo.profile;
				existing.commonSpaces?.push(spaceKey);
			} else acc.set(memberInfo.key, {
				identityKey: memberInfo.key,
				profile: memberInfo.profile,
				commonSpaces: [spaceKey]
			});
			return acc;
		}, new ComplexMap(PublicKey.hash)).values()] };
	}
};
//#endregion
//#region src/packlets/identity/identity-recovery-manager.ts
var __dxlog_file$6 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/identity/identity-recovery-manager.ts";
/**
* Effect service tag for {@link EdgeIdentityRecoveryManager}.
*/
var EdgeIdentityRecoveryManagerService = class extends EffectContext.Tag("@dxos/client-services/EdgeIdentityRecoveryManager")() {};
var EdgeIdentityRecoveryManager = class {
	_keyring;
	_edgeClient;
	_identityProvider;
	_acceptRecoveredIdentity;
	constructor(_keyring, _edgeClient, _identityProvider) {
		this._keyring = _keyring;
		this._edgeClient = _edgeClient;
		this._identityProvider = _identityProvider;
	}
	/**
	* Wires identity acceptance after the composing stack is fully constructed.
	*/
	setAcceptRecoveredIdentity(acceptRecoveredIdentity) {
		this._acceptRecoveredIdentity = acceptRecoveredIdentity;
	}
	async createRecoveryCredential({ data }) {
		const identity = this._identityProvider();
		invariant(identity, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$6,
			L: 62,
			S: this,
			A: ["identity", ""]
		});
		let recoveryKey;
		let lookupKey;
		let algorithm;
		let recoveryCode;
		if (data) {
			recoveryKey = data.recoveryKey;
			lookupKey = data.lookupKey;
			algorithm = data.algorithm;
		} else {
			recoveryCode = generateSeedPhrase();
			const keypair = keyPairFromSeedPhrase(recoveryCode);
			recoveryKey = PublicKey.from(keypair.publicKey);
			lookupKey = PublicKey.from(keypair.publicKey);
			algorithm = "ED25519";
		}
		const identityKey = identity.identityKey;
		const credential = await identity.getIdentityCredentialSigner().createCredential({
			subject: identityKey,
			assertion: {
				"@type": "dxos.halo.credentials.IdentityRecovery",
				recoveryKey,
				identityKey,
				algorithm,
				lookupKey
			}
		});
		const receipt = await identity.controlPipeline.writer.write({ credential: { credential } });
		await identity.controlPipeline.state.waitUntilTimeframe(new Timeframe([[receipt.feedKey, receipt.seq]]));
		return { recoveryCode };
	}
	async requestRecoveryChallenge(ctx) {
		invariant(this._edgeClient, "Not connected to EDGE.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$6,
			L: 99,
			S: this,
			A: ["this._edgeClient", "'Not connected to EDGE.'"]
		});
		const deviceKey = await this._keyring.createKey();
		const controlFeedKey = await this._keyring.createKey();
		const request = {
			deviceKey: deviceKey.toHex(),
			controlFeedKey: controlFeedKey.toHex()
		};
		try {
			await this._edgeClient.recoverIdentity(ctx, request);
			throw new Error("No challenge received.");
		} catch (error) {
			if (!(error instanceof EdgeAuthChallengeError)) throw error;
			return {
				deviceKey,
				controlFeedKey,
				challenge: error.challenge
			};
		}
	}
	async recoverIdentityWithExternalSignature(ctx, { lookupKey, deviceKey, controlFeedKey, signature, clientDataJson, authenticatorData }) {
		invariant(this._edgeClient, "Not connected to EDGE.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$6,
			L: 134,
			S: this,
			A: ["this._edgeClient", "'Not connected to EDGE.'"]
		});
		const request = {
			lookupKey: lookupKey.toHex(),
			deviceKey: deviceKey.toHex(),
			controlFeedKey: controlFeedKey.toHex(),
			signature: clientDataJson && authenticatorData ? {
				signature: Buffer.from(signature).toString("base64"),
				clientDataJson: Buffer.from(clientDataJson).toString("base64"),
				authenticatorData: Buffer.from(authenticatorData).toString("base64")
			} : Buffer.from(signature).toString("base64")
		};
		const response = await this._edgeClient.recoverIdentity(ctx, request);
		await this.#acceptRecoveredIdentity({
			authorizedDeviceCredential: decodeCredential(response.deviceAuthCredential),
			haloGenesisFeedKey: PublicKey.fromHex(response.genesisFeedKey),
			haloSpaceKey: PublicKey.fromHex(response.haloSpaceKey),
			identityKey: PublicKey.fromHex(response.identityKey),
			deviceKey,
			controlFeedKey,
			dataFeedKey: await this._keyring.createKey()
		});
	}
	/**
	* Recover an identity using an opaque one-time token. Accepts either an email magic-link
	* `token` (validated by hub-service) or an OAuth `recoveryProof` (redeemed by kms-service).
	* The two fields are routed to different backends by db-service and must not be conflated.
	*/
	async recoverIdentityWithToken(ctx, fields) {
		invariant(this._edgeClient, "Not connected to EDGE.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$6,
			L: 172,
			S: this,
			A: ["this._edgeClient", "'Not connected to EDGE.'"]
		});
		const deviceKey = await this._keyring.createKey();
		const controlFeedKey = await this._keyring.createKey();
		const request = {
			deviceKey: deviceKey.toHex(),
			controlFeedKey: controlFeedKey.toHex(),
			...fields
		};
		const response = await this._edgeClient.recoverIdentity(ctx, request);
		await this.#acceptRecoveredIdentity({
			authorizedDeviceCredential: decodeCredential(response.deviceAuthCredential),
			haloGenesisFeedKey: PublicKey.fromHex(response.genesisFeedKey),
			haloSpaceKey: PublicKey.fromHex(response.haloSpaceKey),
			identityKey: PublicKey.fromHex(response.identityKey),
			deviceKey,
			controlFeedKey,
			dataFeedKey: await this._keyring.createKey()
		});
	}
	async recoverIdentity(ctx, { recoveryCode }) {
		invariant(this._edgeClient, "Not connected to EDGE.", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$6,
			L: 196,
			S: this,
			A: ["this._edgeClient", "'Not connected to EDGE.'"]
		});
		const recoveryKeypair = keyPairFromSeedPhrase(recoveryCode);
		const recoveryKey = PublicKey.from(recoveryKeypair.publicKey);
		const deviceKey = await this._keyring.createKey();
		const controlFeedKey = await this._keyring.createKey();
		const request = {
			lookupKey: recoveryKey.toHex(),
			deviceKey: deviceKey.toHex(),
			controlFeedKey: controlFeedKey.toHex()
		};
		let response;
		try {
			response = await this._edgeClient.recoverIdentity(ctx, request);
		} catch (error) {
			if (!(error instanceof EdgeAuthChallengeError)) throw error;
			const signature = sign(Buffer.from(error.challenge, "base64"), recoveryKeypair.secretKey);
			response = await this._edgeClient.recoverIdentity(ctx, {
				...request,
				signature: Buffer.from(signature).toString("base64")
			});
		}
		log.info("recovering identity", response, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$6,
			L: 222,
			S: this
		});
		await this.#acceptRecoveredIdentity({
			authorizedDeviceCredential: decodeCredential(response.deviceAuthCredential),
			haloGenesisFeedKey: PublicKey.fromHex(response.genesisFeedKey),
			haloSpaceKey: PublicKey.fromHex(response.haloSpaceKey),
			identityKey: PublicKey.fromHex(response.identityKey),
			deviceKey,
			controlFeedKey,
			dataFeedKey: await this._keyring.createKey()
		});
	}
	#acceptRecoveredIdentity(params) {
		invariant(this._acceptRecoveredIdentity, "acceptRecoveredIdentity not set", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$6,
			L: 236,
			S: this,
			A: ["this._acceptRecoveredIdentity", "'acceptRecoveredIdentity not set'"]
		});
		return this._acceptRecoveredIdentity(params);
	}
};
var decodeCredential = (credentialBase64) => {
	const credentialBytes = Buffer.from(credentialBase64, "base64");
	return schema.getCodecForType("dxos.halo.credentials.Credential").decode(credentialBytes);
};
/**
* Effect Layer constructing a dormant {@link EdgeIdentityRecoveryManager}.
*/
var EdgeIdentityRecoveryManagerLayer = () => Layer.effect(EdgeIdentityRecoveryManagerService, Effect.gen(function* () {
	const keyring = yield* KeyringApiService;
	const edgeClient = yield* Effect.serviceOption(EdgeHttpClientService);
	const identityManager = yield* IdentityManagerService;
	return new EdgeIdentityRecoveryManager(keyring, Option.getOrUndefined(edgeClient), () => identityManager.identity);
}));
//#endregion
//#region src/packlets/network/network-service.ts
var __dxlog_file$5 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/network/network-service.ts";
var NetworkServiceImpl = class {
	networkManager;
	signalManager;
	edgeConnection;
	"constructor"(networkManager, signalManager, edgeConnection) {
		this.networkManager = networkManager;
		this.signalManager = signalManager;
		this.edgeConnection = edgeConnection;
	}
	["NetworkService.queryStatus"]() {
		return EffectStream.async((emit) => {
			const ctx = Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$5,
				L: 36
			});
			const update = () => {
				emit.single({
					swarm: this.networkManager.connectionState,
					connectionInfo: this.networkManager.connectionLog?.swarms,
					signaling: this.signalManager.getStatus?.().map(({ host, state }) => ({
						server: host,
						state
					}))
				});
			};
			this.networkManager.connectionStateChanged.on(ctx, () => update());
			this.signalManager.statusChanged?.on(ctx, () => update());
			update();
			return Effect.promise(() => ctx.dispose());
		});
	}
	["NetworkService.updateConfig"](request) {
		return Effect.tryPromise({
			try: async () => {
				await this.networkManager.setConnectionState(request.swarm);
			},
			catch: (error) => error
		});
	}
	["NetworkService.joinSwarm"](request) {
		return Effect.tryPromise({
			try: async () => {
				await this.signalManager.join(Context.default(void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$5,
					L: 65
				}), request);
			},
			catch: (error) => error
		});
	}
	["NetworkService.leaveSwarm"](request) {
		return Effect.tryPromise({
			try: async () => {
				await this.signalManager.leave(Context.default(void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$5,
					L: 74
				}), request);
			},
			catch: (error) => error
		});
	}
	["NetworkService.querySwarm"](request) {
		return Effect.tryPromise({
			try: async () => {
				return this.signalManager.query(Context.default(void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$5,
					L: 83
				}), request);
			},
			catch: (error) => error
		});
	}
	["NetworkService.subscribeSwarmState"](request) {
		return EffectStream.async((emit) => {
			const ctx = Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$5,
				L: 93
			});
			this.signalManager.swarmState?.on(ctx, (state) => {
				if (request.topic.equals(state.swarmKey)) emit.single(state);
			});
			return Effect.promise(() => ctx.dispose());
		});
	}
	["NetworkService.sendMessage"](message) {
		return Effect.tryPromise({
			try: async () => {
				await this.signalManager.sendMessage(Context.default(void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$5,
					L: 107
				}), message);
			},
			catch: (error) => error
		});
	}
	["NetworkService.subscribeMessages"](request) {
		const { peer, tags = [] } = request;
		return EffectStream.async((emit) => {
			const ctx = Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$5,
				L: 116
			});
			const encodableAny = (payload) => ({
				...payload,
				"@type": "google.protobuf.Any"
			});
			let unsubscribe;
			this.signalManager.subscribeMessages({
				peer,
				tags,
				onMessage: (message) => {
					emit.single({
						...message,
						payload: encodableAny(message.payload)
					});
				}
			}).then((unsub) => {
				if (ctx.disposed) unsub();
				else unsubscribe = unsub;
			}).catch((err) => emit.fail(err instanceof Error ? err : new Error(String(err))));
			return Effect.promise(async () => {
				await unsubscribe?.();
				await ctx.dispose();
			});
		});
	}
};
//#endregion
//#region src/packlets/logging/logging-service.ts
var __dxlog_file$4 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/logging/logging-service.ts";
/**
* Logging service used to spy on logs of the host.
*
* @deprecated This was created so that logs from the shared worker (WorkerClientServices) could be
* seen in the main window console without opening the shared worker DevTools. Shared worker client
* services is deprecated; dedicated worker logs already show in the main window console.
*/
var LoggingServiceImpl = class {
	"_logs" = new Event();
	"_started" = Date.now();
	"_sessionId" = PublicKey.random().toHex();
	async "open"() {
		log.runtimeConfig.processors.push(this._logProcessor);
	}
	async "close"() {
		const index = log.runtimeConfig.processors.findIndex((processor) => processor === this._logProcessor);
		log.runtimeConfig.processors.splice(index, 1);
	}
	["LoggingService.controlMetrics"]({ reset, record }) {
		return Effect.sync(() => {
			if (reset) tracer.clear();
			if (record === true) tracer.start();
			else if (record === false) tracer.stop();
			return { recording: tracer.recording };
		});
	}
	/**
	* @deprecated (Move to diagnostics).
	*/
	["LoggingService.queryMetrics"]({ interval = 5e3 }) {
		const getNumericalValues = (key) => {
			return {
				key,
				stats: numericalValues(tracer.get(key) ?? [], "duration")
			};
		};
		return EffectStream.async((emit) => {
			const update = () => {
				const metrics = {
					timestamp: /* @__PURE__ */ new Date(),
					values: [getNumericalValues("dxos.echo.pipeline.control"), getNumericalValues("dxos.echo.pipeline.data")].filter(Boolean)
				};
				emit.single({
					timestamp: /* @__PURE__ */ new Date(),
					metrics
				});
			};
			update();
			const i = setInterval(update, Math.max(interval, 1e3));
			return Effect.sync(() => {
				clearInterval(i);
			});
		});
	}
	["LoggingService.queryLogs"](request) {
		return EffectStream.async((emit) => {
			const ctx = Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$4,
				L: 102
			});
			const handler = (entry) => {
				if (LOG_PROCESSING > 0) return;
				if (entry.meta?.F.includes("logging-service") || entry.context && Object.values(entry.context).some((value) => typeof value === "string" && value.includes("LoggingService"))) return;
				if (!shouldLog(entry, request)) return;
				const { filename, line, context: scopeName } = entry.computedMeta;
				const recordContext = { ...entry.computedContext };
				if (entry.computedError !== void 0) recordContext.error = entry.computedError;
				const record = {
					level: entry.level,
					message: entry.message ?? entry.computedError ?? "",
					context: recordContext,
					timestamp: new Date(entry.timestamp),
					meta: {
						file: filename ?? "",
						line: line ?? 0,
						scope: {
							hostSessionId: this._sessionId,
							uptimeSeconds: (Date.now() - this._started) / 1e3,
							name: scopeName ?? ""
						}
					}
				};
				try {
					LOG_PROCESSING++;
					emit.single(record);
				} finally {
					LOG_PROCESSING--;
				}
			};
			this._logs.on(ctx, handler);
			return Effect.promise(() => ctx.dispose());
		});
	}
	"_logProcessor" = (_config, entry) => {
		this._logs.emit(entry);
	};
};
var matchFilter = (filter, level, path, options) => {
	switch (options) {
		case QueryLogsRequest.MatchingOptions.INCLUSIVE: return level >= filter.level && (!filter.pattern || path.includes(filter.pattern));
		case QueryLogsRequest.MatchingOptions.EXPLICIT: return level === filter.level && (!filter.pattern || path.includes(filter.pattern));
	}
};
/**
* Determines if the current line should be logged (called by the processor).
*/
var shouldLog = (entry, request) => {
	const options = request.options ?? QueryLogsRequest.MatchingOptions.INCLUSIVE;
	if (request.filters === void 0) return options === QueryLogsRequest.MatchingOptions.INCLUSIVE;
	else return request.filters.some((filter) => matchFilter(filter, entry.level, entry.meta?.F ?? "", options));
};
/**
* Counter that is used to track whether we are processing a log entry.
*/
var LOG_PROCESSING = 0;
//#endregion
//#region src/packlets/system/system-service.ts
var SystemServiceImpl = class {
	"_config";
	"_statusUpdate";
	"_getCurrentStatus";
	"_onUpdateStatus";
	"_onReset";
	"_getDiagnostics";
	"constructor"({ config, statusUpdate, getDiagnostics, onUpdateStatus, getCurrentStatus, onReset }) {
		this._config = config;
		this._statusUpdate = statusUpdate;
		this._getCurrentStatus = getCurrentStatus;
		this._getDiagnostics = getDiagnostics;
		this._onUpdateStatus = onUpdateStatus;
		this._onReset = onReset;
	}
	["SystemService.getConfig"]() {
		return Effect.tryPromise({
			try: async () => (await this._config?.())?.values ?? {},
			catch: (error) => error
		});
	}
	/**
	* NOTE: Since this is serialized as a JSON object, we allow the option to serialize keys.
	*/
	["SystemService.getDiagnostics"]({ keys } = {}) {
		return Effect.tryPromise({
			try: async () => {
				const diagnostics = await this._getDiagnostics();
				return {
					timestamp: /* @__PURE__ */ new Date(),
					diagnostics: JSON.parse(JSON.stringify(diagnostics, jsonKeyReplacer({
						truncate: keys === GetDiagnosticsRequest.KEY_OPTION.TRUNCATE,
						humanize: keys === GetDiagnosticsRequest.KEY_OPTION.HUMANIZE
					})))
				};
			},
			catch: (error) => error
		});
	}
	["SystemService.getPlatform"]() {
		return Effect.tryPromise({
			try: async () => getPlatform(),
			catch: (error) => error
		});
	}
	["SystemService.updateStatus"]({ status }) {
		return Effect.tryPromise({
			try: async () => {
				await this._onUpdateStatus(status);
			},
			catch: (error) => error
		});
	}
	["SystemService.queryStatus"]({ interval = 3e3 } = {}) {
		return EffectStream.async((emit) => {
			const update = () => {
				emit.single({ status: this._getCurrentStatus() });
			};
			update();
			const unsubscribe = this._statusUpdate.on(() => update());
			const i = setInterval(update, interval);
			return Effect.sync(() => {
				clearInterval(i);
				unsubscribe();
			});
		});
	}
	["SystemService.reset"]() {
		return Effect.tryPromise({
			try: async () => {
				await this._onReset();
			},
			catch: (error) => error
		});
	}
};
//#endregion
//#region src/packlets/services/cross-device-space-synchronizer.ts
var __dxlog_file$3 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/services/cross-device-space-synchronizer.ts";
/**
* Effect service tag for {@link CrossDeviceSpaceSynchronizer}.
*/
var CrossDeviceSpaceSynchronizerService = class extends EffectContext.Tag("@dxos/client-services/CrossDeviceSpaceSynchronizer")() {};
var CrossDeviceSpaceSynchronizerImpl = class extends Resource {
	dataSpaceManager;
	_identity;
	constructor(dataSpaceManager) {
		super();
		this.dataSpaceManager = dataSpaceManager;
	}
	setIdentity(identity) {
		this._identity = identity;
	}
	async _open(ctx) {
		assertState(this._identity, "identity not set");
		await this._identity.space.spaceState.addCredentialProcessor(this);
	}
	async _close(ctx) {
		if (!this._identity) return;
		await this._identity.space.spaceState.removeCredentialProcessor(this);
	}
	async processCredential(credential) {
		assertState(this._identity, "identity not set");
		const assertion = getCredentialAssertion(credential);
		if (assertion["@type"] === "dxos.halo.credentials.SpaceDeleted") {
			if (assertion.spaceKey.equals(this._identity.space.key)) return;
			if (!this.dataSpaceManager) {
				log("dataSpaceManager not initialized yet, ignoring space deletion", { details: assertion }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$3,
					L: 66,
					S: this
				});
				return;
			}
			try {
				log("tombstoning space recorded in halo", { details: assertion }, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$3,
					L: 71,
					S: this
				});
				await this.dataSpaceManager.handleRemoteSpaceDeleted(this._ctx, assertion.spaceKey);
			} catch (err) {
				log.catch(err, void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file$3,
					L: 74,
					S: this
				});
			}
			return;
		}
		if (assertion["@type"] !== "dxos.halo.credentials.SpaceMember") return;
		if (assertion.spaceKey.equals(this._identity.space.key)) return;
		if (!this.dataSpaceManager) {
			log("dataSpaceManager not initialized yet, ignoring space admission", { details: assertion }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$3,
				L: 87,
				S: this
			});
			return;
		}
		if (this.dataSpaceManager.isSpaceDeleted(assertion.spaceKey)) {
			log("space is deleted, ignoring space admission", { details: assertion }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$3,
				L: 92,
				S: this
			});
			return;
		}
		if (this.dataSpaceManager.spaces.has(assertion.spaceKey)) {
			log("space already exists, ignoring space admission", { details: assertion }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$3,
				L: 96,
				S: this
			});
			return;
		}
		try {
			log("accepting space recorded in halo", { details: assertion }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$3,
				L: 101,
				S: this
			});
			await this.dataSpaceManager.acceptSpace(this._ctx, {
				spaceKey: assertion.spaceKey,
				genesisFeedKey: assertion.genesisFeedKey,
				tags: assertion.tags
			});
		} catch (err) {
			log.catch(err, void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$3,
				L: 108,
				S: this
			});
		}
	}
};
/**
* Creates a dormant {@link CrossDeviceSpaceSynchronizer} bound to the given data space manager.
*/
var createCrossDeviceSpaceSynchronizer = (dataSpaceManager) => new CrossDeviceSpaceSynchronizerImpl(dataSpaceManager);
/**
* Effect Layer constructing a dormant {@link CrossDeviceSpaceSynchronizer}.
*/
var CrossDeviceSpaceSynchronizerLayer = Layer.effect(CrossDeviceSpaceSynchronizerService, Effect.gen(function* () {
	return createCrossDeviceSpaceSynchronizer(yield* DataSpaceManagerService);
}));
//#endregion
//#region src/packlets/services/feed-syncer.ts
var __dxlog_file$2 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/services/feed-syncer.ts";
var encoder = new Encoder({
	tagUint8Array: false,
	useRecords: false
});
var DEFAULT_MESSAGE_BLOCKS_LIMIT = 50;
var DEFAULT_SYNC_CONCURRENCY = 5;
var DEFAULT_POLLING_INTERVAL = 5e3;
var DEFAULT_POLL_REQUEST_THROTTLE_MS = 250;
var DEFAULT_PUSH_FAILURE_BACKOFF_MS = 250;
var MAX_PUSH_FAILURE_BACKOFF_MS = 3e4;
var MAX_BLOCKING_SYNC_ITERATIONS = 100;
/**
* Effect service tag for {@link FeedSyncer}.
*
* undefined if not initialized.
*/
var FeedSyncerService = class extends EffectContext.Tag("@dxos/client-services/FeedSyncer")() {};
var FeedSyncer = class extends Resource {
	#syncNamespaces;
	#messageBlocksLimit;
	#syncConcurrency;
	#pollingInterval;
	#pollRequestThrottleMs;
	#backgroundSync;
	#runtime;
	#feedStore;
	#edgeClient;
	#syncClient;
	#getSpaceIds;
	#spacesToPoll = /* @__PURE__ */ new Set();
	/** Last time full poll was completed. */
	#lastFullPoll = null;
	#throttledPollScheduled = false;
	#lastRequestedPollAt = null;
	#feedStoreMutex = new Mutex();
	#pushFailureBackoffMs = DEFAULT_PUSH_FAILURE_BACKOFF_MS;
	constructor(options) {
		super();
		this.#runtime = options.runtime;
		this.#feedStore = options.feedStore;
		this.#edgeClient = options.edgeClient;
		this.#syncClient = new SyncClient({
			peerId: options.peerId,
			feedStore: options.feedStore,
			sendMessage: this.#sendMessage.bind(this),
			rpcTimeoutMs: options.syncRpcTimeoutMs
		});
		this.#getSpaceIds = options.getSpaceIds;
		this.#syncNamespaces = options.syncNamespaces;
		this.#messageBlocksLimit = options.messageBlocksLimit ?? DEFAULT_MESSAGE_BLOCKS_LIMIT;
		this.#syncConcurrency = options.syncConcurrency ?? DEFAULT_SYNC_CONCURRENCY;
		this.#pollingInterval = options.pollingInterval ?? DEFAULT_POLLING_INTERVAL;
		this.#pollRequestThrottleMs = options.pollRequestThrottleMs ?? DEFAULT_POLL_REQUEST_THROTTLE_MS;
		this.#backgroundSync = options.backgroundSync ?? true;
	}
	async _open() {
		this._ctx.onDispose(this.#edgeClient.onMessage((msg) => {
			if (!msg.serviceId) return;
			if (msg.serviceId.split(":")[0] !== EdgeService.QUEUE_REPLICATOR) return;
			log("feed sync edge ingress", {
				serviceId: msg.serviceId,
				payloadByteLength: msg.payload?.value?.byteLength
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$2,
				L: 151,
				S: this
			});
			const handleMessageEffect = Effect.gen(this, function* () {
				const decoded = yield* Effect.try({
					try: () => decode(msg.payload.value),
					catch: (error) => /* @__PURE__ */ new Error(`Failed to decode feed sync message: ${error}`)
				});
				const payload = yield* Schema.validate(FeedProtocol.ProtocolMessage)(decoded);
				yield* this.#syncClient.handleMessage(payload);
			}).pipe(Effect.tapError((cause) => Effect.sync(() => log("feed sync edge message handling failed", {
				serviceId: msg.serviceId,
				payloadByteLength: msg.payload?.value?.byteLength,
				cause: cause instanceof Error ? cause.message : String(cause)
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$2,
				L: 165,
				S: this
			}))));
			this.#runSerialized(() => RuntimeProvider.runPromise(this.#runtime)(handleMessageEffect));
		}));
		if (this.#backgroundSync) {
			await this.#pollTask.open();
			await this.#pushTask.open();
			this.#feedStore.onNewBlocks.on(this._ctx, () => {
				this.#pushTask.schedule();
			});
		}
		this._ctx.onDispose(this.#edgeClient.onReconnected(async () => {
			log("feed sync edge reconnected", {
				peerKey: this.#edgeClient.peerKey,
				identityDid: this.#edgeClient.identityDid
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$2,
				L: 196,
				S: this
			});
			if (this.#backgroundSync) {
				this.#resetSpacesToPoll();
				this.#pollTask.schedule();
				this.#pushTask.schedule();
			}
		}));
		if (this.#backgroundSync) {
			this.#resetSpacesToPoll();
			this.#pollTask.schedule();
			this.#pushTask.schedule();
		}
	}
	async _close() {
		if (this.#backgroundSync) {
			await this.#pollTask.close();
			await this.#pushTask.close();
		}
	}
	/**
	* Schedules a best-effort pull without blocking the caller.
	*/
	schedulePoll() {
		if (!this.#backgroundSync) return;
		this.#resetSpacesToPoll();
		if (this.#throttledPollScheduled) return;
		const now = Date.now();
		const delay = this.#lastRequestedPollAt == null ? 0 : Math.max(this.#pollRequestThrottleMs - (now - this.#lastRequestedPollAt), 0);
		this.#throttledPollScheduled = true;
		scheduleTask(this._ctx, () => {
			this.#throttledPollScheduled = false;
			this.#lastRequestedPollAt = Date.now();
			this.#pollTask.schedule();
		}, delay);
	}
	/**
	* Returns per-namespace queue sync backlog for a space.
	* `blocksToPull` and `blocksToPush` of 0 mean caught up for that namespace.
	*/
	async getSyncState(ctx, request) {
		const spaceId = request.spaceId;
		invariant(SpaceId.isValid(spaceId), void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$2,
			L: 259,
			S: this,
			A: ["SpaceId.isValid(spaceId)", ""]
		});
		const namespaces = request.namespaces != null && request.namespaces.length > 0 ? request.namespaces : this.#syncNamespaces;
		for (const feedNamespace of namespaces) invariant(FeedProtocol.isWellKnownNamespace(feedNamespace), void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$2,
			L: 263,
			S: this,
			A: ["FeedProtocol.isWellKnownNamespace(feedNamespace)", ""]
		});
		return this.#runSerialized(() => RuntimeProvider.runPromise(this.#runtime)(Effect.gen(this, function* () {
			return { namespaces: yield* Effect.forEach(namespaces, (feedNamespace) => Effect.gen(this, function* () {
				const blocksToPush = yield* this.#feedStore.countUnpositionedBlocks({
					spaceId,
					feedNamespace
				});
				const totalBlocks = yield* this.#feedStore.countNamespaceBlocks({
					spaceId,
					feedNamespace
				});
				const { blocksToPull } = yield* this.#syncClient.peekPull(ctx, {
					spaceId,
					feedNamespace,
					limit: this.#messageBlocksLimit
				}).pipe(Effect.catchAll((cause) => Effect.gen(this, function* () {
					this.#logSyncFailure("peekPull", {
						spaceId,
						feedNamespace,
						cause
					});
					return { blocksToPull: 0 };
				})));
				return {
					namespace: feedNamespace,
					blocksToPull: String(blocksToPull),
					blocksToPush: String(blocksToPush),
					totalBlocks: String(totalBlocks)
				};
			}), { concurrency: "unbounded" }) };
		})));
	}
	/**
	* Performs queue sync and blocks until there are no pending sync batches.
	*/
	async syncBlocking(ctx, { spaceId, subspaceTag, shouldPush = true, shouldPull = true }) {
		invariant(SpaceId.isValid(spaceId), void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$2,
			L: 327,
			S: this,
			A: ["SpaceId.isValid(spaceId)", ""]
		});
		invariant(FeedProtocol.isWellKnownNamespace(subspaceTag), void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$2,
			L: 328,
			S: this,
			A: ["FeedProtocol.isWellKnownNamespace(subspaceTag)", ""]
		});
		if (!shouldPush && !shouldPull) return;
		await this.#runSerialized(() => RuntimeProvider.runPromise(this.#runtime)(Effect.gen(this, function* () {
			let done = false;
			let iterations = 0;
			while (!done) {
				done = true;
				if (shouldPull) {
					const pullResult = yield* this.#syncClient.pull(ctx, {
						spaceId,
						feedNamespace: subspaceTag,
						limit: this.#messageBlocksLimit
					});
					done &&= pullResult.done;
				}
				if (shouldPush) {
					const pushResult = yield* this.#syncClient.push(ctx, {
						spaceId,
						feedNamespace: subspaceTag,
						limit: this.#messageBlocksLimit
					});
					done &&= pushResult.done;
				}
				iterations++;
				if (iterations > MAX_BLOCKING_SYNC_ITERATIONS) throw new Error("Blocking sync exceeded max iterations.");
			}
		})));
	}
	async #runSerialized(run) {
		try {
			var _usingCtx$2 = _usingCtx();
			_usingCtx$2.u(await this.#feedStoreMutex.acquire("feed-sync"));
			return run();
		} catch (_) {
			_usingCtx$2.e = _;
		} finally {
			_usingCtx$2.d();
		}
	}
	#schedulePushRetry({ hadFailure, needsMore }) {
		if (!needsMore) {
			this.#pushFailureBackoffMs = DEFAULT_PUSH_FAILURE_BACKOFF_MS;
			return;
		}
		if (hadFailure) {
			const delayMs = this.#pushFailureBackoffMs;
			this.#pushFailureBackoffMs = Math.min(this.#pushFailureBackoffMs * 2, MAX_PUSH_FAILURE_BACKOFF_MS);
			log.info("feed sync push retry scheduled with backoff", { delayMs }, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$2,
				L: 380,
				S: this
			});
			scheduleTask(this._ctx, () => this.#pushTask.schedule(), delayMs);
			return;
		}
		this.#pushFailureBackoffMs = DEFAULT_PUSH_FAILURE_BACKOFF_MS;
		this.#pushTask.schedule();
	}
	#resetSpacesToPoll() {
		this.#spacesToPoll.clear();
		this.#getSpaceIds().forEach((spaceId) => {
			this.#spacesToPoll.add(spaceId);
		});
		this.#lastFullPoll = Date.now();
	}
	#sendMessage(ctx, message) {
		return Effect.gen(this, function* () {
			const encoded = encoder.encode(message);
			const serviceId = this.#getTargetServiceId(message);
			const rpcTag = "blocks" in message ? "AppendRequest" : "QueryRequest";
			log("feed sync edge rpc outgoing", {
				tag: rpcTag,
				serviceId,
				payloadByteLength: encoded.byteLength,
				spaceId: message.spaceId,
				feedNamespace: message.feedNamespace,
				requestId: message.requestId
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$2,
				L: 404,
				S: this
			});
			yield* Effect.tryPromise(async () => this.#edgeClient.send(ctx, createBuf(MessageSchema, {
				source: {
					identityDid: this.#edgeClient.identityDid,
					peerKey: this.#edgeClient.peerKey
				},
				serviceId,
				payload: { value: bufferToArray(encoded) }
			}))).pipe(Effect.tapError((cause) => Effect.sync(() => log("feed sync edge send failed", {
				serviceId,
				tag: rpcTag,
				cause: cause instanceof Error ? cause.message : String(cause)
			}, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file$2,
				L: 427,
				S: this
			}))));
		});
	}
	#logSyncFailure(operation, { spaceId, feedNamespace, cause }) {
		log("feed sync operation failed", {
			operation,
			spaceId,
			feedNamespace,
			cause: cause instanceof Error ? cause.message : String(cause),
			errorTag: cause instanceof Error ? cause.name : void 0
		}, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$2,
			L: 442,
			S: this
		});
	}
	#getTargetServiceId(message) {
		return FeedProtocol.encodeServiceId(message.feedNamespace, message.spaceId);
	}
	#pollTask = new AsyncTask(async () => Effect.gen(this, function* () {
		yield* Effect.forEach(this.#spacesToPoll, (spaceId) => Effect.gen(this, function* () {
			let doneForAllNamespaces = true;
			for (const feedNamespace of this.#syncNamespaces) {
				const { done } = yield* this.#syncClient.pull(this._ctx, {
					spaceId,
					feedNamespace,
					limit: this.#messageBlocksLimit
				}).pipe(Effect.catchAll((cause) => Effect.gen(this, function* () {
					this.#logSyncFailure("pull", {
						spaceId,
						feedNamespace,
						cause
					});
					return { done: false };
				})));
				if (!done) doneForAllNamespaces = false;
			}
			if (doneForAllNamespaces) this.#spacesToPoll.delete(spaceId);
		}), { concurrency: this.#syncConcurrency });
		if (this.#lastFullPoll == null || Date.now() - this.#lastFullPoll > this.#pollingInterval) {
			this.#resetSpacesToPoll();
			this.#pollTask.schedule();
		} else if (this.#spacesToPoll.size > 0) this.#pollTask.schedule();
		else {
			this.#resetSpacesToPoll();
			scheduleTask(this._ctx, () => this.#pollTask.schedule(), Math.max(this.#pollingInterval - (Date.now() - (this.#lastFullPoll ?? 0)), 0));
		}
	}).pipe((effect) => this.#runSerialized(() => RuntimeProvider.runPromise(this.#runtime)(effect))));
	#pushTask = new AsyncTask(async () => Effect.gen(this, function* () {
		yield* Effect.forEach(this.#getSpaceIds(), (spaceId) => Effect.gen(this, function* () {
			let needsMorePush = false;
			let hadPushFailure = false;
			for (const feedNamespace of this.#syncNamespaces) {
				const { done } = yield* this.#syncClient.push(this._ctx, {
					spaceId,
					feedNamespace,
					limit: this.#messageBlocksLimit
				}).pipe(Effect.tap(() => Effect.sync(() => {
					this.#pushFailureBackoffMs = DEFAULT_PUSH_FAILURE_BACKOFF_MS;
				})), Effect.catchAll((cause) => Effect.gen(this, function* () {
					this.#logSyncFailure("push", {
						spaceId,
						feedNamespace,
						cause
					});
					hadPushFailure = true;
					return { done: false };
				})));
				if (!done) needsMorePush = true;
			}
			this.#schedulePushRetry({
				hadFailure: hadPushFailure,
				needsMore: needsMorePush
			});
		}), { concurrency: this.#syncConcurrency });
	}).pipe((effect) => this.#runSerialized(() => RuntimeProvider.runPromise(this.#runtime)(effect))));
};
/**
* Effect Layer constructing a {@link FeedSyncer} from ambient SQL, echo host, and edge services.
*
* The feed store is sourced from the {@link EchoHostService} (breaking the EchoHost <-> FeedSyncer
* cycle). Only included when an edge connection is configured, so it resolves the edge tag directly.
*/
var FeedSyncerLayer = (options) => Layer.effect(FeedSyncerService, Effect.gen(function* () {
	const runtime = yield* RuntimeProvider.currentRuntime();
	const echoHost = yield* EchoHostService;
	const edgeClient = yield* EdgeConnectionService;
	return new FeedSyncer({
		runtime,
		feedStore: echoHost.feedStore,
		edgeClient,
		getSpaceIds: () => echoHost.spaceIds,
		...options
	});
}));
//#endregion
//#region src/packlets/services/sqlite-storage.ts
var __dxlog_file$1 = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/services/sqlite-storage.ts";
/**
* True when a rejected SQL op failed because its connection was already closed — the message
* `The database connection is not open` (raised by `@effect/sql-sqlite-node`), which arrives
* wrapped as an effect `SqlError`, so walk the `cause` chain. Signals teardown, not a real fault.
*/
var isClosedConnectionError = (err) => {
	for (let cur = err, depth = 0; cur != null && depth < 5; cur = cur.cause, depth++) {
		const message = typeof cur === "string" ? cur : cur.message;
		if (typeof message === "string" && /connection is not open/i.test(message)) return true;
	}
	return false;
};
/**
* Effect service tag for {@link SqliteStorage}.
*/
var SqliteStorageService = class extends EffectContext.Tag("@dxos/client-services/SqliteStorage")() {};
/** Minimal cross-platform EventEmitter needed by the RandomAccessStorage contract. */
var BaseEventEmitter = class {
	#events = Object.create(null);
	on(event, listener) {
		(this.#events[event] ??= []).push(listener);
		return this;
	}
	off(event, listener) {
		const list = this.#events[event];
		if (list) {
			const idx = list.indexOf(listener);
			if (idx !== -1) list.splice(idx, 1);
		}
		return this;
	}
	emit(event, ...args) {
		const list = this.#events[event];
		if (!list?.length) return false;
		for (const fn of [...list]) fn(...args);
		return true;
	}
	addListener = this.on;
	removeListener = this.off;
	once(event, listener) {
		const wrapper = (...args) => {
			this.off(event, wrapper);
			listener(...args);
		};
		return this.on(event, wrapper);
	}
	removeAllListeners(event) {
		if (event) delete this.#events[event];
		else for (const key of Object.keys(this.#events)) delete this.#events[key];
		return this;
	}
	listeners(event) {
		return this.#events[event] ?? [];
	}
	rawListeners(event) {
		return this.#events[event] ?? [];
	}
	listenerCount(event) {
		return this.#events[event]?.length ?? 0;
	}
	prependListener(event, listener) {
		(this.#events[event] ??= []).unshift(listener);
		return this;
	}
	prependOnceListener(event, listener) {
		const wrapper = (...args) => {
			this.off(event, wrapper);
			listener(...args);
		};
		return this.prependListener(event, wrapper);
	}
	eventNames() {
		return Object.keys(this.#events);
	}
	getMaxListeners() {
		return 0;
	}
	setMaxListeners() {
		return this;
	}
};
/**
* SQLite-backed random-access file for hypercore storage.
* Stores each file as a blob in `hypercore_files`. Read-modify-write for writes.
*/
var SqliteRandomAccessFile = class extends BaseEventEmitter {
	filePath;
	runtime;
	opened = false;
	suspended = false;
	writing = false;
	readable = true;
	writable = true;
	deletable = true;
	truncatable = false;
	statable = false;
	#closed = false;
	#unlinked = false;
	#destroyed = false;
	get closed() {
		return this.#closed;
	}
	get unlinked() {
		return this.#unlinked;
	}
	get destroyed() {
		return this.#destroyed;
	}
	directory;
	filename;
	#buffer = Buffer.alloc(0);
	#loaded = false;
	#loading = null;
	#saving = null;
	constructor(filePath, runtime) {
		super();
		this.filePath = filePath;
		this.runtime = runtime;
		const parts = filePath.split("/");
		this.filename = parts.pop() ?? "";
		this.directory = parts.join("/");
	}
	_ensureLoaded() {
		if (this.#loaded) return Promise.resolve();
		if (this.#closed) return Promise.resolve();
		if (!this.#loading) {
			this.#loading = this._loadFromDb();
			this.#loading.catch(() => {});
		}
		return this.#loading;
	}
	async _loadFromDb() {
		const filePath = this.filePath;
		try {
			const rows = await RuntimeProvider.runPromise(this.runtime)(Effect.gen(function* () {
				return yield* (yield* SqlClient.SqlClient)`SELECT data FROM hypercore_files WHERE path = ${filePath}`;
			}));
			this.#buffer = rows.length > 0 ? Buffer.from(rows[0].data) : Buffer.alloc(0);
		} catch (err) {
			if (!this.#closed && !isClosedConnectionError(err)) throw err;
		}
		this.#loaded = true;
	}
	async _saveToDb() {
		const filePath = this.filePath;
		const data = this.#buffer;
		try {
			await RuntimeProvider.runPromise(this.runtime)(Effect.gen(function* () {
				yield* (yield* SqlClient.SqlClient)`INSERT OR REPLACE INTO hypercore_files (path, data) VALUES (${filePath}, ${data})`;
			}));
		} catch (err) {
			if (!this.#closed && !isClosedConnectionError(err)) throw err;
		}
	}
	write(offset, data, cb) {
		const saving = this._ensureLoaded().then(() => {
			const end = offset + data.length;
			if (end > this.#buffer.length) {
				const enlarged = Buffer.alloc(end);
				this.#buffer.copy(enlarged);
				this.#buffer = enlarged;
			}
			data.copy(this.#buffer, offset);
			return this._saveToDb();
		}).then(() => cb(null), (err) => cb(err));
		this.#saving = saving.catch(() => {});
	}
	read(offset, size, cb) {
		this._ensureLoaded().then(() => {
			if (size === 0) {
				cb(null, Buffer.alloc(0));
				return;
			}
			if (offset + size > this.#buffer.length) {
				cb(/* @__PURE__ */ new Error(`Could not satisfy length ${size} at offset ${offset} (file size: ${this.#buffer.length})`));
				return;
			}
			cb(null, Buffer.from(this.#buffer.subarray(offset, offset + size)));
		}).catch((err) => cb(err));
	}
	del(offset, size, cb) {
		const saving = this._ensureLoaded().then(() => {
			const end = Math.min(offset + size, this.#buffer.length);
			if (offset < end) this.#buffer.fill(0, offset, end);
			return this._saveToDb();
		}).then(() => cb(null), (err) => cb(err));
		this.#saving = saving.catch(() => {});
	}
	stat(cb) {
		this._ensureLoaded().then(() => {
			cb(null, { size: this.#buffer.length });
		}).catch((err) => cb(err));
	}
	close(cb) {
		this.#closed = true;
		Promise.all([this.#loading ?? Promise.resolve(), this.#saving ?? Promise.resolve()]).then(() => cb(null), () => cb(null));
	}
	destroy(cb) {
		const filePath = this.filePath;
		RuntimeProvider.runPromise(this.runtime)(Effect.gen(function* () {
			yield* (yield* SqlClient.SqlClient)`DELETE FROM hypercore_files WHERE path = ${filePath}`;
		})).then(() => {
			this.#buffer = Buffer.alloc(0);
			this.#destroyed = true;
			this.#unlinked = true;
			this.#closed = true;
			cb(null);
		}).catch((err) => cb(err));
	}
};
/**
* SQLite-backed Storage implementation for hypercore feeds.
* Table: hypercore_files(path TEXT PRIMARY KEY, data BLOB NOT NULL DEFAULT x'').
*/
var SqliteStorage = class {
	path;
	type = StorageType.NODE;
	#runtime;
	#files = /* @__PURE__ */ new Map();
	#nativeFiles = /* @__PURE__ */ new Map();
	#closed = false;
	constructor({ runtime }, path = "/sqlite-feeds") {
		this.#runtime = runtime;
		this.path = path;
	}
	migrate = Effect.fn("SqliteStorage.migrate")(() => Effect.gen(function* () {
		yield* (yield* SqlClient.SqlClient)`CREATE TABLE IF NOT EXISTS hypercore_files (
          path TEXT PRIMARY KEY,
          data BLOB NOT NULL DEFAULT x''
        )`;
		log("hypercore_files table ready", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$1,
			L: 371,
			S: this
		});
	}).pipe(Effect.withSpan("SqliteStorage.migrate")))();
	get size() {
		return this.#files.size;
	}
	createDirectory(sub = "") {
		const dirPath = sub ? `${this.path}/${sub}` : this.path;
		const runtime = this.#runtime;
		const files = this.#files;
		const nativeFiles = this.#nativeFiles;
		const getOrCreateFile = (path, filename) => {
			const fullPath = `${path}/${filename}`;
			const existingNative = nativeFiles.get(fullPath);
			if (existingNative && !existingNative.destroyed) return files.get(fullPath);
			const native = new SqliteRandomAccessFile(fullPath, runtime);
			const file = wrapFile(native, StorageType.NODE);
			files.set(fullPath, file);
			nativeFiles.set(fullPath, native);
			return file;
		};
		const list = async (path) => {
			const prefix = path.endsWith("/") ? path : path + "/";
			return (await RuntimeProvider.runPromise(runtime)(Effect.gen(function* () {
				return yield* (yield* SqlClient.SqlClient)`SELECT path FROM hypercore_files WHERE path = ${path} OR path LIKE ${prefix + "%"}`;
			}))).map((row) => row.path.replace(path + "/", "").replace(path, ""));
		};
		const remove = async () => {
			const prefix = dirPath.endsWith("/") ? dirPath : dirPath + "/";
			await RuntimeProvider.runPromise(runtime)(Effect.gen(function* () {
				yield* (yield* SqlClient.SqlClient)`DELETE FROM hypercore_files WHERE path = ${dirPath} OR path LIKE ${prefix + "%"}`;
			}));
			for (const [filePath] of files) if (filePath === dirPath || filePath.startsWith(prefix)) files.delete(filePath);
		};
		return new Directory({
			type: StorageType.NODE,
			path: dirPath,
			list,
			getOrCreateFile,
			remove
		});
	}
	async reset() {
		log("SqliteStorage: clearing all hypercore files", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file$1,
			L: 437,
			S: this
		});
		await RuntimeProvider.runPromise(this.#runtime)(Effect.gen(function* () {
			yield* (yield* SqlClient.SqlClient)`DELETE FROM hypercore_files`;
		}));
		this.#files.clear();
	}
	async close() {
		if (this.#closed) return;
		this.#closed = true;
		const natives = [...this.#nativeFiles.values()];
		await Promise.all(natives.map((native) => new Promise((resolve) => native.close(() => resolve()))));
		this.#files.clear();
		this.#nativeFiles.clear();
	}
};
/**
* Effect Layer constructing a {@link SqliteStorage} from the ambient SQL runtime.
*/
var SqliteStorageLayer = (options = {}) => Layer.effect(SqliteStorageService, Effect.gen(function* () {
	return new SqliteStorage({ runtime: yield* RuntimeProvider.currentRuntime() }, options.path);
}));
/**
* Effect Layer providing the hypercore feeds root directory from {@link SqliteStorage}.
*/
var FeedStorageDirectoryLayer = (options = {}) => Layer.effect(FeedStorageDirectoryService, Effect.gen(function* () {
	return (yield* SqliteStorageService).createDirectory(options.sub ?? "feeds");
}));
//#endregion
//#region src/packlets/services/service-context.ts
/**
* Combined storage migration effect gathered from the concrete SQLite stores.
* Run by {@link ClientServicesHost} during open (storage migration stage).
*/
var StorageMigrationService = class extends EffectContext.Tag("@dxos/client-services/StorageMigration")() {};
/**
* Effect Layer composing the dormant client-stack components, constructed before identity is ready.
* {@link ClientServicesHost} resolves these tags and drives their lifecycle.
*/
var ServiceContextLayer = (options) => {
	const { edgeConnection, edgeHttpClient } = options;
	const core = CrossDeviceSpaceSynchronizerLayer.pipe(Layer.provideMerge(EdgeAgentManagerLayer({ edgeFeatures: options.edgeFeatures })), Layer.provideMerge(DataSpaceManagerLayer({
		runtimeProps: options,
		edgeFeatures: options.edgeFeatures
	})), Layer.provideMerge(SigningContextProviderLayer), Layer.provideMerge(identityProviderLayer), Layer.provideMerge(options.disableP2pReplication ? Layer.empty : MeshEchoReplicatorLayer()), Layer.provideMerge(echoHostLayer({ useSubduction: options.edgeFeatures?.subductionReplicator })), Layer.provideMerge(InvitationsManagerLayer()), Layer.provideMerge(InvitationsHandlerLayer({ connectionProps: options.invitationConnectionDefaultProps })), Layer.provideMerge(EdgeIdentityRecoveryManagerLayer()), Layer.provideMerge(IdentityManagerLayer({
		devicePresenceOfflineTimeout: options.devicePresenceOfflineTimeout,
		devicePresenceAnnounceInterval: options.devicePresenceAnnounceInterval,
		edgeFeatures: options.edgeFeatures
	})), Layer.provideMerge(SpaceManagerLayer({ disableP2pReplication: options.disableP2pReplication })), Layer.provideMerge(storageLayer));
	if (!edgeConnection || !edgeHttpClient) return core;
	return FeedSyncerLayer({
		peerId: "",
		syncNamespaces: [FeedProtocol.WellKnownNamespaces.data, FeedProtocol.WellKnownNamespaces.trace]
	}).pipe(Layer.provideMerge(core), Layer.provideMerge(options.edgeFeatures?.subductionReplicator ? EchoEdgeSubductionReplicatorLayer() : options.edgeFeatures?.echoReplicator ? EchoEdgeReplicatorLayer() : Layer.empty), Layer.provideMerge(Layer.mergeAll(Layer.succeed(EdgeConnectionService, edgeConnection), Layer.succeed(EdgeHttpClientService, edgeHttpClient))));
};
/**
* Provides the {@link IdentityProviderService} from the resolved {@link IdentityManager}.
*/
var identityProviderLayer = Layer.effect(IdentityProviderService, Effect.gen(function* () {
	return identityProviderFromManager(yield* IdentityManagerService);
}));
/**
* Combined storage migration effect. Storage migrations are idempotent `CREATE TABLE` effects that
* do not depend on store instance state, so they are extracted from throwaway instances to keep the
* store layers individual. Run by {@link ClientServicesHost} during open.
*/
var storageMigrationLayer = Layer.effect(StorageMigrationService, Effect.gen(function* () {
	const runtime = yield* RuntimeProvider.currentRuntime();
	return Effect.all([
		new SqliteMetadataStore({ runtime }).migrate,
		new SqliteBlobStore({ runtime }).migrate,
		new SqliteKeyring({ runtime }).migrate,
		new SqliteStorage({ runtime }).migrate
	], { discard: true });
}));
/**
* Storage / feed layers composed from the individual store layers plus the combined migration.
*/
var storageLayer = Layer.empty.pipe(Layer.provideMerge(FeedStoreLayer()), Layer.provideMerge(FeedFactoryLayer({ hypercore: {
	valueEncoding,
	stats: true
} })), Layer.provideMerge(FeedStorageDirectoryLayer()), Layer.provideMerge(SqliteMetadataStoreLayer()), Layer.provideMerge(SqliteBlobStoreLayer()), Layer.provideMerge(SqliteKeyringLayer()), Layer.provideMerge(SqliteStorageLayer()), Layer.provideMerge(storageMigrationLayer));
/**
* Constructs the {@link EchoHost}, resolving the identity/space callbacks that point down the stack.
* The feed sync handlers (which point up) are wired later via `EchoHost.setFeedSyncHandlers`.
*
* The host is self-contained (runs its own migrations, owns its feed/automerge stores), so its
* open/close is owned by the layer scope: it opens when the stack is built and closes when the
* runtime is disposed. Identity-, network-, and storage-bound lifecycle stays in `ClientServicesHost`.
*/
var echoHostLayer = (options) => Layer.scopedDiscard(Effect.gen(function* () {
	const echoHost = yield* EchoHostService;
	yield* Effect.acquireRelease(Effect.promise(() => echoHost.open()), () => Effect.promise(() => echoHost.close()));
})).pipe(Layer.provideMerge(Layer.unwrapEffect(Effect.gen(function* () {
	const identityManager = yield* IdentityManagerService;
	const spaceManager = yield* SpaceManagerService;
	return EchoHostLayer({
		peerIdProvider: () => identityManager.identity?.deviceKey?.toHex(),
		getSpaceKeyByRootDocumentId: (documentId) => spaceManager.findSpaceByRootDocumentId(documentId)?.key,
		useSubduction: options.useSubduction
	});
}))));
//#endregion
//#region src/packlets/services/service-host.ts
var __dxlog_file = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/services/service-host.ts";
/**
* Shared backend for all client services.
*
* Owns the full client stack and its lifecycle: it builds the layer-composed components (keyring,
* feed store, echo host, identity/space managers, …) plus the client RPC handlers, then drives the
* open sequence (migrate → identity → network → space initialization) and teardown. It reads or
* creates the identity, propagates it outward (`_setNetworkIdentity`), and opens the identity-bound
* services once an identity is available (`_initialize`). The host provides itself into the stack
* (via {@link ClientServicesHostService}) so the RPC handler layers can resolve the orchestration
* entry points they need without a separate `ServiceContext` service.
*/
var ClientServicesHost = class {
	#resourceLock;
	#handlers;
	#systemService;
	#loggingService;
	#statusUpdate = new Event();
	#config;
	#signalManager;
	#networkManager;
	#callbacks;
	#devtoolsProxy;
	#edgeConnection = void 0;
	#edgeHttpClient = void 0;
	#stackRuntime;
	#runtime;
	#runtimeProps;
	#diagnosticsBroadcastHandler;
	#opening = false;
	#open = false;
	#resetting = false;
	#ctx;
	#metadataStore;
	#blobStore;
	#keyring;
	#feedStore;
	#spaceManager;
	#identityManager;
	#recoveryManager;
	#invitations;
	#invitationsManager;
	#echoHost;
	#signingContextProvider;
	#dataSpaceManager;
	#edgeAgentManager;
	#deviceSpaceSync;
	#meshReplicator;
	#echoEdgeReplicator;
	#feedSyncer;
	#storageMigrate;
	#initialized = new Trigger();
	#edgeIdentityUpdateMutex = new Mutex();
	#handlerFactories = /* @__PURE__ */ new Map();
	constructor({ config, transportFactory, signalManager, lockKey, callbacks, runtime, runtimeProps }) {
		this.#callbacks = callbacks;
		this.#runtime = runtime;
		this.#runtimeProps = runtimeProps ?? {};
		if (config) this.initialize({
			config,
			transportFactory,
			signalManager
		});
		if (lockKey) this.#resourceLock = new locks_exports.Lock({
			lockKey,
			onAcquire: () => {
				if (!this.#opening) this.open(new Context(void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file,
					L: 256
				}));
			},
			onRelease: () => this.close(Context.default(void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 259
			}))
		});
		this.#systemService = new SystemServiceImpl({
			config: () => this.#config,
			statusUpdate: this.#statusUpdate,
			getCurrentStatus: () => this.isOpen && !this.#resetting ? SystemStatus.ACTIVE : SystemStatus.INACTIVE,
			getDiagnostics: async () => {
				const scope = Effect.runSync(Scope.make());
				try {
					return await createDiagnostics(makeServicesFromRpc(await EffectEx.runPromise(makeInProcessClientServicesRpc(() => this.#handlers).pipe(Effect.provideService(Scope.Scope, scope))), Runtime.defaultRuntime), this, this.#config);
				} finally {
					await EffectEx.runPromise(Scope.close(scope, Exit.void));
				}
			},
			onUpdateStatus: async (status) => {
				if (!this.isOpen && status === SystemStatus.ACTIVE) await this.#resourceLock?.acquire();
				else if (this.isOpen && status === SystemStatus.INACTIVE) await this.#resourceLock?.release();
			},
			onReset: async () => {
				await this.reset();
			}
		});
		this.#diagnosticsBroadcastHandler = (0, diagnostics_exports.createCollectDiagnosticsBroadcastHandler)(this.#systemService);
		this.#loggingService = new LoggingServiceImpl();
		this.#handlers = { SystemService: this.#systemService };
	}
	get isOpen() {
		return this.#open;
	}
	get config() {
		return this.#config;
	}
	get context() {
		return this;
	}
	get services() {
		return this.#handlers;
	}
	get initialized() {
		return this.#initialized;
	}
	get identityManager() {
		return this.#identityManager ?? failUndefined();
	}
	get spaceManager() {
		return this.#spaceManager ?? failUndefined();
	}
	get metadataStore() {
		return this.#metadataStore ?? failUndefined();
	}
	get blobStore() {
		return this.#blobStore ?? failUndefined();
	}
	get recoveryManager() {
		return this.#recoveryManager ?? failUndefined();
	}
	get keyring() {
		return this.#keyring ?? failUndefined();
	}
	get feedStore() {
		return this.#feedStore ?? failUndefined();
	}
	get echoHost() {
		return this.#echoHost ?? failUndefined();
	}
	get invitations() {
		return this.#invitations ?? failUndefined();
	}
	get invitationsManager() {
		return this.#invitationsManager ?? failUndefined();
	}
	get networkManager() {
		return this.#networkManager ?? failUndefined();
	}
	get signalManager() {
		return this.#signalManager ?? failUndefined();
	}
	get dataSpaceManager() {
		return this.#dataSpaceManager;
	}
	get edgeAgentManager() {
		return this.#edgeAgentManager;
	}
	get edgeConnection() {
		return this.#edgeConnection;
	}
	/**
	* Debugging util.
	*/
	async exportSqliteDatabase() {
		return await RuntimeProvider.runPromise(this.#runtime)(Effect.gen(function* () {
			return yield* (yield* SqlExport.SqlExport).export;
		}));
	}
	/**
	* Debugging util.
	*/
	async runSqliteQuery(query, params) {
		return await RuntimeProvider.runPromise(this.#runtime)(Effect.gen(function* () {
			const sql = yield* SqlClient.SqlClient;
			return yield* sql`${sql.unsafe(query, params)}`;
		}));
	}
	/**
	* Initialize the service host with the config.
	* Config can also be provided in the constructor.
	* Can only be called once.
	*/
	initialize({ config, ...options }) {
		invariant(!this.#open, "service host is open", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 413,
			S: this,
			A: ["!this.#open", "'service host is open'"]
		});
		log("initializing...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 414,
			S: this
		});
		if (config) {
			if (this.#runtimeProps.disableP2pReplication === void 0) this.#runtimeProps.disableP2pReplication = config?.get("runtime.client.disableP2pReplication", false);
			if (this.#runtimeProps.enableVectorIndexing === void 0) this.#runtimeProps.enableVectorIndexing = config?.get("runtime.client.enableVectorIndexing", false);
			invariant(!this.#config, "config already set", {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 424,
				S: this,
				A: ["!this.#config", "'config already set'"]
			});
			this.#config = config;
		}
		const endpoint = config?.get("runtime.services.edge.url");
		if (endpoint) {
			const clientTag = resolveTelemetryTag(config);
			this.#edgeConnection = new EdgeClient(createStubEdgeIdentity(), {
				socketEndpoint: endpoint,
				clientTag
			});
			this.#edgeHttpClient = new EdgeHttpClient(endpoint, { clientTag });
		}
		const { connectionLog = true, transportFactory = createRtcTransportFactory({ iceServers: this.#config?.get("runtime.services.ice") }, this.#config?.get("runtime.services.iceProviders") && createIceProvider(this.#config.get("runtime.services.iceProviders"))), signalManager = this.#edgeConnection && this.#config?.get("runtime.client.edgeFeatures")?.signaling ? new EdgeSignalManager({ edgeConnection: this.#edgeConnection }) : new MemorySignalManager(new MemorySignalManagerContext()) } = options;
		this.#signalManager = signalManager;
		invariant(!this.#networkManager, "network manager already set", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 450,
			S: this,
			A: ["!this.#networkManager", "'network manager already set'"]
		});
		this.#networkManager = new SwarmNetworkManager({
			enableDevtoolsLogging: connectionLog,
			transportFactory,
			signalManager,
			peerInfo: this.#edgeConnection ? {
				identityDid: this.#edgeConnection.identityDid,
				peerKey: this.#edgeConnection.peerKey
			} : void 0
		});
		log("initialized", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 463,
			S: this
		});
	}
	async open(ctx = new Context(void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file,
		L: 468
	})) {
		if (this.#open) return;
		log("opening service host", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 473,
			S: this
		});
		invariant(this.#config, "config not set", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 475,
			S: this,
			A: ["this.#config", "'config not set'"]
		});
		invariant(this.#signalManager, "signal manager not set", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 476,
			S: this,
			A: ["this.#signalManager", "'signal manager not set'"]
		});
		invariant(this.#networkManager, "network manager not set", {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 477,
			S: this,
			A: ["this.#networkManager", "'network manager not set'"]
		});
		const config = this.#config;
		const signalManager = this.#signalManager;
		const networkManager = this.#networkManager;
		this.#opening = true;
		this.#ctx = ctx;
		log("opening...", { lockKey: this.#resourceLock?.lockKey }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 484,
			S: this
		});
		await this.#resourceLock?.acquire();
		await this.#loggingService.open();
		const stackLayer = ClientServicesRpcLayer.pipe(Layer.provideMerge(Layer.succeed(ClientServicesHostService, this)), Layer.provideMerge(ServiceContextLayer({
			...this.#runtimeProps,
			edgeFeatures: config.get("runtime.client.edgeFeatures"),
			edgeConnection: this.#edgeConnection,
			edgeHttpClient: this.#edgeHttpClient
		})), Layer.provideMerge(Layer.succeed(SwarmNetworkManagerService, networkManager)), Layer.provideMerge(Layer.succeed(SignalManagerService, signalManager)), Layer.provideMerge(RuntimeProvider.toLayer(this.#runtime)), Layer.orDie);
		this.#stackRuntime = ManagedRuntime.make(stackLayer);
		const resolved = await this.#stackRuntime.runPromise(Effect.all({
			metadataStore: IMetadataStoreService,
			blobStore: BlobStoreApiService,
			keyring: KeyringApiService,
			feedStore: FeedStoreService,
			spaceManager: SpaceManagerService,
			identityManager: IdentityManagerService,
			recoveryManager: EdgeIdentityRecoveryManagerService,
			invitations: InvitationsHandlerService,
			invitationsManager: InvitationsManagerService,
			echoHost: EchoHostService,
			signingContextProvider: SigningContextProviderService,
			dataSpaceManager: DataSpaceManagerService,
			edgeAgentManager: EdgeAgentManagerService,
			deviceSpaceSync: CrossDeviceSpaceSynchronizerService,
			storageMigrate: StorageMigrationService,
			meshReplicator: Effect.serviceOption(MeshEchoReplicatorService),
			echoEdgeReplicator: Effect.serviceOption(EdgeAutomergeReplicatorService),
			feedSyncer: Effect.serviceOption(FeedSyncerService),
			identityService: IdentityService.Tag,
			contactsService: ContactsService.Tag,
			invitationsService: InvitationsService.Tag,
			devicesService: DevicesService.Tag,
			spacesService: SpacesService.Tag,
			networkService: NetworkService.Tag,
			edgeAgentService: EdgeAgentService.Tag,
			dataService: DataService.Tag,
			queryService: QueryService.Tag,
			feedService: FeedService.Tag
		}));
		this.#metadataStore = resolved.metadataStore;
		this.#blobStore = resolved.blobStore;
		this.#keyring = resolved.keyring;
		this.#feedStore = resolved.feedStore;
		this.#spaceManager = resolved.spaceManager;
		this.#identityManager = resolved.identityManager;
		this.#recoveryManager = resolved.recoveryManager;
		this.#invitations = resolved.invitations;
		this.#invitationsManager = resolved.invitationsManager;
		this.#echoHost = resolved.echoHost;
		this.#signingContextProvider = resolved.signingContextProvider;
		this.#dataSpaceManager = resolved.dataSpaceManager;
		this.#edgeAgentManager = resolved.edgeAgentManager;
		this.#deviceSpaceSync = resolved.deviceSpaceSync;
		this.#storageMigrate = resolved.storageMigrate;
		this.#meshReplicator = Option.getOrUndefined(resolved.meshReplicator);
		this.#echoEdgeReplicator = Option.getOrUndefined(resolved.echoEdgeReplicator);
		this.#feedSyncer = Option.getOrUndefined(resolved.feedSyncer);
		this.#handlerFactories.set(Invitation.Kind.DEVICE, () => new DeviceInvitationProtocol(this.#keyring, () => this.#identityManager.identity ?? failUndefined(), this._acceptIdentity.bind(this)));
		this.#recoveryManager.setAcceptRecoveredIdentity((params) => this._acceptIdentity(params));
		this.#invitationsManager.setInvitationHandlerFactory((invitation) => this.getInvitationHandler(invitation));
		this.#echoHost.setFeedSyncHandlers({
			syncFeed: async (feedSyncCtx, request) => this.#feedSyncer?.syncBlocking(feedSyncCtx, {
				spaceId: request.spaceId,
				subspaceTag: request.subspaceTag,
				shouldPush: request.shouldPush,
				shouldPull: request.shouldPull
			}),
			getSyncState: async (feedSyncCtx, request) => {
				if (!this.#feedSyncer) return { namespaces: [] };
				return this.#feedSyncer.getSyncState(feedSyncCtx, request);
			}
		});
		this.#handlers = {
			SystemService: this.#systemService,
			IdentityService: resolved.identityService,
			ContactsService: resolved.contactsService,
			InvitationsService: resolved.invitationsService,
			DevicesService: resolved.devicesService,
			SpacesService: resolved.spacesService,
			DataService: resolved.dataService,
			QueryService: resolved.queryService,
			FeedService: resolved.feedService,
			NetworkService: resolved.networkService,
			LoggingService: this.#loggingService,
			DevtoolsHost: new DevtoolsServiceImpl({
				events: new DevtoolsHostEvents(),
				config: this.#config,
				context: this,
				exportSqliteDatabase: () => this.exportSqliteDatabase(),
				runSqliteQuery: (query, params) => this.runSqliteQuery(query, params)
			}),
			EdgeAgentService: resolved.edgeAgentService
		};
		await this._openStack(ctx);
		const devtoolsProxy = this.#config?.get("runtime.client.devtoolsProxy");
		if (devtoolsProxy) log.warn("devtoolsProxy is not supported with effect-rpc services; skipping", { devtoolsProxy }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 623,
			S: this
		});
		this.#diagnosticsBroadcastHandler.start();
		this.#opening = false;
		this.#open = true;
		this.#statusUpdate.emit();
		const deviceKey = this.#identityManager?.identity?.deviceKey;
		log("opened", { deviceKey }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 631,
			S: this
		});
	}
	async close(ctx = Context.default(void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file,
		L: 636
	})) {
		if (!this.#open) return;
		const deviceKey = this.#identityManager?.identity?.deviceKey;
		log("closing...", { deviceKey }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 642,
			S: this
		});
		this.#diagnosticsBroadcastHandler.stop();
		await this.#devtoolsProxy?.close();
		this.#handlers = { SystemService: this.#systemService };
		await this.#loggingService.close();
		await this._closeStack(ctx);
		await this.#stackRuntime?.dispose();
		this.#stackRuntime = void 0;
		this.#open = false;
		this.#statusUpdate.emit();
		log("closed", { deviceKey }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 652,
			S: this
		});
	}
	async reset() {
		log.info("resetting...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 656,
			S: this
		});
		this.#resetting = true;
		this.#statusUpdate.emit();
		if (this.#open) await this._closeStack(this.#ctx ?? Context.default(void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 662
		}));
		await RuntimeProvider.runPromise(this.#runtime)(Effect.gen(function* () {
			const sql = yield* SqlClient.SqlClient;
			yield* sql`DELETE FROM space_metadata`;
			yield* sql`DELETE FROM space_large`;
			yield* sql`DELETE FROM blobs_meta`;
			yield* sql`DELETE FROM blobs_data`;
			yield* sql`DELETE FROM keyring`;
			yield* sql`DELETE FROM automerge_chunks`;
			yield* sql`DELETE FROM automerge_heads`;
			yield* sql`DELETE FROM hypercore_files`;
			yield* sql`DELETE FROM feeds`;
			yield* sql`DELETE FROM blocks`;
			yield* sql`DELETE FROM subscriptions`;
			yield* sql`DELETE FROM cursor_tokens`;
			yield* sql`DELETE FROM sync_state`;
			yield* sql`DELETE FROM indexCursor`;
			yield* sql`DELETE FROM objectMeta`;
			yield* sql`DELETE FROM reverseRef`;
			yield* sql`DELETE FROM ftsIndex`;
		}));
		log.info("reset", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 694,
			S: this
		});
		await this.#callbacks?.onReset?.();
	}
	async createIdentity(params = {}, ctx) {
		ctx ??= this.#ctx ?? Context.default(void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 703
		});
		const identity = await this.identityManager.createIdentity(params, ctx);
		await this._setNetworkIdentity({ identity });
		await identity.joinNetwork(ctx);
		await this._initialize(ctx);
		return identity;
	}
	getInvitationHandler(invitation) {
		if (this.identityManager.identity == null && invitation.kind === Invitation.Kind.SPACE) throw new Error("Identity must be created before joining a space.");
		const factory = this.#handlerFactories.get(invitation.kind);
		invariant(factory, `Unknown invitation kind: ${invitation.kind}`, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 716,
			S: this,
			A: ["factory", "`Unknown invitation kind: ${invitation.kind}`"]
		});
		return factory(invitation);
	}
	async broadcastProfileUpdate(profile) {
		if (!profile || !this.#dataSpaceManager) return;
		for (const space of this.#dataSpaceManager.spaces.values()) await space.updateOwnProfile(profile);
	}
	/**
	* Resolves the {@link DataSpaceManager} once identity-bound services have opened (`initialized`).
	*/
	async whenDataSpaceManagerReady() {
		await this.#initialized.wait();
		return this.#dataSpaceManager ?? failUndefined();
	}
	/**
	* Resolves the {@link EdgeAgentManager} once identity-bound services have opened (`initialized`).
	*/
	async whenEdgeAgentManagerReady() {
		await this.#initialized.wait();
		return this.#edgeAgentManager ?? failUndefined();
	}
	async _acceptIdentity(params) {
		const ctx = this.#ctx ?? Context.default(void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 746
		});
		const { identity, identityRecord } = await this.identityManager.prepareIdentity(params, ctx);
		await this._setNetworkIdentity({
			deviceCredential: params.authorizedDeviceCredential,
			identity
		});
		await identity.joinNetwork(ctx);
		await this.identityManager.acceptIdentity(identity, identityRecord, params.deviceProfile);
		await this._initialize(ctx);
		return identity;
	}
	async _checkStorageVersion() {
		await this.metadataStore.load();
		if (this.metadataStore.version !== STORAGE_VERSION) throw new InvalidStorageVersionError(STORAGE_VERSION, this.metadataStore.version);
	}
	/**
	* Opens the identity-bound services once an identity is available.
	*/
	async _initialize(ctx) {
		log("_initialize: start", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 768,
			S: this
		});
		const identity = this.identityManager.identity ?? failUndefined();
		await this.#dataSpaceManager.open(ctx);
		log("_initialize: DataSpaceManager opened", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 772,
			S: this
		});
		await this.#edgeAgentManager.open(ctx);
		log("_initialize: EdgeAgentManager opened", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 775,
			S: this
		});
		this.#handlerFactories.set(Invitation.Kind.SPACE, (invitation) => new SpaceInvitationProtocol(this.#dataSpaceManager, this.#signingContextProvider(), this.#keyring, invitation.spaceKey));
		this.#initialized.wake();
		this.#deviceSpaceSync.setIdentity(identity);
		await this.#deviceSpaceSync.open?.(ctx);
	}
	async _setNetworkIdentity(params) {
		try {
			var _usingCtx$1 = _usingCtx();
			log("_setNetworkIdentity: acquiring mutex...", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 794,
				S: this
			});
			_usingCtx$1.u(await this.#edgeIdentityUpdateMutex.acquire());
			log("_setNetworkIdentity: mutex acquired", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 796,
				S: this
			});
			let edgeIdentity;
			const identity = params?.identity;
			if (identity) if (params?.deviceCredential) edgeIdentity = await createChainEdgeIdentity(identity.signer, identity.identityKey, identity.deviceKey, { credential: params.deviceCredential }, []);
			else {
				await warnAfterTimeout(1e4, "Waiting for identity to be ready for edge connection", async () => {
					await identity.ready();
				});
				invariant(identity.deviceCredentialChain, void 0, {
					"~LogMeta": "~LogMeta",
					F: __dxlog_file,
					L: 815,
					S: this,
					A: ["identity.deviceCredentialChain", ""]
				});
				edgeIdentity = await createChainEdgeIdentity(identity.signer, identity.identityKey, identity.deviceKey, identity.deviceCredentialChain, []);
			}
			else edgeIdentity = await createEphemeralEdgeIdentity();
			this.#edgeConnection?.setIdentity(edgeIdentity);
			this.#edgeHttpClient?.setIdentity(edgeIdentity);
			this.networkManager.setPeerInfo({
				identityDid: edgeIdentity.identityDid,
				peerKey: edgeIdentity.peerKey
			});
			log("_setNetworkIdentity: done", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 835,
				S: this
			});
		} catch (_) {
			_usingCtx$1.e = _;
		} finally {
			_usingCtx$1.d();
		}
	}
	/**
	* Open lifecycle stages over the resolved stack components (formerly ServiceContext._open).
	*/
	async _openStack(ctx) {
		log("running storage migrations...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 842,
			S: this
		});
		await RuntimeProvider.runPromise(this.#runtime)(this.#storageMigrate);
		await this._checkStorageVersion();
		log("running sqlite health check...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 847,
			S: this
		});
		await runSqliteHealthCheck(this.#runtime);
		log("sqlite health check passed", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 849,
			S: this
		});
		log("opening identityManager...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 851,
			S: this
		});
		await this.#identityManager.open(ctx);
		log("identityManager opened", { hasIdentity: !!this.#identityManager.identity }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 853,
			S: this
		});
		log("setting network identity...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 855,
			S: this
		});
		await this._setNetworkIdentity({ identity: this.#identityManager.identity });
		log("opening edge connection...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 858,
			S: this
		});
		await this.#edgeConnection?.open(ctx);
		log("opening signal manager...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 861,
			S: this
		});
		await this.#signalManager.open(ctx);
		log("opening network manager...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 864,
			S: this
		});
		await this.#networkManager.open();
		if (this.#meshReplicator) {
			log("adding mesh replicator...", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 869,
				S: this
			});
			await this.#echoHost.addReplicator(ctx, this.#meshReplicator);
		}
		if (this.#echoEdgeReplicator) {
			log("adding edge replicator...", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 873,
				S: this
			});
			await this.#echoHost.addReplicator(ctx, this.#echoEdgeReplicator);
		}
		log("loading metadata store...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 877,
			S: this
		});
		await this.#metadataStore.load();
		log("opening space manager...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 880,
			S: this
		});
		await this.#spaceManager.open();
		if (this.#identityManager.identity) {
			log("joining network...", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 884,
				S: this
			});
			await this.#identityManager.identity.joinNetwork(ctx);
			log("initializing spaces...", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 887,
				S: this
			});
			await this._initialize(ctx);
		} else log("no identity, skipping network join and space initialization", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 890,
			S: this
		});
		log("opening feed syncer...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 893,
			S: this
		});
		await this.#feedSyncer?.open(ctx);
		log("loading persistent invitations...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 896,
			S: this
		});
		log("loaded persistent invitations", { count: (await this.#invitationsManager.loadPersistentInvitations(ctx)).invitations?.length }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 898,
			S: this
		});
		log("stack opened", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 900,
			S: this
		});
	}
	/**
	* Close lifecycle stages (formerly ServiceContext._close).
	*/
	async _closeStack(ctx) {
		log("closing stack...", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 907,
			S: this
		});
		await this.#feedSyncer?.close();
		await this.#deviceSpaceSync?.close?.();
		await this.#dataSpaceManager?.close(ctx);
		await this.#edgeAgentManager?.close();
		await this.#identityManager?.close(ctx);
		await this.#spaceManager?.close();
		await this.#networkManager?.close(ctx);
		await this.#signalManager?.close();
		await this.#edgeConnection?.close();
		await this.#feedStore?.close();
		await this.#metadataStore?.close();
		log("stack closed", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 921,
			S: this
		});
	}
};
__decorate([synchronized, trace.span()], ClientServicesHost.prototype, "open", null);
__decorate([synchronized, trace.span()], ClientServicesHost.prototype, "close", null);
__decorate([trace.span()], ClientServicesHost.prototype, "_initialize", null);
/**
* Context tag for the {@link ClientServicesHost}. The host provides itself under this tag when it
* builds its component stack, so client RPC handler layers can resolve the orchestration entry
* points (`createIdentity`, readiness gates, …) they need.
*/
var ClientServicesHostService = class extends EffectContext.Tag("@dxos/client-services/ClientServicesHost")() {};
/**
* Layer that constructs a {@link ClientServicesHost} from its props and exposes it under
* {@link ClientServicesHostService}. Host lifecycle (`open` / `close`) stays caller-driven.
*/
var layerClientServicesHost = (props) => Layer.sync(ClientServicesHostService, () => new ClientServicesHost(props));
//#endregion
//#region src/packlets/services/client-services-layer.ts
var identityServiceLayer = Layer.scoped(IdentityService.Tag, Effect.gen(function* () {
	const identityManager = yield* IdentityManagerService;
	const recoveryManager = yield* EdgeIdentityRecoveryManagerService;
	const keyring = yield* KeyringApiService;
	const host = yield* ClientServicesHostService;
	const service = new IdentityServiceImpl(identityManager, recoveryManager, keyring, async (params, ctx) => {
		const identity = await host.createIdentity(params, ctx);
		await host.initialized.wait();
		return identity;
	}, (profile) => host.broadcastProfileUpdate(profile));
	yield* Effect.acquireRelease(Effect.promise(() => service.open()), () => Effect.promise(() => service.close()));
	return service;
}));
var contactsServiceLayer = Layer.effect(ContactsService.Tag, Effect.gen(function* () {
	const identityManager = yield* IdentityManagerService;
	const spaceManager = yield* SpaceManagerService;
	const host = yield* ClientServicesHostService;
	return new ContactsServiceImpl(identityManager, spaceManager, () => host.whenDataSpaceManagerReady());
}));
var invitationsServiceLayer = Layer.effect(InvitationsService.Tag, Effect.map(InvitationsManagerService, (invitationsManager) => new InvitationsServiceImpl(invitationsManager)));
var devicesServiceLayer = Layer.effect(DevicesService.Tag, Effect.gen(function* () {
	return new DevicesServiceImpl(yield* IdentityManagerService, Option.getOrUndefined(yield* Effect.serviceOption(EdgeConnectionService)));
}));
var spacesServiceLayer = Layer.effect(SpacesService.Tag, Effect.gen(function* () {
	const identityManager = yield* IdentityManagerService;
	const spaceManager = yield* SpaceManagerService;
	const echoHost = yield* EchoHostService;
	const host = yield* ClientServicesHostService;
	return new SpacesServiceImpl(identityManager, spaceManager, echoHost, () => host.whenDataSpaceManagerReady());
}));
var networkServiceLayer = Layer.effect(NetworkService.Tag, Effect.gen(function* () {
	return new NetworkServiceImpl(yield* SwarmNetworkManagerService, yield* SignalManagerService, Option.getOrUndefined(yield* Effect.serviceOption(EdgeConnectionService)));
}));
var edgeAgentServiceLayer = Layer.effect(EdgeAgentService.Tag, Effect.gen(function* () {
	const edgeConnection = Option.getOrUndefined(yield* Effect.serviceOption(EdgeConnectionService));
	const host = yield* ClientServicesHostService;
	return new EdgeAgentServiceImpl(() => host.whenEdgeAgentManagerReady(), edgeConnection);
}));
var dataServiceLayer = Layer.effect(DataService.Tag, Effect.map(EchoHostService, (echoHost) => echoHost.dataService));
var queryServiceLayer = Layer.effect(QueryService.Tag, Effect.map(EchoHostService, (echoHost) => echoHost.queryService));
var feedServiceLayer = Layer.effect(FeedService.Tag, Effect.map(EchoHostService, (echoHost) => echoHost.feedService));
/**
* Composes every client RPC service handler on top of the component tags exposed by the stack.
* Each handler keeps its own tag so callers resolve them individually from the stack runtime.
*/
var ClientServicesRpcLayer = Layer.mergeAll(identityServiceLayer, contactsServiceLayer, invitationsServiceLayer, devicesServiceLayer, spacesServiceLayer, networkServiceLayer, edgeAgentServiceLayer, dataServiceLayer, queryServiceLayer, feedServiceLayer);
//#endregion
export { CredentialServerExtension as $, orderObjJsonFields as A, subscribeToSwarmInfo as At, SigningContextProviderService as B, IdentityProviderService as C, DevtoolsHostEvents as Ct, SpaceArchiveWriter as D, subscribeToNetworkStatus as Dt, SpacesServiceImpl as E, getNetworkPeers as Et, detectSpaceArchiveFormat as F, SpaceManagerLayer as G, DataSpace as H, DataSpaceManager as I, MOCK_AUTH_PROVIDER as J, SpaceManagerService as K, DataSpaceManagerLayer as L, buildDatabaseDirectoryFromObjects as M, subscribeToFeeds as Mt, objJsonToObjectStructure as N, __exportAll as Nt, extractSpaceArchive as O, subscribeToNetworkTopics as Ot, readSerializedSpaceArchive as P, __reExport as Pt, CredentialRetrieverExtension as Q, DataSpaceManagerService as R, IdentityManagerService as S, createDiagnostics as St, Identity as T, subscribeToSpaces as Tt, EdgeFeedReplicator as U, createSigningContextProvider as V, SpaceManager as W, SpaceProtocol as X, MOCK_AUTH_VERIFIER as Y, SpaceProtocolSession as Z, EdgeAgentManagerService as _, DeviceInvitationProtocol as _t, ServiceContextLayer as a, InvitationsManagerService as at, IdentityManager as b, diagnostics_exports as bt, FeedSyncer as c, IMetadataStoreService as ct, CrossDeviceSpaceSynchronizerLayer as d, SpaceInvitationProtocol as dt, Space as et, CrossDeviceSpaceSynchronizerService as f, InvitationsServiceImpl as ft, EdgeAgentManagerLayer as g, createAdmissionKeypair as gt, EdgeAgentManager as h, InvitationsHandlerService as ht, layerClientServicesHost as i, InvitationsManagerLayer as it, writeSerializedSpaceArchive as j, subscribeToFeedBlocks as jt, objectStructureToObjJson as k, subscribeToSignal as kt, FeedSyncerLayer as l, MetadataStore as lt, EdgeAgentServiceImpl as m, InvitationsHandlerLayer as mt, ClientServicesHost as n, AuthExtension as nt, StorageMigrationService as o, SqliteMetadataStore as ot, createCrossDeviceSpaceSynchronizer as p, InvitationsHandler as pt, AuthStatus as q, ClientServicesHostService as r, InvitationsManager as rt, SqliteStorage as s, SqliteMetadataStoreLayer as st, ClientServicesRpcLayer as t, valueEncoding as tt, FeedSyncerService as u, hasInvitationExpired as ut, locks_exports as v, TrustedKeySetAuthVerifier as vt, identityProviderFromManager as w, DevtoolsServiceImpl as wt, IdentityManagerLayer as x, DiagnosticsCollector as xt, IdentityServiceImpl as y, createAuthProvider as yt, SigningContextProviderLayer as z };

//# sourceMappingURL=chunk-client-services-layer.mjs.map